import React, { useState, useEffect } from "react";
import { useNavigation } from '@react-navigation/native';
import { 
  Alert,
  View, 
  StyleSheet, 
  FlatList, 
  TextInput, 
  TouchableOpacity,
  Image, 
  KeyboardAvoidingView, 
  Keyboard,
  ScrollView,
  Platform,
  Dimensions
 } from "react-native";
import { Image as ImageCache } from "react-native-expo-image-cache";
import { PieChart } from "react-native-chart-kit";
//react-native-chart-kit
//react-native-gifted-charts *mala
import { Video } from 'expo-av';
import { MaterialCommunityIcons, Entypo, Foundation, Feather, AntDesign } from "@expo/vector-icons";
import VideoVisor from "./VideoVisor";
//import { WebView } from 'react-native-webview';
import * as ImagePicker from "expo-image-picker";
import * as ImageManipulator from "expo-image-manipulator";
import * as DocumentPicker from 'expo-document-picker'

//import useAuth from "../auth/useAuth";
import routes from "../navigation/routes";

import dateNow from "../utility/dateNow";
import dateActions from "../utility/dateActions";
import configurationPost from "../config/configurationPost";
import connectionConfig from "../config/settings";      
import Text from "./Text";
import colors from "../config/colors";
import { ListItemSeparator } from "../components/lists";
import CardListTypeActions from "./CardListTypeActions";
import Icon from "./Icon";
import CardListMesures from "./CardListMesures";
import { useContext } from "react";
import AuthContext from "../auth/context";


const webUrl = connectionConfig.imageUrl + '/seedImages/'
var infoDocumetUri =  connectionConfig.imageUrl +'/Documents/'  
var seedVideoUri = connectionConfig.imageUrl + '/Documents/videoSeeds/'
var profileUri =  connectionConfig.imageUrl +'/PerfilDeUsuario/'

var date = dateNow()
var numLikes = 0
var changeListing = true
var statusFollowed = 0
var typeFile = ''
var nameDateDoc = ''
var typeFileImageAndVideo = ''
var nameDateImageAndVideo = ''
var typeActionSelect = ''
var post_documentSeed = ''
var pickerFileRecipient = ''
var newSeedDate = ''
var youtubeIdSelector = ''
var filterDocumentSeed = ''
var mesureSelect = ''


function CardEdit({ 
                type,
                seedDescription, 
                seedId,
                seedName,
                seedPhoto,
                origin,
                //screenApodo,
                imageUrl, 
                onPress, 
                //onPressLike,  12-9-21 Dejó de traerse como parámetro porque los likes se deben de hacer desde aqui en vez de en ListingDetailsSeedScreen. 
                thumbnailUrl,
                videoNumber,
                documentSeed,
                userId,
                seedDate,
                seedOrder,
                setTypeto35,
                setTypeto36,
                setTypeto37,
                itemsRequirements,
                qty,
                mesure,
                unitaryPrice,
                currency,
                userName,
                userPhoto
                }) {


const video =React.useRef(null);
const [status, setStatus] = useState({});
const [ followers, setFollowers ] =  useState(0)  
const [loading, setLoading] = useState(false);
const [ typeBoxText, setTypeBoxText ] = useState('') // para que jale el type
const [ titleBoxText, setTitleBoxText ] =  useState('') // para que jale el comentario
const [ descriptionBoxText, setDescriptionBoxText ] =  useState('') // para que jale el comentario 
const [imageUri, setImageUri] = useState('');
const [ready, setReady] = useState(false); // Hook para que funcione el manipResult de expo-image-manipulator
const [pickerFile, setPickerFile] = useState(null);
const [youtubeLink, setYoutubeLink] = useState(''); // Id de video de youtube extraído del link mediante método onChangeText
const [videoNumberHook, setVideoNumber] = useState(''); // Link de video de youtube 
const [qtyBox, setQtyBox] = useState(String(qty)); // Para poner cantidad en requerimientos y apoyos
const [mesureBox, setMesureBox] = useState(mesure); // Para poner unidad de medida en Reqs. y Apoyos
const [unitPriceBox, setUnitPriceBox] = useState(String(unitaryPrice));  // Para poner precio Unitario en Reqs. y Apoyos
const [currencyBox, setCurrencyBox] = useState(String(currency));  // Para poner tipo de Divisa  en Reqs. y Apoyos
const [itemsSupport, setItemsSupport] = useState([]);


const [progress, setProgress] = useState(0);
const [ menuItems, setMenuItems ] =  useState([]) // para meter la lista del tipo de acciones y desplegaarla en el FlatList de type para su edición.
const [uploadVisible, setUploadVisible] = useState(false);
const [listChooseArrange, setListChooseArrange] = useState(false);
const [keyboardVisible, setKeyboardVisible] = useState(false);
//var keyboardVisible = ''
//const [keyboardStatus, setKeyboardStatus] = useState(undefined);
const [ifShowPriceSub, setIfShowPriceSub] = useState("show")
const [showMesures, setShowMesures] = useState(false);
const [ mesures, setMesures ] =  useState([]) // para meter la lista de las unidades de medida que se pueden utilizar.


const { user } = useContext(AuthContext)

const navigation = useNavigation();
var foundUserChecker = "off"
var dateFormated = dateActions(seedDate)
var filterDocumentSeed = ''  
var  sub = qtyBox * unitPriceBox




useEffect(() => {
  //debugger
    date = dateNow()
    getMesures()  // Para traer la variedad de unidades medidas usadas en el edit de requerimientos (case 40 )
    bringSupportItems()  // Función para traer array de posibles apoyos a cada requerimiento y hacer cuentas.
    getListOfTypeActions() // Para traer las acciones y poder desplegar menu en el campo tipo de accion EditOrigin. 
    setTypeBoxText(String(type))
    setTitleBoxText(seedName)
    setDescriptionBoxText(seedDescription)
    typeActionSelect = type

// Función para detectar cuando se activa y desactiva keyboard.
{
  const showSubscription = Keyboard.addListener('keyboardDidShow',  () => {
  setKeyboardVisible(true)
  //keyboardVisible = true
  console.log('****entre keyboardDidShow (:' , keyboardVisible )
  })
  const hideSubscription = Keyboard.addListener('keyboardDidHide',  () => {
     setKeyboardVisible(false)
     //keyboardVisible = false
  console.log(keyboardVisible, ' entre keyboardDidHide ===== ):')
     })
      return () => {
       showSubscription.remove();
       hideSubscription.remove();
     };
}
  }, [seedId, type]); //[seedId, type]

origin = origin



// Para hacer que en el type 34 aparezca  
if(documentSeed === "Poner documento"){
  filterDocumentSeed = ''
} else {
filterDocumentSeed = documentSeed
}


//--------------------------------------------------
//  Select Image es la función que te permite sacar
//  la biblioteca de imagenes de tu Cel 
//--------------------------------------------------
const selectImage = async () => {
  try {
    const result = await ImagePicker.launchImageLibraryAsync({
      mediaTypes: ImagePicker.MediaTypeOptions.All,
      allowsEditing: true,
      aspect: [4, 3],
      quality: 0.5,
    })
    console.log("Este es el result de imagen: ", result)
    if(!result.cancelled)
    setImageUri(result.uri)
    console.log("imageUri del selectimage ", imageUri)
  } catch (error) {
     console.log("error al leer imagen", error) 
  }
}

const alertEditRequirement = async () => {
  Alert.alert(
    "Algunas imágenes pueden tardar de 10 a 15 minutos en actualizarse :)",
  [{ text: "OK", onPress: () => updateInfo() }]
    );
}

//---------------------------------------------
// Función para traer el seedId
//---------------------------------------------
const updateInfo = async () => {
  debugger
  setLoading(true)
 //setProgress(0.3);
   //Valida el tipo de archivo que se eligio 
   if (pickerFile != null) {
     if (pickerFile.name.includes('.pdf')) {
       typeFile = 'application/pdf'
       nameDateDoc = JSON.parse(user).userId + '_' + date.replace(/ /g, '_').replace(/\//g, '-') + '_GenerateSeed.pdf'
     }
     if (pickerFile.name.includes('.avi')) {
       typeFile = 'video/x-msvideo'
       nameDateDoc = JSON.parse(user).userId + '_' + date.replace(/ /g, '_').replace(/\//g, '-') + '_GenerateSeed.avi'
     }
     if (pickerFile.name.includes('.mp4')) {
       typeFile = 'application/mp4'
       nameDateDoc = JSON.parse(user).userId + '_' + date.replace(/ /g, '_').replace(/\//g, '-') + '_GenerateSeed.mp4'
     }
     if (pickerFile.name.includes('.mov')) {
       typeFile = 'video/quicktime'
       nameDateDoc = JSON.parse(user).userId + '_' + date.replace(/ /g, '_').replace(/\//g, '-') + '_GenerateSeed.mov'
     }
     if (pickerFile.name.includes('.jpg')) {
       typeFile = 'image/jpeg'
       nameDateDoc = JSON.parse(user).userId + '_' + date.replace(/ /g, '_').replace(/\//g, '-') + '_GenerateSeed.jpg'
     }
     if (pickerFile.name.includes('.png')) {
       typeFile = 'image/png'
       nameDateDoc = JSON.parse(user).userId + '_' + date.replace(/ /g, '_').replace(/\//g, '-') + '_GenerateSeed.png'
     }
     if (pickerFile.name.includes('.xls')) {
       typeFile = 'application/vnd.ms-excel'
       nameDateDoc = JSON.parse(user).userId + '_' + date.replace(/ /g, '_').replace(/\//g, '-') + '_GenerateSeed.xls'
     }
     if (pickerFile.name.includes('.xlsx')) {
       typeFile = 'application/xlsx'
       nameDateDoc = JSON.parse(user).userId + '_' + date.replace(/ /g, '_').replace(/\//g, '-') + '_GenerateSeed.xlsx'
     } 
   }
   //Valida si es imagen o video lo que se eligio
   if (imageUri != '') {
     if (imageUri.includes('.jpg')) {
       typeFileImageAndVideo = 'image/jpeg'
       nameDateImageAndVideo = JSON.parse(user).userId + '_' + date.replace(/ /g, '_').replace(/\//g, '-') + '_GenerateSeed.jpg'
     }
     if (imageUri.includes('.png')) {
       typeFileImageAndVideo = 'image/png'
       nameDateImageAndVideo = JSON.parse(user).userId + '_' + date.replace(/ /g, '_').replace(/\//g, '-') + '_GenerateSeed.png'
     }
     if (imageUri.includes('.mp4')) {
       typeFileImageAndVideo = 'application/mp4'
       nameDateImageAndVideo = JSON.parse(user).userId + '_' + date.replace(/ /g, '_').replace(/\//g, '-') + '_GenerateSeed.mp4'
     }
     if (imageUri.includes('.mov')) {
       typeFileImageAndVideo = 'video/quicktime'
       nameDateImageAndVideo = JSON.parse(user).userId + '_' + date.replace(/ /g, '_').replace(/\//g, '-') + '_GenerateSeed.mov'
     }
   }

// Con esta variable post_documentSeed se logra que el usuario al actualizar no pase 
// un documento vacío que planche lo que tenía antes.
if(nameDateDoc === ''){ 
  post_documentSeed = documentSeed
 }else{
  post_documentSeed = nameDateDoc}  

 var post_values = {}
 if(nameDateImageAndVideo === ''){
 post_values =
  {
    type             : typeActionSelect,
    seedName         : titleBoxText,
    seedDescription  : descriptionBoxText,
    seedPhoto        : seedPhoto,
    seedId           : seedId,
    origin           : origin,
    documentSeed     : post_documentSeed,         //nameDateDoc,
    youtubeId        : youtubeIdSelector,         //videoNumber
    //userId           : JSON.parse(user).userId,
    qty              : qtyBox,   // Para fucionabilidad de componentes requirement: 39, 40, 41
    mesure           : mesureBox,  // Para fucionabilidad de componentes requirement: 39, 40, 41
    unitaryPrice     : unitPriceBox,  // Para fucionabilidad de componentes requirement: 39, 40, 41
    sub              : sub,    // Para fucionabilidad de componentes requirement: 39, 40, 41
  }
} else {
  post_values =
  {
    type             : typeActionSelect,
    seedName         : titleBoxText,
    seedDescription  : descriptionBoxText,
    seedPhoto        : nameDateImageAndVideo,
    seedId           : seedId,
    origin           : origin,
    documentSeed     : post_documentSeed,         //nameDateDoc,
    youtubeId        : youtubeIdSelector,         //videoNumber
    //userId           : JSON.parse(user).userId,
    qty              : qtyBox,      // Para fucionabilidad de componentes requirement: 39, 40, 41
    mesure           : mesureBox,  // Para fucionabilidad de componentes requirement: 39, 40, 41
    unitaryPrice     : unitPriceBox,  // Para fucionabilidad de componentes requirement: 39, 40, 41
    sub              : sub,      // Para fucionabilidad de componentes requirement: 39, 40, 41
  }
}

 
   configurationPost.body = JSON.stringify(post_values)
   await fetch(connectionConfig.apiUrl+'/UpdateSeedActionContent/', configurationPost)
   .then(response => response.json())
   .then(response => {
     console.log( {response} + "Listing despues de post GenerateActionId")

     if (imageUri != '') {
       savePhoto()
     }
     if (pickerFile != null) {
       saveMultiple()
     }
     
     if( typeActionSelect < 33 ) {
     setTimeout(function(){ selectAddedAction(); }, 500); 
    } else if(typeActionSelect === 40) {
      setTimeout(function(){ selectAddedAction40(); }, 500); 
    } 
    else {
      //navigation.goBack()
      setTimeout(function(){ navigation.goBack(); }, 2000)
    }
     
  
   })
   .catch(err =>{
     console.log('update fixo failed :( review internet service /UpdateSeedActionContent/', err )
   })
};


//--------------------------------------------- 
//Rutina para guardar una foto o video
//---------------------------------------------
const savePhoto = async () => {
  let format = 'JPEG'
  let quality = 0.1
 //debugger
  try {
    const formData = new FormData()
    if (typeFileImageAndVideo === 'image/jpeg' ) {
      const manipResult = await ImageManipulator.manipulateAsync( 
        imageUri,
        [],
        { compress: quality, format: ImageManipulator.SaveFormat.JPEG })
      formData.append('photoAndVideo', {
        uri: manipResult.uri,
        type: typeFileImageAndVideo,
        name: nameDateImageAndVideo,
      })
    }
    if (typeFileImageAndVideo === 'image/png') {
      const manipResult = await ImageManipulator.manipulateAsync( 
        imageUri,
        [],
        { compress: quality, format: ImageManipulator.SaveFormat.JPEG })
      formData.append('photoAndVideo', {
        uri: manipResult.uri,
        type: typeFileImageAndVideo,
        name: nameDateImageAndVideo,
      })
    }
    if (typeFileImageAndVideo === 'application/mp4') {
      formData.append('photoAndVideo', {
        uri: imageUri,
        type: typeFileImageAndVideo,
        name: nameDateImageAndVideo,
      })
    }
    if (typeFileImageAndVideo === 'video/quicktime') {
      formData.append('photoAndVideo', {
        uri: imageUri,
        type: typeFileImageAndVideo,
        name: nameDateImageAndVideo,
      })
    }
    const configurationPost = {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'multipart/form-data'
      },
      body: formData
    }
    // post Para guardar imagen de perfil
    fetch(connectionConfig.apiUrl + '/upload_infoPhotoAndVideo', configurationPost)
      .then(response => response.json())
      .then(response => {
        //debugger
        //setProgress(0.8)
        nameDateImageAndVideo = ''
        setImageUri('')
        //pathSelect()

        if (response.data === 'descarga-> error') {
          console.log("maintennance server descarga-> error /upload_infoPhotoAndVideo")
        }
      })
      .catch((err) => {
        console.log("maintennance server -> catch /upload_infoPhotoAndVideo", err)
      })
  } catch (error) {
    console.log("maintennance server -> catch Final /upload_infoPhotoAndVideo", error)
  }
}

 
//---------------------------------------------
//   Rutina que guarda el document de la info 
//  (Esta función es llamada para guardar el 
//     documento seleccionado en una carpeta 
//              en el servidor).
//---------------------------------------------
const saveMultiple = async () => {
  //debugger
  try {      
    const formData = new FormData()
    formData.append('multiservice',{
      uri:  pickerFile.uri,
      type: typeFile,
      name: nameDateDoc,
    })
    console.log("typeFile -> ", typeFile,"nameDateDoc ->", nameDateDoc  )
    const configurationPost = {
      method :'POST',
      headers:{
        'Accept': 'application/json',
        'Content-Type':'multipart/form-data'
      },
      body:formData
    }
   // post Para guardar imagen de perfil
    fetch(connectionConfig.apiUrl + '/upload_Documents', configurationPost)
    .then(response => response.json())
    .then(response => {
      //debugger
      setProgress(1)
      setPickerFile(null)
      filterDocumentSeed = '';
      if(response.data === 'descarga-> error'){
        console.log("maintennance server /upload_Documents descarga-> error")   
      }
    })
    .catch((err) => {
      console.log( "maintennance server -> catch /upload_Documents ", err)   
    })
  } catch (error) {
    console.log( "maintennance server -> catch Final /upload_Documents ", error)   
  }
}


//----------------------------------------------------------------------------
//Servicio para buscar un navegador de archivos del celular para buscar un pdf 
//----------------------------------------------------------------------------
const uploadDocument = async () => {
  var options = {
    type: 'image/png'
  }
  if (Platform.OS === 'android') {
 
    options = {
      copyToCacheDirectory: true,
      multiple: false
    }
  } else {
    options = {
      copyToCacheDirectory : true,
      multiple: false
    }
  }
  try {
    if (Platform.OS === 'android') {
      await DocumentPicker.getDocumentAsync(options)
      .then(res => {
       // debugger
       if (res.type === 'cancel') {
        setPickerFile(null);
 
       } else {
        setPickerFile(res);
        filterDocumentSeed = '';
        navigation.navigate(CARD_EDIT)
       }
        //console.log('res : ' + JSON.stringify(res));
        //console.log('User cancelled file picker->', res);
        //console.log(res.uri, res.type, res.name, res.size)
        
      })
    } else {
      await DocumentPicker.getDocumentAsync(options)
      .then(res => {
       // debugger
       if (res.type === 'cancel') {
        setPickerFile(null);
 
       } else {
        setPickerFile(res);
       }
        console.log('res : ' + JSON.stringify(res));
        console.log('User cancelled file picker->', res);
        console.log(res.uri, res.type, res.name, res.size)
 
      }) 
    }
  } catch (err) {
    setPickerFile(null);
   
      alert('Unknown Error: ' + JSON.stringify(err));
      throw err;
  }
 }
 


//------------------------------------------------------------
//  Función encadenada para traer la info de la nueva acción. 
//------------------------------------------------------------
const selectAddedAction = async () => {
  console.log("Entre a función selectedAddedAction")
  var post_values = {
    //seedId: seedId
    seedId: seedId 
   }
  configurationPost.body = JSON.stringify(post_values)
  await fetch(connectionConfig.apiUrl+'/selectActionFromFlatlist/', configurationPost)
  .then(response => response.json())
  .then(response => {
   //debugger
   //var item = []
   var item = response     //response.data
   console.log("Entre a función selectedAddedAction y response es ", response)

   setLoading(false)
   //setListing(response.data)
   changeListing = true
   var screen = 'ActionScreen'
   navigation.navigate(routes.SEED_DETAILS, { item, screen, changeListing } ) 
  })
  .catch(err =>{
  console.log(':( review internet service /selectActionFromFlatlist/', err )
  })
}


//---------------------------------------------------------------------------
//  Función encadenada para refrescar CardComponent para componente 40 y 41.  
//---------------------------------------------------------------------------
const selectAddedAction40 = async () => {
  changeListing = true,
    screen = 'ListingsSeedsScreen'
   navigation.navigate(routes.LISTINGS_SEEDS ) // Como no se actualizan los requerimientos si te ... 
   // ... ibas a SEED.DETAILSya que CardComponent se actualiza con seedId y Type entonces mejor...
   // ... lo mandé de regreso a LISTINGS_SEEDS para que a fuercitas de deba actualizar.
   //navigation.navigate(routes.SEED_DETAILS, { screen, changeListing, seedId, origin } ) // Este...
   // ...es el navigation que tenía antes.
   Alert.alert("Listo, para terminar de actualizar te regresaremos al Listing! Una disculpa por las vueltas! :)");

}


//---------------------------------------------------------------------------
// Función para traer las unidades de medida utilizadas en el campo unidad  
// del edit de requerimientos.
//---------------------------------------------------------------------------
const getMesures = async () => {
  //debugger
  //console.log("entre a getMesures :)  :)  :)")
   await fetch(connectionConfig.apiUrl+'/getMesures/', configurationPost)
     .then(response => response.json())
     .then(response => {
      var res = response.data
      //var transformToArray = res.filter(res => res.mesureStatus > 0)
      //console.log("response.data en getMesures ", transformToArray)
      setMesures(res)
     } )
     .catch(err =>{
          console.log('getMesures /getMesures/ failed :( review internet service)', err )
     })  
}



//-----------------------------------------------------------------------
// Función para traer el tipo de acciones por si el usuario desea cambiar
// la acción que escogerá en el FlatList.
//-----------------------------------------------------------------------
const getListOfTypeActions = async () => {
  //debugger
   await fetch(connectionConfig.apiUrl+'/getSeedsType/', configurationPost)
     .then(response => response.json())
     .then(response => {
      var result = response.data 
      var skipSeedType = result.filter(result => result.typeNum > 0)
      setMenuItems(skipSeedType)
      //console.log("skipSeed ", skipSeedType)
     } )
     .catch(err =>{
          console.log('getListOfTypeActions /getSeedsType/ failed :( review internet service)', err )
     })  
}

//-----------------------------------------------------------------------
//  Operación para ver si es null o no el campo temporal para archivos
//  y asi poder visualizarlos. En caso de que sea pdf o xlxs o xlx
//  nos deja dicho que es para poder renderizarlo en el return.
//-----------------------------------------------------------------------
if(pickerFile === null ){    //|| pickerFile.name.includes('.xlsx'
  pickerFileRecipient = 'nothing'
}
if(pickerFile !== null ){    //|| pickerFile.name.includes('.xlsx'
  pickerFileRecipient = 'something'
}            


//---------------------------------------------------------------------
//  Empiezan operaciones para cambiar número de Type de 35 a 36 o 37
//  y así hacer el arreglo correspondiente de la imagen.
//---------------------------------------------------------------------
const selectingArrangeImage = async (typeActionSelect) => {
if(typeActionSelect === 35) { 
  type = 35 
  setTypeto35here()
  } else if(typeActionSelect === 36) {
  type = 36
  setTypeto36here()
  } else {
  type = 37
  setTypeto37here()
    }
  console.log("type en Arrange ", type)
  setListChooseArrange(false)
}
//------------------------------------------------------------------------------------------
// Funciones que invocan la funciones setTypeto35-37 via props desde ActionEditScreen 
//------------------------------------------------------------------------------------------
const setTypeto35here = async () => { setTypeto35() }
const setTypeto36here = async () => { setTypeto36() }
const setTypeto37here = async () => { setTypeto37() }


// Este arreglo es para las opciones del Flat List para acomodo
// de la imagen en el contenido 35.
const menuArrangePhotosComponent35 = [
  {
    typeActionsId   :  35,
    title           :  "Imagen al centro",
    iconFamily      :   "MaterialCommunityIcons",
    icon            :   "set-center",
    background      :   "CardEditListaComponentes35y36y37",
    backgroundColor :   colors.black
  },
  {
    typeActionsId   :  36,
    title           :  "Imagen a la derecha",
    iconFamily      :   "MaterialCommunityIcons",
    icon            :   "set-right",
    background      :   "CardEditListaComponentes35y36y37",
    backgroundColor :   colors.black
  },
  {
    typeActionsId   :  37,
    title           :  "Imagen a la izquierda",
    iconFamily      :   "MaterialCommunityIcons",
    icon            :   "set-left",
    background      :   "CardEditListaComponentes35y36y37",
    backgroundColor :   colors.black
  }
]

const menuMesures = [
  {
    mesureId        :   1,
    description     :  "pieza",
    backgroundColor :   "white"
  },
  {
    mesureId        :   2,
    description     :  "servicio",
    backgroundColor :   "white"
  },
  {
    mesureId        :   3,
    description     :  "toneladas",
    backgroundColor :   "white"
  }
]


//----------------------------------------------------------
//   Función para seleccionar de donde tomar id de youtube
//----------------------------------------------------------
if (videoNumberHook === ''){
  youtubeIdSelector = videoNumber
}else{
  youtubeIdSelector = videoNumberHook
}
 
//-------------------------------------------------------
//   Función para extraer el Id del link de Youtube
//-------------------------------------------------------
// "https://www.youtube.com/watch?v=WWzEK7NLi74youTubeUrl"
//  const videoNumber = ("WWzEK7NLi74");
const onChangeText = async () => {
  //setYoutubeLink(videoNumber)
  setYoutubeLink(youtubeIdSelector)

  console.log(youtubeLink)

     try {
       let re = /^(https?:\/\/)?((www\.)?(youtube(-nocookie)?|youtube.googleapis)\.com.*(v\/|v=|vi=|vi\/|e\/|embed\/|user\/.*\/u\/\d+\/)|youtu\.be\/)([_0-9a-z-]+)/i;
       const id = youtubeLink.match(re)[7];
       setVideoNumber(id)
       console.log(id)
       //console.log(videoNumber)
       console.log(videoNumberHook)
       //if(!id === '')
       //setVideoNumber(id)
       //console.log(videoNumber)
     } catch (error) {
       console.log("error en el link de Youtube", error) 
     }
} 

//----------------------------------------------------------
//   Función para seleccionar de donde tomar id de youtube
//----------------------------------------------------------
if (videoNumberHook === ''){
  youtubeIdSelector = videoNumber
}else{
  youtubeIdSelector = videoNumberHook
}


//******************************************************************************************
//     Empieza sección para ver apoyos de cada requerimiento para renderizar en case "r"
//******************************************************************************************
const bringSupportItems = async () => {

  var post_values = {
   origin: seedId,  // Lleva el seedId en origin para que busque los renglones de requerimientos.
   type: 41  //type40
}
configurationPost.body = JSON.stringify(post_values) 

//await fetch(connectionConfig.apiUrl+'/selectRequirementActions/', configurationPost)
await fetch(connectionConfig.apiUrl+'/SelectSupportActions/', configurationPost)

     .then(response => response.json())
     .then(response => {
      setItemsSupport(response)
     } )
     .catch(err =>{
          console.log('bringRequirementItems /selectRequirementActions/ failed :( review internet service)', err )
     })

  }

// ********** Código para sumar los items de cada apoyo de un requerimiento **************
  var qtySupports = (itemsSupport.length) // Este en particular es para sacar los apoyos de un requerimiento en particular.
  var sumSupports = ''
  sumSupports = itemsSupport.map((element) => (element.qty) ); 
  var totalSupports = 0
//totalSupports = sumSupports.reduce(function(a, b){ return a + b, 0 }) // Esta forma antigua de escribir js no le gusta a recat native
  totalSupports = sumSupports.reduce((a, b) => a + b, 0 ); // Con esta forma nueva si la reconoce react native :)
  var requirementsToFulfill = 0    // Requerimeintos por completar
  requirementsToFulfill = (qty - totalSupports)     

  var percentageSuccess = 0       // Porcentaje de requerimientos completados 
  percentageSuccess = (totalSupports/qty)*100

  if(percentageSuccess === 0){    // Ifeo para meterle sólo dos decimales al resultado (si es distinto de cero)
    percentageSuccess
  } else{
  percentageSuccess = percentageSuccess.toFixed(2)  // Método en si para ponerle decimales (dos) 
  }
  var qtyItemsRequirements = ''
  if (itemsRequirements === undefined) {
    itemsRequirements = ''
  } else {
    (itemsRequirements.length) } // Esto nos da la cantidad de items en el array de requerimientos 39

// ********** Función para ir a editar requerimiento ******************
const editRequirement = async () => {
   var screen = 'ChooseTypeContent'
   console.log("seedId ", seedId)
   navigation.navigate(routes.ACTION_EDIT_SCREEN, { seedId, screen } ) 
  //navigation.navigate(routes.ACTION_EDIT_SCREEN, { type, seedId, origin, foundUserChecker, changeListing, seedDate, seedOrder, seedPhoto, screen, itemsRequirements } ) 
}

//********** Datos para la gráfica de requerimientos **********
const pieData = [
    { value: totalSupports, 
      color: '#35AB20', 
      name: 'Progreso', 
      legendFontSize: 15,
      legendFontColor: '#7F7F7F'
    },
    {
      value: requirementsToFulfill,
       color: 'lightgray', 
       name: 'Pendiente',  
       legendFontSize: 15, 
       legendFontColor: '#7F7F7F'
    }
];
//**************************************************************

//Función que se encarga de hacer la gráfica de pie
const MyPieChart = () => {
  return (
    <>
      <PieChart        
         data={pieData}
          chartConfig={{
          backgroundColor: '#1cc910',
          backgroundGradientFrom: '#eff3ff',
          backgroundGradientTo: '#efefef',
          decimalPlaces: 2,
          color: (opacity = 1) => `rgba(0, 0, 0, ${opacity})`,
          style: {
            //borderRadius: 16,
            width:200,
             height:200
           // margin:2
          },
        }}
        //estilos que impactan la gráfica por fuera
        style={{
          marginVertical: 8,
         marginLeft:100,
 
          borderRadius: 16,
        }}
        accessor="value"
        backgroundColor="transparent"
        padding="15"
        paddingLeft='40'
        width={500}
        height={200}
        //absolute //for the absolute number remove if you want percentage
      />
    </>
  );
};

switch (type) {

  // S E E D  <===  Semilla
    case 0:   
      return (
        <View >
              <View style={ typeActionSelect === 0 ? styles.seedTitle :
                            typeActionSelect === 1 ? styles.seedTitle1 :
                            typeActionSelect === 2 ? styles.seedTitle2 :
                            typeActionSelect === 3 ? styles.seedTitle3 :
                            typeActionSelect === 4 ? styles.seedTitle4 :
                            typeActionSelect === 5 ? styles.seedTitle5 :
                            typeActionSelect === 6 ? styles.seedTitle6 :
                            typeActionSelect === 7 ? styles.seedTitle7 :
                            typeActionSelect === 8 ? styles.seedTitle8 :
                            styles.seedTitle9
                             }>

                            {
                              uploadVisible === true ?
                              <View style={typeActionSelect === 1 ? styles.ViewflatlistTypeAction1:
                                           typeActionSelect === 2 ? styles.ViewflatlistTypeAction2:
                                           typeActionSelect === 3 ? styles.ViewflatlistTypeAction3:
                                           typeActionSelect === 4 ? styles.ViewflatlistTypeAction4:
                                           typeActionSelect === 5 ? styles.ViewflatlistTypeAction5:
                                           typeActionSelect === 6 ? styles.ViewflatlistTypeAction6:
                                           typeActionSelect === 7 ? styles.ViewflatlistTypeAction7:
                                           typeActionSelect === 8 ? styles.ViewflatlistTypeAction8:
                                           styles.ViewflatlistTypeAction9
                              }>
                              <FlatList
                                data={menuItems}
                                keyExtractor={(menuItem) => menuItem.typeActionsId.toString()}
                                ItemSeparatorComponent={ListItemSeparator}
                                renderItem={({ item, index }) => (
                                  <CardListTypeActions
                                    title ={item.typeActionsDesc}
                                    IconComponent={
                                      <Icon
                                        iconFamily={item.iconFamily}
                                        name={item.icon}
                                        size ={35}      //{item.size}
                                        backgroundColor={item.backgroundColor}
                                      />
                                    }
                                    onPress={() =>{ 
                                      typeActionSelect = menuItems[index].typeNum
                                      console.log("typeActionSelect==> ", typeActionSelect)
                                      setUploadVisible(false)
                                    }}
                                  />
                                )}
                              />
                              <Text style={styles.Cancel}
                              onPress={() =>{ 
                                setUploadVisible(false)
                              }}>Cancel</Text>
                              </View>
                              :
                              null
                            } 

                            <Text style={styles.titleSeedDate} > Creada el:  { seedDate } </Text>
             
                            {
                            typeActionSelect === 0 ?   <Text style={styles.titleSeedSeed} >Tipo de Acción: Semilla </Text>:
                            typeActionSelect === 1 ?   <Text style={styles.titleSeed} 
                                                onPress={() => {
                                                  uploadVisible === false ?
                                                    setUploadVisible(true)
                                                    :
                                                    setUploadVisible(false)
                                                }}
                                           >Tipo de Acción: Información </Text>:                            
                            typeActionSelect === 2 ?   <Text style={styles.titleSeed} 
                                                onPress={() => {
                                                  uploadVisible === false ?
                                                    setUploadVisible(true)
                                                    :
                                                    setUploadVisible(false)
                                                }}
                                           >Tipo de Acción: Idea { typeActionSelect}</Text>:                            
                            typeActionSelect === 3 ?   <Text style={styles.titleSeed} 
                                                onPress={() => {
                                                  uploadVisible === false ?
                                                    setUploadVisible(true)
                                                    :
                                                    setUploadVisible(false)
                                                }}
                                                >Tipo de Acción: Plan { typeActionSelect}</Text>:
                            typeActionSelect === 4 ?   <Text style={styles.titleSeed} 
                                                onPress={() => {
                                                  uploadVisible === false ?
                                                    setUploadVisible(true)
                                                    :
                                                    setUploadVisible(false)
                                                }}
                                                >Tipo de Acción: Realizar { typeActionSelect}</Text>:
                            typeActionSelect === 5 ?   <Text style={styles.titleSeed}
                                                onPress={() => {
                                                  uploadVisible === false ?
                                                    setUploadVisible(true)
                                                    :
                                                    setUploadVisible(false)
                                                }}
                                                >Tipo de Acción: Invitar { typeActionSelect}</Text>:
                            typeActionSelect === 6 ?   <Text style={styles.titleSeed} 
                                                onPress={() => {
                                                  uploadVisible === false ?
                                                    setUploadVisible(true)
                                                    :
                                                    setUploadVisible(false)
                                                }}
                                                >Tipo de Acción: Disfrutar { typeActionSelect}</Text>:
                            typeActionSelect === 7 ?   <Text style={styles.titleSeed} 
                                                onPress={() => {
                                                  uploadVisible === false ?
                                                    setUploadVisible(true)
                                                    :
                                                    setUploadVisible(false)
                                                }}
                                                >Tipo de Acción: Rama { typeActionSelect}</Text>:
                            typeActionSelect === 8 ?   <Text style={styles.titleSeed} 
                                                onPress={() => {
                                                  uploadVisible === false ?
                                                    setUploadVisible(true)
                                                    :
                                                    setUploadVisible(false)
                                                }}
                                                >Tipo de Acción: Requerimiento { typeActionSelect}</Text>:
                              <Text style={styles.titleSeed} 
                                                onPress={() => {
                                                  uploadVisible === false ?
                                                    setUploadVisible(true)
                                                    :
                                                    setUploadVisible(false)
                                                }}
                                                >Tipo de Acción: Donar </Text> 
                             }
                             
                  { 
                    changeListing ?   
                    <View>   
                    <TextInput style={styles.inputName}
                                      onChangeText = {text => setTitleBoxText(text)}
                                      value = {titleBoxText}
                                      multiline = {true}
                                      /> 
                   </View>
                   :
                   <View>
               {/* Prueba con filtroListing sábado 7 agosto 2021      */}
                  <Text style={styles.titleSeed} numberOfLines={2}> {seedName}</Text>
                   <Text style={styles.titleSeed} >Type { type}</Text>
                   <Text style={styles.titleSeed} >Seed Id { seedId}</Text>
                   <Text style={styles.titleSeed} >Origin {  origin}</Text>
                   
                   </View>
                  }
               
                  
                  {
                     //lógica para documentos 
                          String(documentSeed).includes('.mp4') ?
                         <Video 
                            ref = {video}
                            style = {styles.imageVideoSeed}
                            source = {{ uri: seedVideoUri + documentSeed }}
                            useNativeControls
                            resizeMode = "contain"
                            isLooping
                            onPlaybackStatusUpdate = {status => setStatus(() => status)}
                         />
                          : 
                          String(documentSeed).includes('.pdf') ?
                          <Foundation
                                    onPress = { () => retriveDoc()}
                                    name={"page-export-pdf"}
                                    size={50}
                                    color={colors.lemonGreen}
                                    style={styles.icon}
                          /> 
                          : 
                          String(documentSeed).includes('.avi') ?
                          <Video
                                ref={video}
                                style  ={styles.imageVideoSeed}
                                source = {{ uri: seedVideoUri + documentSeed }}                       
                                useNativeControls
                                resizeMode="contain"
                                isLooping
                                onPlaybackStatusUpdate={status => setStatus(() => status)}
                          /> 
                          : 
                          String(documentSeed).includes('.mov') ?
                          <Video
                                ref={video}
                                style  ={styles.imageVideoSeed}
                                source = {{ uri: seedVideoUri + documentSeed }}                       
                                useNativeControls
                                resizeMode="contain"
                                isLooping
                                onPlaybackStatusUpdate={status => setStatus(() => status)}
                          /> 
                          : 
                          String(documentSeed) === '' ?
                          null
                          :
                          String(documentSeed).includes('.xls') ?
                          <MaterialCommunityIcons
                              onPress = { () => retriveDoc()}
                              name={"file-excel"}
                              size={50}
                              color={colors.lemonGreen}
                              style={styles.icon}
                          /> 
                          :
                          String(documentSeed).includes('.xlxs') ?
                          <MaterialCommunityIcons
                              onPress = { () => retriveDoc()}
                              name={"file-excel"}
                              size={50}
                              color={colors.lemonGreen}
                              style={styles.icon}
                          /> 
                          :  
                           null                 
                        }
              {/* 1. primer View </View>  */}
              </View>
              
              {/* Aqui empieza View de Imagen y Follores */}
              <View style={styles.detailsContainerSeed}> 
                  <View >
                  <TouchableOpacity  onPress = {selectImage}>
                  {imageUri != '' ? 

                                 String(imageUri).includes('.mp4') ?
                                   <Video 
                                      ref = {video}
                                      style = {styles.imageSeed}
                                      source = {{ uri: imageUri }}
                                      useNativeControls
                                      resizeMode = "contain"
                                      isLooping
                                      onPlaybackStatusUpdate = {status => setStatus(() => status)}
                                   />
                                  :
                                  String(imageUri).includes('.mov') ?
                                  <Video 
                                      ref = {video}
                                      style = {styles.imageSeed}
                                      source = {{ uri: imageUri }}
                                      useNativeControls
                                      resizeMode = "contain"
                                      isLooping
                                      onPlaybackStatusUpdate = {status => setStatus(() => status)}
                                  />
                                  : 
                                  imageUri === null ?    // http://18.116.234.21:5001/seedImages/
                                  <View style={styles.imageMountainSeed} >
                                              <Foundation 
                                                          name="mountains" 
                                                          size={182} 
                                                          color={colors.medium} />
                                  </View>
                                  :
                                  String(imageUri).includes('.jpg') ?
                                   
                                  <Image style={styles.imageSeed} source={{uri: imageUri} } />
                                  : String(imageUri).includes('.png') ?
                                     
                                  <Image style={styles.imageSeed} source={{uri: imageUri} } />
                                  :  
                                       
                                <Image style={styles.imageSeed} source={{uri: imageUri} } />
                          :
                            
                            true ?  
                             String(seedPhoto).includes('.mp4') ?
                               <Video 
                                  ref = {video}
                                  style = {styles.imageSeed}
                                  source = {{ uri: seedVideoUri + seedPhoto }}
                                  useNativeControls
                                  resizeMode = "contain"
                                  isLooping
                                  onPlaybackStatusUpdate = {status => setStatus(() => status)}
                               />
                              :
                              String(seedPhoto).includes('.mov') ?
                              <Video 
                                  ref = {video}
                                  style = {styles.imageSeed}
                                  source = {{ uri: seedVideoUri + seedPhoto }}
                                  useNativeControls
                                  resizeMode = "contain"
                                  isLooping
                                  onPlaybackStatusUpdate = {status => setStatus(() => status)}
                              />
                              : 
                              seedPhoto === null ?    // http://18.116.234.21:5001/seedImages/
                              <View style={styles.imageMountainSeed} >
                                          <Foundation 
                                                      name="mountains" 
                                                      size={182} 
                                                      color={colors.medium} />
                              </View>
                              :
                              String(seedPhoto).includes('.png') ?
                              <ImageCache
                                  style={styles.imageSeed}
                                  preview={{ uri: webUrl + seedPhoto }}
                                  tint="light"
                                  uri= { webUrl + seedPhoto }
                              /> 
                              :
                              <ImageCache
                                  style={styles.imageSeed}
                                  preview={{ uri: webUrl + seedPhoto }}
                                  tint="light"
                                  uri= { webUrl + seedPhoto }
                              />   
                              :  
                              // Este Image que viene no lo pude quitar porque sino me da un error :(
                             <ImageCache         
                             />      
                        
                          } 
              
                   
                  </TouchableOpacity>
                  </View> 
                    
                    <View style={styles.treeFollowersIconsContainer} >
                        <View  >
                            <Text style={styles.treeSeed} numberOfLines={1} >
                              <Entypo name={"tree"}
                                          //color={colors.medium} 
                                          color={colors.green} 
                                          size={30} 
                                  />                
                              </Text> 
                             <Text style={styles.numbersActionsFollowers} > 1,000 </Text>
                         </View>    
                         <View style={styles.treeFollowersIconsContainer} >
                            <Text style={styles.textFollowers} > Followers </Text>   
                            <Text style={styles.numbersFollowers} > { followers } </Text>  
                         </View>
                         <View style={styles.ContainerButtonEdit}>
                           {
                             foundUserChecker === "off" ?  //true?      //route.params.foundUserChecker === "off" ?
                            <TouchableOpacity  style={styles.buttonEdit}
                                                onPress={ () => 
                                                  updateInfo()
                                                  } >
                                <Text style={styles.textEdit}>
                                  Save
                                </Text>
                              </TouchableOpacity>
                            :
                                statusFollowed ===  1 ?
                                <TouchableOpacity  
                                  style={styles.buttonEdit}
                                  // onPress={ () => 
                                  //   onPressUnFollow()
                                  // }
                                >
                               <Text style={styles.textEdit}>
                                   Unfollow
                               </Text>
                               </TouchableOpacity> 
                            :
                               <TouchableOpacity  
                                  style={styles.buttonEdit}
                                  onPress={ () => 
                                    onPressFollow()
                                  } 
                                >
                                <Text style={styles.textEdit}>
                                  Follow
                                </Text>
                              </TouchableOpacity> 
                           }                     
                          </View>     
                    </View>         
              
              </View>
              {/* Aqui termina View de imagen y followers */}
              
                    {/* </TouchableOpacity> */}
                    <View style={styles.detailsContainer}>
                                      <TextInput style={styles.input}
                                      onChangeText = {text => setDescriptionBoxText(text)}
                                      value = {descriptionBoxText}
                                      multiline = {true}
                                      />
                  </View>
              </View>
    );
  
  
  // A C T I O N  1   <==== Información 
    case 1: 
    return (
<View >
              <View style={ typeActionSelect === 0 ? styles.seedTitle :
                            typeActionSelect === 1 ? styles.seedTitle1 :
                            typeActionSelect === 2 ? styles.seedTitle2 :
                            typeActionSelect === 3 ? styles.seedTitle3 :
                            typeActionSelect === 4 ? styles.seedTitle4 :
                            typeActionSelect === 5 ? styles.seedTitle5 :
                            typeActionSelect === 6 ? styles.seedTitle6 :
                            typeActionSelect === 7 ? styles.seedTitle7 :
                            typeActionSelect === 8 ? styles.seedTitle8 :
                            styles.seedTitle9
                             }>

                          <Text style={styles.titleSeedDate} > Creada el:  { seedDate } </Text>

                            {
                              uploadVisible === true ?
                              <View style={typeActionSelect === 1 ? styles.ViewflatlistTypeAction1:
                                           typeActionSelect === 2 ? styles.ViewflatlistTypeAction2:
                                           typeActionSelect === 3 ? styles.ViewflatlistTypeAction3:
                                           typeActionSelect === 4 ? styles.ViewflatlistTypeAction4:
                                           typeActionSelect === 5 ? styles.ViewflatlistTypeAction5:
                                           typeActionSelect === 6 ? styles.ViewflatlistTypeAction6:
                                           typeActionSelect === 7 ? styles.ViewflatlistTypeAction7:
                                           typeActionSelect === 8 ? styles.ViewflatlistTypeAction8:
                                           styles.ViewflatlistTypeAction9
                              }>
                              <FlatList
                                data={menuItems}
                                keyExtractor={(menuItem) => menuItem.typeActionsId.toString()}
                                ItemSeparatorComponent={ListItemSeparator}
                                renderItem={({ item, index }) => (
                                  <CardListTypeActions
                                    title ={item.typeActionsDesc}
                                    IconComponent={
                                      <Icon
                                        iconFamily={item.iconFamily}
                                        name={item.icon}
                                        size ={35}      //{item.size}
                                        backgroundColor={item.backgroundColor}
                                      />
                                    }
                                    onPress={() =>{ 
                                      typeActionSelect = menuItems[index].typeNum
                                      console.log("typeActionSelect==> ", typeActionSelect)
                                      setUploadVisible(false)
                                    }}
                                  />
                                )}
                              />
                              <Text style={styles.Cancel}
                              onPress={() =>{ 
                                setUploadVisible(false)
                              }}>Cancel</Text>
                              </View>
                              :
                              null
                            } 

             
                            {
                            typeActionSelect === 0 ?   <Text style={styles.titleSeed} >Tipo de acción: Semilla </Text>:
                            typeActionSelect === 1 ?   <Text style={styles.titleSeed} 
                                                onPress={() => {
                                                  uploadVisible === false ?
                                                    setUploadVisible(true)
                                                    :
                                                    setUploadVisible(false)
                                                }}
                                           >Tipo de acción: Información </Text>:                            
                            typeActionSelect === 2 ?   <Text style={styles.titleSeed} 
                                                onPress={() => {
                                                  uploadVisible === false ?
                                                    setUploadVisible(true)
                                                    :
                                                    setUploadVisible(false)
                                                }}
                                           >Tipo de acción: Idea </Text>:                            
                            typeActionSelect === 3 ?   <Text style={styles.titleSeed} 
                                                onPress={() => {
                                                  uploadVisible === false ?
                                                    setUploadVisible(true)
                                                    :
                                                    setUploadVisible(false)
                                                }}
                                                >Tipo de acción: Plan </Text>:
                            typeActionSelect === 4 ?   <Text style={styles.titleSeed} 
                                                onPress={() => {
                                                  uploadVisible === false ?
                                                    setUploadVisible(true)
                                                    :
                                                    setUploadVisible(false)
                                                }}
                                                >Tipo de acción: Realizar </Text>:
                            typeActionSelect === 5 ?   <Text style={styles.titleSeed}
                                                onPress={() => {
                                                  uploadVisible === false ?
                                                    setUploadVisible(true)
                                                    :
                                                    setUploadVisible(false)
                                                }}
                                                >Tipo de acción: Invitar </Text>:
                            typeActionSelect === 6 ?   <Text style={styles.titleSeed} 
                                                onPress={() => {
                                                  uploadVisible === false ?
                                                    setUploadVisible(true)
                                                    :
                                                    setUploadVisible(false)
                                                }}
                                                >Tipo de acción: Disfrutar </Text>:
                            typeActionSelect === 7 ?   <Text style={styles.titleSeed} 
                                                onPress={() => {
                                                  uploadVisible === false ?
                                                    setUploadVisible(true)
                                                    :
                                                    setUploadVisible(false)
                                                }}
                                                >Tipo de acción: Ramificar </Text>:
                            typeActionSelect === 8 ?   <Text style={styles.titleSeed} 
                                                onPress={() => {
                                                  uploadVisible === false ?
                                                    setUploadVisible(true)
                                                    :
                                                    setUploadVisible(false)
                                                }}
                                                >Tipo de acción: Requerimiento </Text>:
                              <Text style={styles.titleSeed} 
                                                onPress={() => {
                                                  uploadVisible === false ?
                                                    setUploadVisible(true)
                                                    :
                                                    setUploadVisible(false)
                                                }}
                                                >Tipo de acción: Donar</Text> 
                             }
                             
                  { 
                    changeListing ?   
                    <View>   
                    <TextInput style={styles.inputName}
                                      onChangeText = {text => setTitleBoxText(text)}
                                      value = {titleBoxText}
                                      multiline = {true}
                                      /> 
                   </View>
                   :
                   <View>
               {/* Prueba con filtroListing sábado 7 agosto 2021      */}
                  <Text style={styles.titleSeed} numberOfLines={2}> {seedName}</Text>
                   <Text style={styles.titleSeed} >Type { type}</Text>
                   <Text style={styles.titleSeed} >Seed Id { seedId}</Text>
                   <Text style={styles.titleSeed} >Origin {  origin}</Text>
                   
                   </View>
                  }
               
                  
                  {
                     //lógica para documentos 
                          String(documentSeed).includes('.mp4') ?
                         <Video 
                            ref = {video}
                            style = {styles.imageVideoSeed}
                            source = {{ uri: seedVideoUri + documentSeed }}
                            useNativeControls
                            resizeMode = "contain"
                            isLooping
                            onPlaybackStatusUpdate = {status => setStatus(() => status)}
                         />
                          : 
                          String(documentSeed).includes('.pdf') ?
                          <Foundation
                                    onPress = { () => retriveDoc()}
                                    name={"page-export-pdf"}
                                    size={50}
                                    color={colors.lemonGreen}
                                    style={styles.icon}
                          /> 
                          : 
                          String(documentSeed).includes('.avi') ?
                          <Video
                                ref={video}
                                style  ={styles.imageVideoSeed}
                                source = {{ uri: seedVideoUri + documentSeed }}                       
                                useNativeControls
                                resizeMode="contain"
                                isLooping
                                onPlaybackStatusUpdate={status => setStatus(() => status)}
                          /> 
                          : 
                          String(documentSeed).includes('.mov') ?
                          <Video
                                ref={video}
                                style  ={styles.imageVideoSeed}
                                source = {{ uri: seedVideoUri + documentSeed }}                       
                                useNativeControls
                                resizeMode="contain"
                                isLooping
                                onPlaybackStatusUpdate={status => setStatus(() => status)}
                          /> 
                          : 
                          String(documentSeed) === '' ?
                          null
                          :
                          String(documentSeed).includes('.xls') ?
                          <MaterialCommunityIcons
                              onPress = { () => retriveDoc()}
                              name={"file-excel"}
                              size={50}
                              color={colors.lemonGreen}
                              style={styles.icon}
                          /> 
                          :
                          String(documentSeed).includes('.xlxs') ?
                          <MaterialCommunityIcons
                              onPress = { () => retriveDoc()}
                              name={"file-excel"}
                              size={50}
                              color={colors.lemonGreen}
                              style={styles.icon}
                          /> 
                          :  
                           null                 
                        }
              {/* 1. primer View </View>  */}
              </View>
              
              {/* Aqui empieza View de Imagen y Follores */}
              <View style={styles.detailsContainerSeed}> 
                  <View >
                  <TouchableOpacity  onPress = {selectImage}>
                  {imageUri != '' ? 
                                
                                  
                                 String(imageUri).includes('.mp4') ?
                                   <Video 
                                      ref = {video}
                                      style = {styles.imageSeed}
                                      source = {{ uri: imageUri }}
                                      useNativeControls
                                      resizeMode = "contain"
                                      isLooping
                                      onPlaybackStatusUpdate = {status => setStatus(() => status)}
                                   />
                                  :
                                  String(imageUri).includes('.mov') ?
                                  <Video 
                                      ref = {video}
                                      style = {styles.imageSeed}
                                      source = {{ uri: imageUri }}
                                      useNativeControls
                                      resizeMode = "contain"
                                      isLooping
                                      onPlaybackStatusUpdate = {status => setStatus(() => status)}
                                  />
                                  : 
                                  imageUri === null ?    // http://18.116.234.21:5001/seedImages/
                                  <View style={styles.imageMountainSeed} >
                                              <Foundation 
                                                          name="mountains" 
                                                          size={182} 
                                                          color={colors.medium} />
                                  </View>
                                  :
                                  String(imageUri).includes('.jpg') ?
                                   
                                  <Image style={styles.imageSeed} source={{uri: imageUri} } />
                                  : String(imageUri).includes('.png') ?
                                     
                                  <Image style={styles.imageSeed} source={{uri: imageUri} } />
                                  :  
                                       
                                <Image style={styles.imageSeed} source={{uri: imageUri} } />
                          :
                            
                            true ?  
                             String(seedPhoto).includes('.mp4') ?
                               <Video 
                                  ref = {video}
                                  style = {styles.imageSeed}
                                  source = {{ uri: seedVideoUri + seedPhoto }}
                                  useNativeControls
                                  resizeMode = "contain"
                                  isLooping
                                  onPlaybackStatusUpdate = {status => setStatus(() => status)}
                               />
                              :
                              String(seedPhoto).includes('.mov') ?
                              <Video 
                                  ref = {video}
                                  style = {styles.imageSeed}
                                  source = {{ uri: seedVideoUri + seedPhoto }}
                                  useNativeControls
                                  resizeMode = "contain"
                                  isLooping
                                  onPlaybackStatusUpdate = {status => setStatus(() => status)}
                              />
                              : 
                              seedPhoto === null ?    // http://18.116.234.21:5001/seedImages/
                              <View style={styles.imageMountainSeed} >
                                          <Foundation 
                                                      name="mountains" 
                                                      size={182} 
                                                      color={colors.medium} />
                              </View>
                              :
                              String(seedPhoto).includes('.png') ?
                              <ImageCache
                                  style={styles.imageSeed}
                                  preview={{ uri: webUrl + seedPhoto }}
                                  tint="light"
                                  uri= { webUrl + seedPhoto }
                              /> 
                              :
                              <ImageCache
                                  style={styles.imageSeed}
                                  preview={{ uri: webUrl + seedPhoto }}
                                  tint="light"
                                  uri= { webUrl + seedPhoto }
                              />   
                              :  
                              // Este Image que viene no lo pude quitar porque sino me da un error :(
                             <ImageCache         
                             />      
                        
                          } 
              
                   
                  </TouchableOpacity>
                  </View> 
                    
                    <View style={styles.treeFollowersIconsContainer} >
                        <View  >
                            <Text style={styles.treeSeed} numberOfLines={1} >
                              <Entypo name={"tree"}
                                          //color={colors.medium} 
                                          color={colors.green} 
                                          size={30} 
                                  />                
                              </Text> 
                             <Text style={styles.numbersActionsFollowers} > 1,000 </Text>
                         </View>    
                         <View style={styles.treeFollowersIconsContainer} >
                            <Text style={styles.textFollowers} > Followers </Text>   
                            <Text style={styles.numbersFollowers} > { followers } </Text>  
                         </View>
                         <View style={styles.ContainerButtonEdit}>
                           {
                             foundUserChecker === "off" ?  //true?      //route.params.foundUserChecker === "off" ?
                            <TouchableOpacity  style={styles.buttonEdit}
                                                onPress={ () => 
                                                  updateInfo()
                                                  } >
                                <Text style={styles.textEdit}>
                                  Save
                                </Text>
                              </TouchableOpacity>
                            :
                                statusFollowed ===  1 ?
                                <TouchableOpacity  
                                  style={styles.buttonEdit}
                                  // onPress={ () => 
                                  //   onPressUnFollow()
                                  // }
                                >
                               <Text style={styles.textEdit}>
                                   Unfollow
                               </Text>
                               </TouchableOpacity> 
                            :
                               <TouchableOpacity  
                                  style={styles.buttonEdit}
                                  onPress={ () => 
                                    onPressFollow()
                                  } 
                                >
                                <Text style={styles.textEdit}>
                                  Follow
                                </Text>
                              </TouchableOpacity> 
                           }                     
                          </View>     
                    </View>         
              
              </View>
              {/* Aqui termina View de imagen y followers */}
              
                    {/* </TouchableOpacity> */}
                    <View style={styles.viewDescription}>
                                      <TextInput style={styles.input}
                                      onChangeText = {text => setDescriptionBoxText(text)}
                                      value = {descriptionBoxText}
                                      multiline = {true}
                                      />
                  </View>
              </View>
              
              );
  
  
  // S E E D   A C T I O N   1     <===  Idea
  case 2:   
  return (
    <View >
    <View style={ typeActionSelect === 0 ? styles.seedTitle :
                  typeActionSelect === 1 ? styles.seedTitle1 :
                  typeActionSelect === 2 ? styles.seedTitle2 :
                  typeActionSelect === 3 ? styles.seedTitle3 :
                  typeActionSelect === 4 ? styles.seedTitle4 :
                  typeActionSelect === 5 ? styles.seedTitle5 :
                  typeActionSelect === 6 ? styles.seedTitle6 :
                  typeActionSelect === 7 ? styles.seedTitle7 :
                  typeActionSelect === 8 ? styles.seedTitle8 :
                  styles.seedTitle9
                   }>

                <Text style={styles.titleSeedDate} > Creada el:  { seedDate } </Text>

                  {
                    uploadVisible === true ?
                    <View style={typeActionSelect === 1 ? styles.ViewflatlistTypeAction1:
                                 typeActionSelect === 2 ? styles.ViewflatlistTypeAction2:
                                 typeActionSelect === 3 ? styles.ViewflatlistTypeAction3:
                                 typeActionSelect === 4 ? styles.ViewflatlistTypeAction4:
                                 typeActionSelect === 5 ? styles.ViewflatlistTypeAction5:
                                 typeActionSelect === 6 ? styles.ViewflatlistTypeAction6:
                                 typeActionSelect === 7 ? styles.ViewflatlistTypeAction7:
                                 typeActionSelect === 8 ? styles.ViewflatlistTypeAction8:
                                 styles.ViewflatlistTypeAction9
                    }>
                    <FlatList
                      data={menuItems}
                      keyExtractor={(menuItem) => menuItem.typeActionsId.toString()}
                      ItemSeparatorComponent={ListItemSeparator}
                      renderItem={({ item, index }) => (
                        <CardListTypeActions
                          title ={item.typeActionsDesc}
                          IconComponent={
                            <Icon
                              iconFamily={item.iconFamily}
                              name={item.icon}
                              size ={35}      //{item.size}
                              backgroundColor={item.backgroundColor}
                            />
                          }
                          onPress={() =>{ 
                            typeActionSelect = menuItems[index].typeNum
                            console.log("typeActionSelect==> ", typeActionSelect)
                            setUploadVisible(false)
                          }}
                        />
                      )}
                    />
                    <Text style={styles.Cancel}
                    onPress={() =>{ 
                      setUploadVisible(false)
                    }}>Cancel</Text>
                    </View>
                    :
                    null
                  } 

   
                  {
                  typeActionSelect === 0 ?   <Text style={styles.titleSeed} >Tipo de acción: Semilla </Text>:
                  typeActionSelect === 1 ?   <Text style={styles.titleSeed} 
                                      onPress={() => {
                                        uploadVisible === false ?
                                          setUploadVisible(true)
                                          :
                                          setUploadVisible(false)
                                      }}
                                 >Tipo de acción: Información </Text>:                            
                  typeActionSelect === 2 ?   <Text style={styles.titleSeed} 
                                      onPress={() => {
                                        uploadVisible === false ?
                                          setUploadVisible(true)
                                          :
                                          setUploadVisible(false)
                                      }}
                                 >Tipo de acción: Idea </Text>:                            
                  typeActionSelect === 3 ?   <Text style={styles.titleSeed} 
                                      onPress={() => {
                                        uploadVisible === false ?
                                          setUploadVisible(true)
                                          :
                                          setUploadVisible(false)
                                      }}
                                      >Tipo de acción: Plan </Text>:
                  typeActionSelect === 4 ?   <Text style={styles.titleSeed} 
                                      onPress={() => {
                                        uploadVisible === false ?
                                          setUploadVisible(true)
                                          :
                                          setUploadVisible(false)
                                      }}
                                      >Tipo de acción: Realizar </Text>:
                  typeActionSelect === 5 ?   <Text style={styles.titleSeed}
                                      onPress={() => {
                                        uploadVisible === false ?
                                          setUploadVisible(true)
                                          :
                                          setUploadVisible(false)
                                      }}
                                      >Tipo de acción: Invitar </Text>:
                  typeActionSelect === 6 ?   <Text style={styles.titleSeed} 
                                      onPress={() => {
                                        uploadVisible === false ?
                                          setUploadVisible(true)
                                          :
                                          setUploadVisible(false)
                                      }}
                                      >Tipo de acción: Disfrutar </Text>:
                  typeActionSelect === 7 ?   <Text style={styles.titleSeed} 
                                      onPress={() => {
                                        uploadVisible === false ?
                                          setUploadVisible(true)
                                          :
                                          setUploadVisible(false)
                                      }}
                                      >Tipo de acción: Ramificar </Text>:
                  typeActionSelect === 8 ?   <Text style={styles.titleSeed} 
                                      onPress={() => {
                                        uploadVisible === false ?
                                          setUploadVisible(true)
                                          :
                                          setUploadVisible(false)
                                      }}
                                      >Tipo de acción: Requerimiento </Text>:
                    <Text style={styles.titleSeed} 
                                      onPress={() => {
                                        uploadVisible === false ?
                                          setUploadVisible(true)
                                          :
                                          setUploadVisible(false)
                                      }}
                                      >Tipo de acción: Donar</Text> 
                   }
                   
        { 
          changeListing ?   
          <View>   
          <TextInput style={styles.inputName}
                            onChangeText = {text => setTitleBoxText(text)}
                            value = {titleBoxText}
                            multiline = {true}
                            /> 
         </View>
         :
         <View>
     {/* Prueba con filtroListing sábado 7 agosto 2021      */}
        <Text style={styles.titleSeed} numberOfLines={2}> {seedName}</Text>
         <Text style={styles.titleSeed} >Type { type}</Text>
         <Text style={styles.titleSeed} >Seed Id { seedId}</Text>
         <Text style={styles.titleSeed} >Origin {  origin}</Text>
         
         </View>
        }
     
        
        {
           //lógica para documentos 
                String(documentSeed).includes('.mp4') ?
               <Video 
                  ref = {video}
                  style = {styles.imageVideoSeed}
                  source = {{ uri: seedVideoUri + documentSeed }}
                  useNativeControls
                  resizeMode = "contain"
                  isLooping
                  onPlaybackStatusUpdate = {status => setStatus(() => status)}
               />
                : 
                String(documentSeed).includes('.pdf') ?
                <Foundation
                          onPress = { () => retriveDoc()}
                          name={"page-export-pdf"}
                          size={50}
                          color={colors.lemonGreen}
                          style={styles.icon}
                /> 
                : 
                String(documentSeed).includes('.avi') ?
                <Video
                      ref={video}
                      style  ={styles.imageVideoSeed}
                      source = {{ uri: seedVideoUri + documentSeed }}                       
                      useNativeControls
                      resizeMode="contain"
                      isLooping
                      onPlaybackStatusUpdate={status => setStatus(() => status)}
                /> 
                : 
                String(documentSeed).includes('.mov') ?
                <Video
                      ref={video}
                      style  ={styles.imageVideoSeed}
                      source = {{ uri: seedVideoUri + documentSeed }}                       
                      useNativeControls
                      resizeMode="contain"
                      isLooping
                      onPlaybackStatusUpdate={status => setStatus(() => status)}
                /> 
                : 
                String(documentSeed) === '' ?
                null
                :
                String(documentSeed).includes('.xls') ?
                <MaterialCommunityIcons
                    onPress = { () => retriveDoc()}
                    name={"file-excel"}
                    size={50}
                    color={colors.lemonGreen}
                    style={styles.icon}
                /> 
                :
                String(documentSeed).includes('.xlxs') ?
                <MaterialCommunityIcons
                    onPress = { () => retriveDoc()}
                    name={"file-excel"}
                    size={50}
                    color={colors.lemonGreen}
                    style={styles.icon}
                /> 
                :  
                 null                 
              }
    {/* 1. primer View </View>  */}
    </View>
    
    {/* Aqui empieza View de Imagen y Follores */}
    <View style={styles.detailsContainerSeed}> 
        <View >
        <TouchableOpacity  onPress = {selectImage}>
        {imageUri != '' ? 
                      
                        
                       String(imageUri).includes('.mp4') ?
                         <Video 
                            ref = {video}
                            style = {styles.imageSeed}
                            source = {{ uri: imageUri }}
                            useNativeControls
                            resizeMode = "contain"
                            isLooping
                            onPlaybackStatusUpdate = {status => setStatus(() => status)}
                         />
                        :
                        String(imageUri).includes('.mov') ?
                        <Video 
                            ref = {video}
                            style = {styles.imageSeed}
                            source = {{ uri: imageUri }}
                            useNativeControls
                            resizeMode = "contain"
                            isLooping
                            onPlaybackStatusUpdate = {status => setStatus(() => status)}
                        />
                        : 
                        imageUri === null ?    // http://18.116.234.21:5001/seedImages/
                        <View style={styles.imageMountainSeed} >
                                    <Foundation 
                                                name="mountains" 
                                                size={182} 
                                                color={colors.medium} />
                        </View>
                        :
                        String(imageUri).includes('.jpg') ?
                         
                        <Image style={styles.imageSeed} source={{uri: imageUri} } />
                        : String(imageUri).includes('.png') ?
                           
                        <Image style={styles.imageSeed} source={{uri: imageUri} } />
                        :  
                             
                      <Image style={styles.imageSeed} source={{uri: imageUri} } />
                :
                  
                  true ?  
                   String(seedPhoto).includes('.mp4') ?
                     <Video 
                        ref = {video}
                        style = {styles.imageSeed}
                        source = {{ uri: seedVideoUri + seedPhoto }}
                        useNativeControls
                        resizeMode = "contain"
                        isLooping
                        onPlaybackStatusUpdate = {status => setStatus(() => status)}
                     />
                    :
                    String(seedPhoto).includes('.mov') ?
                    <Video 
                        ref = {video}
                        style = {styles.imageSeed}
                        source = {{ uri: seedVideoUri + seedPhoto }}
                        useNativeControls
                        resizeMode = "contain"
                        isLooping
                        onPlaybackStatusUpdate = {status => setStatus(() => status)}
                    />
                    : 
                    seedPhoto === null ?    // http://18.116.234.21:5001/seedImages/
                    <View style={styles.imageMountainSeed} >
                                <Foundation 
                                            name="mountains" 
                                            size={182} 
                                            color={colors.medium} />
                    </View>
                    :
                    String(seedPhoto).includes('.png') ?
                    <ImageCache
                        style={styles.imageSeed}
                        preview={{ uri: webUrl + seedPhoto }}
                        tint="light"
                        uri= { webUrl + seedPhoto }
                    /> 
                    :
                    <ImageCache
                        style={styles.imageSeed}
                        preview={{ uri: webUrl + seedPhoto }}
                        tint="light"
                        uri= { webUrl + seedPhoto }
                    />   
                    :  
                    // Este Image que viene no lo pude quitar porque sino me da un error :(
                   <ImageCache         
                   />      
              
                } 
    
         
        </TouchableOpacity>
        </View> 
          
          <View style={styles.treeFollowersIconsContainer} >
              <View  >
                  <Text style={styles.treeSeed} numberOfLines={1} >
                    <Entypo name={"tree"}
                                //color={colors.medium} 
                                color={colors.green} 
                                size={30} 
                        />                
                    </Text> 
                   <Text style={styles.numbersActionsFollowers} > 1,000 </Text>
               </View>    
               <View style={styles.treeFollowersIconsContainer} >
                  <Text style={styles.textFollowers} > Followers </Text>   
                  <Text style={styles.numbersFollowers} > { followers } </Text>  
               </View>
               <View style={styles.ContainerButtonEdit}>
                 {
                   foundUserChecker === "off" ?  //true?      //route.params.foundUserChecker === "off" ?
                  <TouchableOpacity  style={styles.buttonEdit}
                                      onPress={ () => 
                                        updateInfo()
                                        } >
                      <Text style={styles.textEdit}>
                        Save
                      </Text>
                    </TouchableOpacity>
                  :
                      statusFollowed ===  1 ?
                      <TouchableOpacity  
                        style={styles.buttonEdit}
                        // onPress={ () => 
                        //   onPressUnFollow()
                        // }
                      >
                     <Text style={styles.textEdit}>
                         Unfollow
                     </Text>
                     </TouchableOpacity> 
                  :
                     <TouchableOpacity  
                        style={styles.buttonEdit}
                        onPress={ () => 
                          onPressFollow()
                        } 
                      >
                      <Text style={styles.textEdit}>
                        Follow
                      </Text>
                    </TouchableOpacity> 
                 }                     
                </View>     
          </View>         
    
    </View>
    {/* Aqui termina View de imagen y followers */}
    
          {/* </TouchableOpacity> */}
          <View style={styles.viewDescription}>
                            <TextInput style={styles.input}
                            onChangeText = {text => setDescriptionBoxText(text)}
                            value = {descriptionBoxText}
                            multiline = {true}
                            />
        </View>
    </View>

  );
  
  
  // S E E D  A C T I O N 3 <===  Plan
  case 3:   
  return (
    <View >
              <View style={ typeActionSelect === 0 ? styles.seedTitle :
                            typeActionSelect === 1 ? styles.seedTitle1 :
                            typeActionSelect === 2 ? styles.seedTitle2 :
                            typeActionSelect === 3 ? styles.seedTitle3 :
                            typeActionSelect === 4 ? styles.seedTitle4 :
                            typeActionSelect === 5 ? styles.seedTitle5 :
                            typeActionSelect === 6 ? styles.seedTitle6 :
                            typeActionSelect === 7 ? styles.seedTitle7 :
                            typeActionSelect === 8 ? styles.seedTitle8 :
                            styles.seedTitle9
                             }>

                          <Text style={styles.titleSeedDate} > Creada el:  { seedDate } </Text>

                            {
                              uploadVisible === true ?
                              <View style={typeActionSelect === 1 ? styles.ViewflatlistTypeAction1:
                                           typeActionSelect === 2 ? styles.ViewflatlistTypeAction2:
                                           typeActionSelect === 3 ? styles.ViewflatlistTypeAction3:
                                           typeActionSelect === 4 ? styles.ViewflatlistTypeAction4:
                                           typeActionSelect === 5 ? styles.ViewflatlistTypeAction5:
                                           typeActionSelect === 6 ? styles.ViewflatlistTypeAction6:
                                           typeActionSelect === 7 ? styles.ViewflatlistTypeAction7:
                                           typeActionSelect === 8 ? styles.ViewflatlistTypeAction8:
                                           styles.ViewflatlistTypeAction9
                              }>
                              <FlatList
                                data={menuItems}
                                keyExtractor={(menuItem) => menuItem.typeActionsId.toString()}
                                ItemSeparatorComponent={ListItemSeparator}
                                renderItem={({ item, index }) => (
                                  <CardListTypeActions
                                    title ={item.typeActionsDesc}
                                    IconComponent={
                                      <Icon
                                        iconFamily={item.iconFamily}
                                        name={item.icon}
                                        size ={35}      //{item.size}
                                        backgroundColor={item.backgroundColor}
                                      />
                                    }
                                    onPress={() =>{ 
                                      typeActionSelect = menuItems[index].typeNum
                                      console.log("typeActionSelect==> ", typeActionSelect)
                                      setUploadVisible(false)
                                    }}
                                  />
                                )}
                              />
                              <Text style={styles.Cancel}
                              onPress={() =>{ 
                                setUploadVisible(false)
                              }}>Cancel</Text>
                              </View>
                              :
                              null
                            } 

             
                            {
                            typeActionSelect === 0 ?   <Text style={styles.titleSeed} >Tipo de acción: Semilla </Text>:
                            typeActionSelect === 1 ?   <Text style={styles.titleSeed} 
                                                onPress={() => {
                                                  uploadVisible === false ?
                                                    setUploadVisible(true)
                                                    :
                                                    setUploadVisible(false)
                                                }}
                                           >Tipo de acción: Información </Text>:                            
                            typeActionSelect === 2 ?   <Text style={styles.titleSeed} 
                                                onPress={() => {
                                                  uploadVisible === false ?
                                                    setUploadVisible(true)
                                                    :
                                                    setUploadVisible(false)
                                                }}
                                           >Tipo de acción: Idea </Text>:                            
                            typeActionSelect === 3 ?   <Text style={styles.titleSeed} 
                                                onPress={() => {
                                                  uploadVisible === false ?
                                                    setUploadVisible(true)
                                                    :
                                                    setUploadVisible(false)
                                                }}
                                                >Tipo de acción: Plan </Text>:
                            typeActionSelect === 4 ?   <Text style={styles.titleSeed} 
                                                onPress={() => {
                                                  uploadVisible === false ?
                                                    setUploadVisible(true)
                                                    :
                                                    setUploadVisible(false)
                                                }}
                                                >Tipo de acción: Realizar </Text>:
                            typeActionSelect === 5 ?   <Text style={styles.titleSeed}
                                                onPress={() => {
                                                  uploadVisible === false ?
                                                    setUploadVisible(true)
                                                    :
                                                    setUploadVisible(false)
                                                }}
                                                >Tipo de acción: Invitar </Text>:
                            typeActionSelect === 6 ?   <Text style={styles.titleSeed} 
                                                onPress={() => {
                                                  uploadVisible === false ?
                                                    setUploadVisible(true)
                                                    :
                                                    setUploadVisible(false)
                                                }}
                                                >Tipo de acción: Disfrutar </Text>:
                            typeActionSelect === 7 ?   <Text style={styles.titleSeed} 
                                                onPress={() => {
                                                  uploadVisible === false ?
                                                    setUploadVisible(true)
                                                    :
                                                    setUploadVisible(false)
                                                }}
                                                >Tipo de acción: Ramificar </Text>:
                            typeActionSelect === 8 ?   <Text style={styles.titleSeed} 
                                                onPress={() => {
                                                  uploadVisible === false ?
                                                    setUploadVisible(true)
                                                    :
                                                    setUploadVisible(false)
                                                }}
                                                >Tipo de acción: Requerimiento </Text>:
                              <Text style={styles.titleSeed} 
                                                onPress={() => {
                                                  uploadVisible === false ?
                                                    setUploadVisible(true)
                                                    :
                                                    setUploadVisible(false)
                                                }}
                                                >Tipo de acción: Donar</Text> 
                             }
                             
                  { 
                    changeListing ?   
                    <View>   
                    <TextInput style={styles.inputName}
                                      onChangeText = {text => setTitleBoxText(text)}
                                      value = {titleBoxText}
                                      multiline = {true}
                                      /> 
                   </View>
                   :
                   <View>
               {/* Prueba con filtroListing sábado 7 agosto 2021      */}
                  <Text style={styles.titleSeed} numberOfLines={2}> {seedName}</Text>
                   <Text style={styles.titleSeed} >Type { type}</Text>
                   <Text style={styles.titleSeed} >Seed Id { seedId}</Text>
                   <Text style={styles.titleSeed} >Origin {  origin}</Text>
                   
                   </View>
                  }
               
                  
                  {
                     //lógica para documentos 
                          String(documentSeed).includes('.mp4') ?
                         <Video 
                            ref = {video}
                            style = {styles.imageVideoSeed}
                            source = {{ uri: seedVideoUri + documentSeed }}
                            useNativeControls
                            resizeMode = "contain"
                            isLooping
                            onPlaybackStatusUpdate = {status => setStatus(() => status)}
                         />
                          : 
                          String(documentSeed).includes('.pdf') ?
                          <Foundation
                                    onPress = { () => retriveDoc()}
                                    name={"page-export-pdf"}
                                    size={50}
                                    color={colors.lemonGreen}
                                    style={styles.icon}
                          /> 
                          : 
                          String(documentSeed).includes('.avi') ?
                          <Video
                                ref={video}
                                style  ={styles.imageVideoSeed}
                                source = {{ uri: seedVideoUri + documentSeed }}                       
                                useNativeControls
                                resizeMode="contain"
                                isLooping
                                onPlaybackStatusUpdate={status => setStatus(() => status)}
                          /> 
                          : 
                          String(documentSeed).includes('.mov') ?
                          <Video
                                ref={video}
                                style  ={styles.imageVideoSeed}
                                source = {{ uri: seedVideoUri + documentSeed }}                       
                                useNativeControls
                                resizeMode="contain"
                                isLooping
                                onPlaybackStatusUpdate={status => setStatus(() => status)}
                          /> 
                          : 
                          String(documentSeed) === '' ?
                          null
                          :
                          String(documentSeed).includes('.xls') ?
                          <MaterialCommunityIcons
                              onPress = { () => retriveDoc()}
                              name={"file-excel"}
                              size={50}
                              color={colors.lemonGreen}
                              style={styles.icon}
                          /> 
                          :
                          String(documentSeed).includes('.xlxs') ?
                          <MaterialCommunityIcons
                              onPress = { () => retriveDoc()}
                              name={"file-excel"}
                              size={50}
                              color={colors.lemonGreen}
                              style={styles.icon}
                          /> 
                          :  
                           null                 
                        }
              {/* 1. primer View </View>  */}
              </View>
              
              {/* Aqui empieza View de Imagen y Follores */}
              <View style={styles.detailsContainerSeed}> 
                  <View >
                  <TouchableOpacity  onPress = {selectImage}>
                  {imageUri != '' ? 
                                
                                  
                                 String(imageUri).includes('.mp4') ?
                                   <Video 
                                      ref = {video}
                                      style = {styles.imageSeed}
                                      source = {{ uri: imageUri }}
                                      useNativeControls
                                      resizeMode = "contain"
                                      isLooping
                                      onPlaybackStatusUpdate = {status => setStatus(() => status)}
                                   />
                                  :
                                  String(imageUri).includes('.mov') ?
                                  <Video 
                                      ref = {video}
                                      style = {styles.imageSeed}
                                      source = {{ uri: imageUri }}
                                      useNativeControls
                                      resizeMode = "contain"
                                      isLooping
                                      onPlaybackStatusUpdate = {status => setStatus(() => status)}
                                  />
                                  : 
                                  imageUri === null ?    // http://18.116.234.21:5001/seedImages/
                                  <View style={styles.imageMountainSeed} >
                                              <Foundation 
                                                          name="mountains" 
                                                          size={182} 
                                                          color={colors.medium} />
                                  </View>
                                  :
                                  String(imageUri).includes('.jpg') ?
                                   
                                  <Image style={styles.imageSeed} source={{uri: imageUri} } />
                                  : String(imageUri).includes('.png') ?
                                     
                                  <Image style={styles.imageSeed} source={{uri: imageUri} } />
                                  :  
                                       
                                <Image style={styles.imageSeed} source={{uri: imageUri} } />
                          :
                            
                            true ?  
                             String(seedPhoto).includes('.mp4') ?
                               <Video 
                                  ref = {video}
                                  style = {styles.imageSeed}
                                  source = {{ uri: seedVideoUri + seedPhoto }}
                                  useNativeControls
                                  resizeMode = "contain"
                                  isLooping
                                  onPlaybackStatusUpdate = {status => setStatus(() => status)}
                               />
                              :
                              String(seedPhoto).includes('.mov') ?
                              <Video 
                                  ref = {video}
                                  style = {styles.imageSeed}
                                  source = {{ uri: seedVideoUri + seedPhoto }}
                                  useNativeControls
                                  resizeMode = "contain"
                                  isLooping
                                  onPlaybackStatusUpdate = {status => setStatus(() => status)}
                              />
                              : 
                              seedPhoto === null ?    // http://18.116.234.21:5001/seedImages/
                              <View style={styles.imageMountainSeed} >
                                          <Foundation 
                                                      name="mountains" 
                                                      size={182} 
                                                      color={colors.medium} />
                              </View>
                              :
                              String(seedPhoto).includes('.png') ?
                              <ImageCache
                                  style={styles.imageSeed}
                                  preview={{ uri: webUrl + seedPhoto }}
                                  tint="light"
                                  uri= { webUrl + seedPhoto }
                              /> 
                              :
                              <ImageCache
                                  style={styles.imageSeed}
                                  preview={{ uri: webUrl + seedPhoto }}
                                  tint="light"
                                  uri= { webUrl + seedPhoto }
                              />   
                              :  
                              // Este Image que viene no lo pude quitar porque sino me da un error :(
                             <ImageCache         
                             />      
                        
                          } 
              
                   
                  </TouchableOpacity>
                  </View> 
                    
                    <View style={styles.treeFollowersIconsContainer} >
                        <View  >
                            <Text style={styles.treeSeed} numberOfLines={1} >
                              <Entypo name={"tree"}
                                          //color={colors.medium} 
                                          color={colors.green} 
                                          size={30} 
                                  />                
                              </Text> 
                             <Text style={styles.numbersActionsFollowers} > 1,000 </Text>
                         </View>    
                         <View style={styles.treeFollowersIconsContainer} >
                            <Text style={styles.textFollowers} > Followers </Text>   
                            <Text style={styles.numbersFollowers} > { followers } </Text>  
                         </View>
                         <View style={styles.ContainerButtonEdit}>
                           {
                             foundUserChecker === "off" ?  //true?      //route.params.foundUserChecker === "off" ?
                            <TouchableOpacity  style={styles.buttonEdit}
                                                onPress={ () => 
                                                  updateInfo()
                                                  } >
                                <Text style={styles.textEdit}>
                                  Save
                                </Text>
                              </TouchableOpacity>
                            :
                                statusFollowed ===  1 ?
                                <TouchableOpacity  
                                  style={styles.buttonEdit}
                                  // onPress={ () => 
                                  //   onPressUnFollow()
                                  // }
                                >
                               <Text style={styles.textEdit}>
                                   Unfollow
                               </Text>
                               </TouchableOpacity> 
                            :
                               <TouchableOpacity  
                                  style={styles.buttonEdit}
                                  onPress={ () => 
                                    onPressFollow()
                                  } 
                                >
                                <Text style={styles.textEdit}>
                                  Follow
                                </Text>
                              </TouchableOpacity> 
                           }                     
                          </View>     
                    </View>         
              
              </View>
              {/* Aqui termina View de imagen y followers */}
              
                    {/* </TouchableOpacity> */}
                    <View style={styles.viewDescription}>
                                      <TextInput style={styles.input}
                                      onChangeText = {text => setDescriptionBoxText(text)}
                                      value = {descriptionBoxText}
                                      multiline = {true}
                                      />
                  </View>
              </View>

  );
  
 
  // S E E D  A C T I O N 4 <===  Realizar
  case 4:   
  return (
    <View >
              <View style={ typeActionSelect === 0 ? styles.seedTitle :
                            typeActionSelect === 1 ? styles.seedTitle1 :
                            typeActionSelect === 2 ? styles.seedTitle2 :
                            typeActionSelect === 3 ? styles.seedTitle3 :
                            typeActionSelect === 4 ? styles.seedTitle4 :
                            typeActionSelect === 5 ? styles.seedTitle5 :
                            typeActionSelect === 6 ? styles.seedTitle6 :
                            typeActionSelect === 7 ? styles.seedTitle7 :
                            typeActionSelect === 8 ? styles.seedTitle8 :
                            styles.seedTitle9
                             }>

                          <Text style={styles.titleSeedDate} > Creada el:  { seedDate } </Text>

                            {
                              uploadVisible === true ?
                              <View style={typeActionSelect === 1 ? styles.ViewflatlistTypeAction1:
                                           typeActionSelect === 2 ? styles.ViewflatlistTypeAction2:
                                           typeActionSelect === 3 ? styles.ViewflatlistTypeAction3:
                                           typeActionSelect === 4 ? styles.ViewflatlistTypeAction4:
                                           typeActionSelect === 5 ? styles.ViewflatlistTypeAction5:
                                           typeActionSelect === 6 ? styles.ViewflatlistTypeAction6:
                                           typeActionSelect === 7 ? styles.ViewflatlistTypeAction7:
                                           typeActionSelect === 8 ? styles.ViewflatlistTypeAction8:
                                           styles.ViewflatlistTypeAction9
                              }>
                              <FlatList
                                data={menuItems}
                                keyExtractor={(menuItem) => menuItem.typeActionsId.toString()}
                                ItemSeparatorComponent={ListItemSeparator}
                                renderItem={({ item, index }) => (
                                  <CardListTypeActions
                                    title ={item.typeActionsDesc}
                                    IconComponent={
                                      <Icon
                                        iconFamily={item.iconFamily}
                                        name={item.icon}
                                        size ={35}      //{item.size}
                                        backgroundColor={item.backgroundColor}
                                      />
                                    }
                                    onPress={() =>{ 
                                      typeActionSelect = menuItems[index].typeNum
                                      console.log("typeActionSelect==> ", typeActionSelect)
                                      setUploadVisible(false)
                                    }}
                                  />
                                )}
                              />
                              <Text style={styles.Cancel}
                              onPress={() =>{ 
                                setUploadVisible(false)
                              }}>Cancel</Text>
                              </View>
                              :
                              null
                            } 

             
                            {
                            typeActionSelect === 0 ?   <Text style={styles.titleSeed} >Tipo de acción: Semilla </Text>:
                            typeActionSelect === 1 ?   <Text style={styles.titleSeed} 
                                                onPress={() => {
                                                  uploadVisible === false ?
                                                    setUploadVisible(true)
                                                    :
                                                    setUploadVisible(false)
                                                }}
                                           >Tipo de acción: Información </Text>:                            
                            typeActionSelect === 2 ?   <Text style={styles.titleSeed} 
                                                onPress={() => {
                                                  uploadVisible === false ?
                                                    setUploadVisible(true)
                                                    :
                                                    setUploadVisible(false)
                                                }}
                                           >Tipo de acción: Idea </Text>:                            
                            typeActionSelect === 3 ?   <Text style={styles.titleSeed} 
                                                onPress={() => {
                                                  uploadVisible === false ?
                                                    setUploadVisible(true)
                                                    :
                                                    setUploadVisible(false)
                                                }}
                                                >Tipo de acción: Plan </Text>:
                            typeActionSelect === 4 ?   <Text style={styles.titleSeed} 
                                                onPress={() => {
                                                  uploadVisible === false ?
                                                    setUploadVisible(true)
                                                    :
                                                    setUploadVisible(false)
                                                }}
                                                >Tipo de acción: Realizar </Text>:
                            typeActionSelect === 5 ?   <Text style={styles.titleSeed}
                                                onPress={() => {
                                                  uploadVisible === false ?
                                                    setUploadVisible(true)
                                                    :
                                                    setUploadVisible(false)
                                                }}
                                                >Tipo de acción: Invitar </Text>:
                            typeActionSelect === 6 ?   <Text style={styles.titleSeed} 
                                                onPress={() => {
                                                  uploadVisible === false ?
                                                    setUploadVisible(true)
                                                    :
                                                    setUploadVisible(false)
                                                }}
                                                >Tipo de acción: Disfrutar </Text>:
                            typeActionSelect === 7 ?   <Text style={styles.titleSeed} 
                                                onPress={() => {
                                                  uploadVisible === false ?
                                                    setUploadVisible(true)
                                                    :
                                                    setUploadVisible(false)
                                                }}
                                                >Tipo de acción: Ramificar </Text>:
                            typeActionSelect === 8 ?   <Text style={styles.titleSeed} 
                                                onPress={() => {
                                                  uploadVisible === false ?
                                                    setUploadVisible(true)
                                                    :
                                                    setUploadVisible(false)
                                                }}
                                                >Tipo de acción: Requerimiento </Text>:
                              <Text style={styles.titleSeed} 
                                                onPress={() => {
                                                  uploadVisible === false ?
                                                    setUploadVisible(true)
                                                    :
                                                    setUploadVisible(false)
                                                }}
                                                >Tipo de acción: Donar</Text> 
                             }
                             
                  { 
                    changeListing ?   
                    <View>   
                    <TextInput style={styles.inputName}
                                      onChangeText = {text => setTitleBoxText(text)}
                                      value = {titleBoxText}
                                      multiline = {true}
                                      /> 
                   </View>
                   :
                   <View>
               {/* Prueba con filtroListing sábado 7 agosto 2021      */}
                  <Text style={styles.titleSeed} numberOfLines={2}> {seedName}</Text>
                   <Text style={styles.titleSeed} >Type { type}</Text>
                   <Text style={styles.titleSeed} >Seed Id { seedId}</Text>
                   <Text style={styles.titleSeed} >Origin {  origin}</Text>
                   
                   </View>
                  }
               
                  
                  {
                     //lógica para documentos 
                          String(documentSeed).includes('.mp4') ?
                         <Video 
                            ref = {video}
                            style = {styles.imageVideoSeed}
                            source = {{ uri: seedVideoUri + documentSeed }}
                            useNativeControls
                            resizeMode = "contain"
                            isLooping
                            onPlaybackStatusUpdate = {status => setStatus(() => status)}
                         />
                          : 
                          String(documentSeed).includes('.pdf') ?
                          <Foundation
                                    onPress = { () => retriveDoc()}
                                    name={"page-export-pdf"}
                                    size={50}
                                    color={colors.lemonGreen}
                                    style={styles.icon}
                          /> 
                          : 
                          String(documentSeed).includes('.avi') ?
                          <Video
                                ref={video}
                                style  ={styles.imageVideoSeed}
                                source = {{ uri: seedVideoUri + documentSeed }}                       
                                useNativeControls
                                resizeMode="contain"
                                isLooping
                                onPlaybackStatusUpdate={status => setStatus(() => status)}
                          /> 
                          : 
                          String(documentSeed).includes('.mov') ?
                          <Video
                                ref={video}
                                style  ={styles.imageVideoSeed}
                                source = {{ uri: seedVideoUri + documentSeed }}                       
                                useNativeControls
                                resizeMode="contain"
                                isLooping
                                onPlaybackStatusUpdate={status => setStatus(() => status)}
                          /> 
                          : 
                          String(documentSeed) === '' ?
                          null
                          :
                          String(documentSeed).includes('.xls') ?
                          <MaterialCommunityIcons
                              onPress = { () => retriveDoc()}
                              name={"file-excel"}
                              size={50}
                              color={colors.lemonGreen}
                              style={styles.icon}
                          /> 
                          :
                          String(documentSeed).includes('.xlxs') ?
                          <MaterialCommunityIcons
                              onPress = { () => retriveDoc()}
                              name={"file-excel"}
                              size={50}
                              color={colors.lemonGreen}
                              style={styles.icon}
                          /> 
                          :  
                           null                 
                        }
              {/* 1. primer View </View>  */}
              </View>
              
              {/* Aqui empieza View de Imagen y Follores */}
              <View style={styles.detailsContainerSeed}> 
                  <View >
                  <TouchableOpacity  onPress = {selectImage}>
                  {imageUri != '' ? 
                                
                                  
                                 String(imageUri).includes('.mp4') ?
                                   <Video 
                                      ref = {video}
                                      style = {styles.imageSeed}
                                      source = {{ uri: imageUri }}
                                      useNativeControls
                                      resizeMode = "contain"
                                      isLooping
                                      onPlaybackStatusUpdate = {status => setStatus(() => status)}
                                   />
                                  :
                                  String(imageUri).includes('.mov') ?
                                  <Video 
                                      ref = {video}
                                      style = {styles.imageSeed}
                                      source = {{ uri: imageUri }}
                                      useNativeControls
                                      resizeMode = "contain"
                                      isLooping
                                      onPlaybackStatusUpdate = {status => setStatus(() => status)}
                                  />
                                  : 
                                  imageUri === null ?    // http://18.116.234.21:5001/seedImages/
                                  <View style={styles.imageMountainSeed} >
                                              <Foundation 
                                                          name="mountains" 
                                                          size={182} 
                                                          color={colors.medium} />
                                  </View>
                                  :
                                  String(imageUri).includes('.jpg') ?
                                   
                                  <Image style={styles.imageSeed} source={{uri: imageUri} } />
                                  : String(imageUri).includes('.png') ?
                                     
                                  <Image style={styles.imageSeed} source={{uri: imageUri} } />
                                  :  
                                       
                                <Image style={styles.imageSeed} source={{uri: imageUri} } />
                          :
                            
                            true ?  
                             String(seedPhoto).includes('.mp4') ?
                               <Video 
                                  ref = {video}
                                  style = {styles.imageSeed}
                                  source = {{ uri: seedVideoUri + seedPhoto }}
                                  useNativeControls
                                  resizeMode = "contain"
                                  isLooping
                                  onPlaybackStatusUpdate = {status => setStatus(() => status)}
                               />
                              :
                              String(seedPhoto).includes('.mov') ?
                              <Video 
                                  ref = {video}
                                  style = {styles.imageSeed}
                                  source = {{ uri: seedVideoUri + seedPhoto }}
                                  useNativeControls
                                  resizeMode = "contain"
                                  isLooping
                                  onPlaybackStatusUpdate = {status => setStatus(() => status)}
                              />
                              : 
                              seedPhoto === null ?    // http://18.116.234.21:5001/seedImages/
                              <View style={styles.imageMountainSeed} >
                                          <Foundation 
                                                      name="mountains" 
                                                      size={182} 
                                                      color={colors.medium} />
                              </View>
                              :
                              String(seedPhoto).includes('.png') ?
                              <ImageCache
                                  style={styles.imageSeed}
                                  preview={{ uri: webUrl + seedPhoto }}
                                  tint="light"
                                  uri= { webUrl + seedPhoto }
                              /> 
                              :
                              <ImageCache
                                  style={styles.imageSeed}
                                  preview={{ uri: webUrl + seedPhoto }}
                                  tint="light"
                                  uri= { webUrl + seedPhoto }
                              />   
                              :  
                              // Este Image que viene no lo pude quitar porque sino me da un error :(
                             <ImageCache         
                             />      
                        
                          } 
              
                   
                  </TouchableOpacity>
                  </View> 
                    
                    <View style={styles.treeFollowersIconsContainer} >
                        <View  >
                            <Text style={styles.treeSeed} numberOfLines={1} >
                              <Entypo name={"tree"}
                                          //color={colors.medium} 
                                          color={colors.green} 
                                          size={30} 
                                  />                
                              </Text> 
                             <Text style={styles.numbersActionsFollowers} > 1,000 </Text>
                         </View>    
                         <View style={styles.treeFollowersIconsContainer} >
                            <Text style={styles.textFollowers} > Followers </Text>   
                            <Text style={styles.numbersFollowers} > { followers } </Text>  
                         </View>
                         <View style={styles.ContainerButtonEdit}>
                           {
                             foundUserChecker === "off" ?  //true?      //route.params.foundUserChecker === "off" ?
                            <TouchableOpacity  style={styles.buttonEdit}
                                                onPress={ () => 
                                                  updateInfo()
                                                  } >
                                <Text style={styles.textEdit}>
                                  Save
                                </Text>
                              </TouchableOpacity>
                            :
                                statusFollowed ===  1 ?
                                <TouchableOpacity  
                                  style={styles.buttonEdit}
                                  // onPress={ () => 
                                  //   onPressUnFollow()
                                  // }
                                >
                               <Text style={styles.textEdit}>
                                   Unfollow
                               </Text>
                               </TouchableOpacity> 
                            :
                               <TouchableOpacity  
                                  style={styles.buttonEdit}
                                  onPress={ () => 
                                    onPressFollow()
                                  } 
                                >
                                <Text style={styles.textEdit}>
                                  Follow
                                </Text>
                              </TouchableOpacity> 
                           }                     
                          </View>     
                    </View>         
              
              </View>
              {/* Aqui termina View de imagen y followers */}
              
                    {/* </TouchableOpacity> */}
                    <View style={styles.viewDescription}>
                                      <TextInput style={styles.input}
                                      onChangeText = {text => setDescriptionBoxText(text)}
                                      value = {descriptionBoxText}
                                      multiline = {true}
                                      />
                  </View>
              </View>

  );
  

  // S E E D  A C T I O N 5 <===  Invitar
  case 5:   
  return (
    <View >
              <View style={ typeActionSelect === 0 ? styles.seedTitle :
                            typeActionSelect === 1 ? styles.seedTitle1 :
                            typeActionSelect === 2 ? styles.seedTitle2 :
                            typeActionSelect === 3 ? styles.seedTitle3 :
                            typeActionSelect === 4 ? styles.seedTitle4 :
                            typeActionSelect === 5 ? styles.seedTitle5 :
                            typeActionSelect === 6 ? styles.seedTitle6 :
                            typeActionSelect === 7 ? styles.seedTitle7 :
                            typeActionSelect === 8 ? styles.seedTitle8 :
                            styles.seedTitle9
                             }>

                          <Text style={styles.titleSeedDate} > Creada el:  { seedDate } </Text>

                            {
                              uploadVisible === true ?
                              <View style={typeActionSelect === 1 ? styles.ViewflatlistTypeAction1:
                                           typeActionSelect === 2 ? styles.ViewflatlistTypeAction2:
                                           typeActionSelect === 3 ? styles.ViewflatlistTypeAction3:
                                           typeActionSelect === 4 ? styles.ViewflatlistTypeAction4:
                                           typeActionSelect === 5 ? styles.ViewflatlistTypeAction5:
                                           typeActionSelect === 6 ? styles.ViewflatlistTypeAction6:
                                           typeActionSelect === 7 ? styles.ViewflatlistTypeAction7:
                                           typeActionSelect === 8 ? styles.ViewflatlistTypeAction8:
                                           styles.ViewflatlistTypeAction9
                              }>
                              <FlatList
                                data={menuItems}
                                keyExtractor={(menuItem) => menuItem.typeActionsId.toString()}
                                ItemSeparatorComponent={ListItemSeparator}
                                renderItem={({ item, index }) => (
                                  <CardListTypeActions
                                    title ={item.typeActionsDesc}
                                    IconComponent={
                                      <Icon
                                        iconFamily={item.iconFamily}
                                        name={item.icon}
                                        size ={35}      //{item.size}
                                        backgroundColor={item.backgroundColor}
                                      />
                                    }
                                    onPress={() =>{ 
                                      typeActionSelect = menuItems[index].typeNum
                                      console.log("typeActionSelect==> ", typeActionSelect)
                                      setUploadVisible(false)
                                    }}
                                  />
                                )}
                              />
                              <Text style={styles.Cancel}
                              onPress={() =>{ 
                                setUploadVisible(false)
                              }}>Cancel</Text>
                              </View>
                              :
                              null
                            } 

             
                            {
                            typeActionSelect === 0 ?   <Text style={styles.titleSeed} >Tipo de acción: Semilla </Text>:
                            typeActionSelect === 1 ?   <Text style={styles.titleSeed} 
                                                onPress={() => {
                                                  uploadVisible === false ?
                                                    setUploadVisible(true)
                                                    :
                                                    setUploadVisible(false)
                                                }}
                                           >Tipo de acción: Información </Text>:                            
                            typeActionSelect === 2 ?   <Text style={styles.titleSeed} 
                                                onPress={() => {
                                                  uploadVisible === false ?
                                                    setUploadVisible(true)
                                                    :
                                                    setUploadVisible(false)
                                                }}
                                           >Tipo de acción: Idea </Text>:                            
                            typeActionSelect === 3 ?   <Text style={styles.titleSeed} 
                                                onPress={() => {
                                                  uploadVisible === false ?
                                                    setUploadVisible(true)
                                                    :
                                                    setUploadVisible(false)
                                                }}
                                                >Tipo de acción: Plan </Text>:
                            typeActionSelect === 4 ?   <Text style={styles.titleSeed} 
                                                onPress={() => {
                                                  uploadVisible === false ?
                                                    setUploadVisible(true)
                                                    :
                                                    setUploadVisible(false)
                                                }}
                                                >Tipo de acción: Realizar </Text>:
                            typeActionSelect === 5 ?   <Text style={styles.titleSeed}
                                                onPress={() => {
                                                  uploadVisible === false ?
                                                    setUploadVisible(true)
                                                    :
                                                    setUploadVisible(false)
                                                }}
                                                >Tipo de acción: Invitar </Text>:
                            typeActionSelect === 6 ?   <Text style={styles.titleSeed} 
                                                onPress={() => {
                                                  uploadVisible === false ?
                                                    setUploadVisible(true)
                                                    :
                                                    setUploadVisible(false)
                                                }}
                                                >Tipo de acción: Disfrutar </Text>:
                            typeActionSelect === 7 ?   <Text style={styles.titleSeed} 
                                                onPress={() => {
                                                  uploadVisible === false ?
                                                    setUploadVisible(true)
                                                    :
                                                    setUploadVisible(false)
                                                }}
                                                >Tipo de acción: Ramificar </Text>:
                            typeActionSelect === 8 ?   <Text style={styles.titleSeed} 
                                                onPress={() => {
                                                  uploadVisible === false ?
                                                    setUploadVisible(true)
                                                    :
                                                    setUploadVisible(false)
                                                }}
                                                >Tipo de acción: Requerimiento </Text>:
                              <Text style={styles.titleSeed} 
                                                onPress={() => {
                                                  uploadVisible === false ?
                                                    setUploadVisible(true)
                                                    :
                                                    setUploadVisible(false)
                                                }}
                                                >Tipo de acción: Donar</Text> 
                             }
                             
                  { 
                    changeListing ?   
                    <View>   
                    <TextInput style={styles.inputName}
                                      onChangeText = {text => setTitleBoxText(text)}
                                      value = {titleBoxText}
                                      multiline = {true}
                                      /> 
                   </View>
                   :
                   <View>
               {/* Prueba con filtroListing sábado 7 agosto 2021      */}
                  <Text style={styles.titleSeed} numberOfLines={2}> {seedName}</Text>
                   <Text style={styles.titleSeed} >Type { type}</Text>
                   <Text style={styles.titleSeed} >Seed Id { seedId}</Text>
                   <Text style={styles.titleSeed} >Origin {  origin}</Text>
                   
                   </View>
                  }
               
                  
                  {
                     //lógica para documentos 
                          String(documentSeed).includes('.mp4') ?
                         <Video 
                            ref = {video}
                            style = {styles.imageVideoSeed}
                            source = {{ uri: seedVideoUri + documentSeed }}
                            useNativeControls
                            resizeMode = "contain"
                            isLooping
                            onPlaybackStatusUpdate = {status => setStatus(() => status)}
                         />
                          : 
                          String(documentSeed).includes('.pdf') ?
                          <Foundation
                                    onPress = { () => retriveDoc()}
                                    name={"page-export-pdf"}
                                    size={50}
                                    color={colors.lemonGreen}
                                    style={styles.icon}
                          /> 
                          : 
                          String(documentSeed).includes('.avi') ?
                          <Video
                                ref={video}
                                style  ={styles.imageVideoSeed}
                                source = {{ uri: seedVideoUri + documentSeed }}                       
                                useNativeControls
                                resizeMode="contain"
                                isLooping
                                onPlaybackStatusUpdate={status => setStatus(() => status)}
                          /> 
                          : 
                          String(documentSeed).includes('.mov') ?
                          <Video
                                ref={video}
                                style  ={styles.imageVideoSeed}
                                source = {{ uri: seedVideoUri + documentSeed }}                       
                                useNativeControls
                                resizeMode="contain"
                                isLooping
                                onPlaybackStatusUpdate={status => setStatus(() => status)}
                          /> 
                          : 
                          String(documentSeed) === '' ?
                          null
                          :
                          String(documentSeed).includes('.xls') ?
                          <MaterialCommunityIcons
                              onPress = { () => retriveDoc()}
                              name={"file-excel"}
                              size={50}
                              color={colors.lemonGreen}
                              style={styles.icon}
                          /> 
                          :
                          String(documentSeed).includes('.xlxs') ?
                          <MaterialCommunityIcons
                              onPress = { () => retriveDoc()}
                              name={"file-excel"}
                              size={50}
                              color={colors.lemonGreen}
                              style={styles.icon}
                          /> 
                          :  
                           null                 
                        }
              {/* 1. primer View </View>  */}
              </View>
              
              {/* Aqui empieza View de Imagen y Follores */}
              <View style={styles.detailsContainerSeed}> 
                  <View >
                  <TouchableOpacity  onPress = {selectImage}>
                  {imageUri != '' ? 
                                
                                  
                                 String(imageUri).includes('.mp4') ?
                                   <Video 
                                      ref = {video}
                                      style = {styles.imageSeed}
                                      source = {{ uri: imageUri }}
                                      useNativeControls
                                      resizeMode = "contain"
                                      isLooping
                                      onPlaybackStatusUpdate = {status => setStatus(() => status)}
                                   />
                                  :
                                  String(imageUri).includes('.mov') ?
                                  <Video 
                                      ref = {video}
                                      style = {styles.imageSeed}
                                      source = {{ uri: imageUri }}
                                      useNativeControls
                                      resizeMode = "contain"
                                      isLooping
                                      onPlaybackStatusUpdate = {status => setStatus(() => status)}
                                  />
                                  : 
                                  imageUri === null ?    // http://18.116.234.21:5001/seedImages/
                                  <View style={styles.imageMountainSeed} >
                                              <Foundation 
                                                          name="mountains" 
                                                          size={182} 
                                                          color={colors.medium} />
                                  </View>
                                  :
                                  String(imageUri).includes('.jpg') ?
                                   
                                  <Image style={styles.imageSeed} source={{uri: imageUri} } />
                                  : String(imageUri).includes('.png') ?
                                     
                                  <Image style={styles.imageSeed} source={{uri: imageUri} } />
                                  :  
                                       
                                <Image style={styles.imageSeed} source={{uri: imageUri} } />
                          :
                            
                            true ?  
                             String(seedPhoto).includes('.mp4') ?
                               <Video 
                                  ref = {video}
                                  style = {styles.imageSeed}
                                  source = {{ uri: seedVideoUri + seedPhoto }}
                                  useNativeControls
                                  resizeMode = "contain"
                                  isLooping
                                  onPlaybackStatusUpdate = {status => setStatus(() => status)}
                               />
                              :
                              String(seedPhoto).includes('.mov') ?
                              <Video 
                                  ref = {video}
                                  style = {styles.imageSeed}
                                  source = {{ uri: seedVideoUri + seedPhoto }}
                                  useNativeControls
                                  resizeMode = "contain"
                                  isLooping
                                  onPlaybackStatusUpdate = {status => setStatus(() => status)}
                              />
                              : 
                              seedPhoto === null ?    // http://18.116.234.21:5001/seedImages/
                              <View style={styles.imageMountainSeed} >
                                          <Foundation 
                                                      name="mountains" 
                                                      size={182} 
                                                      color={colors.medium} />
                              </View>
                              :
                              String(seedPhoto).includes('.png') ?
                              <ImageCache
                                  style={styles.imageSeed}
                                  preview={{ uri: webUrl + seedPhoto }}
                                  tint="light"
                                  uri= { webUrl + seedPhoto }
                              /> 
                              :
                              <ImageCache
                                  style={styles.imageSeed}
                                  preview={{ uri: webUrl + seedPhoto }}
                                  tint="light"
                                  uri= { webUrl + seedPhoto }
                              />   
                              :  
                              // Este Image que viene no lo pude quitar porque sino me da un error :(
                             <ImageCache         
                             />      
                        
                          } 
              
                   
                  </TouchableOpacity>
                  </View> 
                    
                    <View style={styles.treeFollowersIconsContainer} >
                        <View  >
                            <Text style={styles.treeSeed} numberOfLines={1} >
                              <Entypo name={"tree"}
                                          //color={colors.medium} 
                                          color={colors.green} 
                                          size={30} 
                                  />                
                              </Text> 
                             <Text style={styles.numbersActionsFollowers} > 1,000 </Text>
                         </View>    
                         <View style={styles.treeFollowersIconsContainer} >
                            <Text style={styles.textFollowers} > Followers </Text>   
                            <Text style={styles.numbersFollowers} > { followers } </Text>  
                         </View>
                         <View style={styles.ContainerButtonEdit}>
                           {
                             foundUserChecker === "off" ?  //true?      //route.params.foundUserChecker === "off" ?
                            <TouchableOpacity  style={styles.buttonEdit}
                                                onPress={ () => 
                                                  updateInfo()
                                                  } >
                                <Text style={styles.textEdit}>
                                  Save
                                </Text>
                              </TouchableOpacity>
                            :
                                statusFollowed ===  1 ?
                                <TouchableOpacity  
                                  style={styles.buttonEdit}
                                  // onPress={ () => 
                                  //   onPressUnFollow()
                                  // }
                                >
                               <Text style={styles.textEdit}>
                                   Unfollow
                               </Text>
                               </TouchableOpacity> 
                            :
                               <TouchableOpacity  
                                  style={styles.buttonEdit}
                                  onPress={ () => 
                                    onPressFollow()
                                  } 
                                >
                                <Text style={styles.textEdit}>
                                  Follow
                                </Text>
                              </TouchableOpacity> 
                           }                     
                          </View>     
                    </View>         
              
              </View>
              {/* Aqui termina View de imagen y followers */}
              
                    {/* </TouchableOpacity> */}
                    <View style={styles.viewDescription}>
                                      <TextInput style={styles.input}
                                      onChangeText = {text => setDescriptionBoxText(text)}
                                      value = {descriptionBoxText}
                                      multiline = {true}
                                      />
                  </View>
              </View>

  );

  
  // S E E D  A C T I O N 6 <===  Disfrutar
  case 6:   
  return (
    <View >
              <View style={ typeActionSelect === 0 ? styles.seedTitle :
                            typeActionSelect === 1 ? styles.seedTitle1 :
                            typeActionSelect === 2 ? styles.seedTitle2 :
                            typeActionSelect === 3 ? styles.seedTitle3 :
                            typeActionSelect === 4 ? styles.seedTitle4 :
                            typeActionSelect === 5 ? styles.seedTitle5 :
                            typeActionSelect === 6 ? styles.seedTitle6 :
                            typeActionSelect === 7 ? styles.seedTitle7 :
                            typeActionSelect === 8 ? styles.seedTitle8 :
                            styles.seedTitle9
                             }>

                          <Text style={styles.titleSeedDate} > Creada el:  { seedDate } </Text>

                            {
                              uploadVisible === true ?
                              <View style={typeActionSelect === 1 ? styles.ViewflatlistTypeAction1:
                                           typeActionSelect === 2 ? styles.ViewflatlistTypeAction2:
                                           typeActionSelect === 3 ? styles.ViewflatlistTypeAction3:
                                           typeActionSelect === 4 ? styles.ViewflatlistTypeAction4:
                                           typeActionSelect === 5 ? styles.ViewflatlistTypeAction5:
                                           typeActionSelect === 6 ? styles.ViewflatlistTypeAction6:
                                           typeActionSelect === 7 ? styles.ViewflatlistTypeAction7:
                                           typeActionSelect === 8 ? styles.ViewflatlistTypeAction8:
                                           styles.ViewflatlistTypeAction9
                              }>
                              <FlatList
                                data={menuItems}
                                keyExtractor={(menuItem) => menuItem.typeActionsId.toString()}
                                ItemSeparatorComponent={ListItemSeparator}
                                renderItem={({ item, index }) => (
                                  <CardListTypeActions
                                    title ={item.typeActionsDesc}
                                    IconComponent={
                                      <Icon
                                        iconFamily={item.iconFamily}
                                        name={item.icon}
                                        size ={35}      //{item.size}
                                        backgroundColor={item.backgroundColor}
                                      />
                                    }
                                    onPress={() =>{ 
                                      typeActionSelect = menuItems[index].typeNum
                                      console.log("typeActionSelect==> ", typeActionSelect)
                                      setUploadVisible(false)
                                    }}
                                  />
                                )}
                              />
                              <Text style={styles.Cancel}
                              onPress={() =>{ 
                                setUploadVisible(false)
                              }}>Cancel</Text>
                              </View>
                              :
                              null
                            } 

             
                            {
                            typeActionSelect === 0 ?   <Text style={styles.titleSeed} >Tipo de acción: Semilla </Text>:
                            typeActionSelect === 1 ?   <Text style={styles.titleSeed} 
                                                onPress={() => {
                                                  uploadVisible === false ?
                                                    setUploadVisible(true)
                                                    :
                                                    setUploadVisible(false)
                                                }}
                                           >Tipo de acción: Información </Text>:                            
                            typeActionSelect === 2 ?   <Text style={styles.titleSeed} 
                                                onPress={() => {
                                                  uploadVisible === false ?
                                                    setUploadVisible(true)
                                                    :
                                                    setUploadVisible(false)
                                                }}
                                           >Tipo de acción: Idea </Text>:                            
                            typeActionSelect === 3 ?   <Text style={styles.titleSeed} 
                                                onPress={() => {
                                                  uploadVisible === false ?
                                                    setUploadVisible(true)
                                                    :
                                                    setUploadVisible(false)
                                                }}
                                                >Tipo de acción: Plan </Text>:
                            typeActionSelect === 4 ?   <Text style={styles.titleSeed} 
                                                onPress={() => {
                                                  uploadVisible === false ?
                                                    setUploadVisible(true)
                                                    :
                                                    setUploadVisible(false)
                                                }}
                                                >Tipo de acción: Realizar </Text>:
                            typeActionSelect === 5 ?   <Text style={styles.titleSeed}
                                                onPress={() => {
                                                  uploadVisible === false ?
                                                    setUploadVisible(true)
                                                    :
                                                    setUploadVisible(false)
                                                }}
                                                >Tipo de acción: Invitar </Text>:
                            typeActionSelect === 6 ?   <Text style={styles.titleSeed} 
                                                onPress={() => {
                                                  uploadVisible === false ?
                                                    setUploadVisible(true)
                                                    :
                                                    setUploadVisible(false)
                                                }}
                                                >Tipo de acción: Disfrutar </Text>:
                            typeActionSelect === 7 ?   <Text style={styles.titleSeed} 
                                                onPress={() => {
                                                  uploadVisible === false ?
                                                    setUploadVisible(true)
                                                    :
                                                    setUploadVisible(false)
                                                }}
                                                >Tipo de acción: Ramificar </Text>:
                            typeActionSelect === 8 ?   <Text style={styles.titleSeed} 
                                                onPress={() => {
                                                  uploadVisible === false ?
                                                    setUploadVisible(true)
                                                    :
                                                    setUploadVisible(false)
                                                }}
                                                >Tipo de acción: Requerimiento </Text>:
                              <Text style={styles.titleSeed} 
                                                onPress={() => {
                                                  uploadVisible === false ?
                                                    setUploadVisible(true)
                                                    :
                                                    setUploadVisible(false)
                                                }}
                                                >Tipo de acción: Donar</Text> 
                             }
                             
                  { 
                    changeListing ?   
                    <View>   
                    <TextInput style={styles.inputName}
                                      onChangeText = {text => setTitleBoxText(text)}
                                      value = {titleBoxText}
                                      multiline = {true}
                                      /> 
                   </View>
                   :
                   <View>
               {/* Prueba con filtroListing sábado 7 agosto 2021      */}
                  <Text style={styles.titleSeed} numberOfLines={2}> {seedName}</Text>
                   <Text style={styles.titleSeed} >Type { type}</Text>
                   <Text style={styles.titleSeed} >Seed Id { seedId}</Text>
                   <Text style={styles.titleSeed} >Origin {  origin}</Text>
                   
                   </View>
                  }
               
                  
                  {
                     //lógica para documentos 
                          String(documentSeed).includes('.mp4') ?
                         <Video 
                            ref = {video}
                            style = {styles.imageVideoSeed}
                            source = {{ uri: seedVideoUri + documentSeed }}
                            useNativeControls
                            resizeMode = "contain"
                            isLooping
                            onPlaybackStatusUpdate = {status => setStatus(() => status)}
                         />
                          : 
                          String(documentSeed).includes('.pdf') ?
                          <Foundation
                                    onPress = { () => retriveDoc()}
                                    name={"page-export-pdf"}
                                    size={50}
                                    color={colors.lemonGreen}
                                    style={styles.icon}
                          /> 
                          : 
                          String(documentSeed).includes('.avi') ?
                          <Video
                                ref={video}
                                style  ={styles.imageVideoSeed}
                                source = {{ uri: seedVideoUri + documentSeed }}                       
                                useNativeControls
                                resizeMode="contain"
                                isLooping
                                onPlaybackStatusUpdate={status => setStatus(() => status)}
                          /> 
                          : 
                          String(documentSeed).includes('.mov') ?
                          <Video
                                ref={video}
                                style  ={styles.imageVideoSeed}
                                source = {{ uri: seedVideoUri + documentSeed }}                       
                                useNativeControls
                                resizeMode="contain"
                                isLooping
                                onPlaybackStatusUpdate={status => setStatus(() => status)}
                          /> 
                          : 
                          String(documentSeed) === '' ?
                          null
                          :
                          String(documentSeed).includes('.xls') ?
                          <MaterialCommunityIcons
                              onPress = { () => retriveDoc()}
                              name={"file-excel"}
                              size={50}
                              color={colors.lemonGreen}
                              style={styles.icon}
                          /> 
                          :
                          String(documentSeed).includes('.xlxs') ?
                          <MaterialCommunityIcons
                              onPress = { () => retriveDoc()}
                              name={"file-excel"}
                              size={50}
                              color={colors.lemonGreen}
                              style={styles.icon}
                          /> 
                          :  
                           null                 
                        }
              {/* 1. primer View </View>  */}
              </View>
              
              {/* Aqui empieza View de Imagen y Follores */}
              <View style={styles.detailsContainerSeed}> 
                  <View >
                  <TouchableOpacity  onPress = {selectImage}>
                  {imageUri != '' ? 
                                
                                  
                                 String(imageUri).includes('.mp4') ?
                                   <Video 
                                      ref = {video}
                                      style = {styles.imageSeed}
                                      source = {{ uri: imageUri }}
                                      useNativeControls
                                      resizeMode = "contain"
                                      isLooping
                                      onPlaybackStatusUpdate = {status => setStatus(() => status)}
                                   />
                                  :
                                  String(imageUri).includes('.mov') ?
                                  <Video 
                                      ref = {video}
                                      style = {styles.imageSeed}
                                      source = {{ uri: imageUri }}
                                      useNativeControls
                                      resizeMode = "contain"
                                      isLooping
                                      onPlaybackStatusUpdate = {status => setStatus(() => status)}
                                  />
                                  : 
                                  imageUri === null ?    // http://18.116.234.21:5001/seedImages/
                                  <View style={styles.imageMountainSeed} >
                                              <Foundation 
                                                          name="mountains" 
                                                          size={182} 
                                                          color={colors.medium} />
                                  </View>
                                  :
                                  String(imageUri).includes('.jpg') ?
                                   
                                  <Image style={styles.imageSeed} source={{uri: imageUri} } />
                                  : String(imageUri).includes('.png') ?
                                     
                                  <Image style={styles.imageSeed} source={{uri: imageUri} } />
                                  :  
                                       
                                <Image style={styles.imageSeed} source={{uri: imageUri} } />
                          :
                            
                            true ?  
                             String(seedPhoto).includes('.mp4') ?
                               <Video 
                                  ref = {video}
                                  style = {styles.imageSeed}
                                  source = {{ uri: seedVideoUri + seedPhoto }}
                                  useNativeControls
                                  resizeMode = "contain"
                                  isLooping
                                  onPlaybackStatusUpdate = {status => setStatus(() => status)}
                               />
                              :
                              String(seedPhoto).includes('.mov') ?
                              <Video 
                                  ref = {video}
                                  style = {styles.imageSeed}
                                  source = {{ uri: seedVideoUri + seedPhoto }}
                                  useNativeControls
                                  resizeMode = "contain"
                                  isLooping
                                  onPlaybackStatusUpdate = {status => setStatus(() => status)}
                              />
                              : 
                              seedPhoto === null ?    // http://18.116.234.21:5001/seedImages/
                              <View style={styles.imageMountainSeed} >
                                          <Foundation 
                                                      name="mountains" 
                                                      size={182} 
                                                      color={colors.medium} />
                              </View>
                              :
                              String(seedPhoto).includes('.png') ?
                              <ImageCache
                                  style={styles.imageSeed}
                                  preview={{ uri: webUrl + seedPhoto }}
                                  tint="light"
                                  uri= { webUrl + seedPhoto }
                              /> 
                              :
                              <ImageCache
                                  style={styles.imageSeed}
                                  preview={{ uri: webUrl + seedPhoto }}
                                  tint="light"
                                  uri= { webUrl + seedPhoto }
                              />   
                              :  
                              // Este Image que viene no lo pude quitar porque sino me da un error :(
                             <ImageCache         
                             />      
                        
                          } 
              
                   
                  </TouchableOpacity>
                  </View> 
                    
                    <View style={styles.treeFollowersIconsContainer} >
                        <View  >
                            <Text style={styles.treeSeed} numberOfLines={1} >
                              <Entypo name={"tree"}
                                          //color={colors.medium} 
                                          color={colors.green} 
                                          size={30} 
                                  />                
                              </Text> 
                             <Text style={styles.numbersActionsFollowers} > 1,000 </Text>
                         </View>    
                         <View style={styles.treeFollowersIconsContainer} >
                            <Text style={styles.textFollowers} > Followers </Text>   
                            <Text style={styles.numbersFollowers} > { followers } </Text>  
                         </View>
                         <View style={styles.ContainerButtonEdit}>
                           {
                             foundUserChecker === "off" ?  //true?      //route.params.foundUserChecker === "off" ?
                            <TouchableOpacity  style={styles.buttonEdit}
                                                onPress={ () => 
                                                  updateInfo()
                                                  } >
                                <Text style={styles.textEdit}>
                                  Save
                                </Text>
                              </TouchableOpacity>
                            :
                                statusFollowed ===  1 ?
                                <TouchableOpacity  
                                  style={styles.buttonEdit}
                                  // onPress={ () => 
                                  //   onPressUnFollow()
                                  // }
                                >
                               <Text style={styles.textEdit}>
                                   Unfollow
                               </Text>
                               </TouchableOpacity> 
                            :
                               <TouchableOpacity  
                                  style={styles.buttonEdit}
                                  onPress={ () => 
                                    onPressFollow()
                                  } 
                                >
                                <Text style={styles.textEdit}>
                                  Follow
                                </Text>
                              </TouchableOpacity> 
                           }                     
                          </View>     
                    </View>         
              
              </View>
              {/* Aqui termina View de imagen y followers */}
              
                    {/* </TouchableOpacity> */}
                    <View style={styles.viewDescription}>
                                      <TextInput style={styles.input}
                                      onChangeText = {text => setDescriptionBoxText(text)}
                                      value = {descriptionBoxText}
                                      multiline = {true}
                                      />
                  </View>
              </View>

  );
  

  // S E E D  A C T I O N 7 <===  Ramificar
  case 7:   
  return (
    <View >
              <View style={ typeActionSelect === 0 ? styles.seedTitle :
                            typeActionSelect === 1 ? styles.seedTitle1 :
                            typeActionSelect === 2 ? styles.seedTitle2 :
                            typeActionSelect === 3 ? styles.seedTitle3 :
                            typeActionSelect === 4 ? styles.seedTitle4 :
                            typeActionSelect === 5 ? styles.seedTitle5 :
                            typeActionSelect === 6 ? styles.seedTitle6 :
                            typeActionSelect === 7 ? styles.seedTitle7 :
                            typeActionSelect === 8 ? styles.seedTitle8 :
                            styles.seedTitle9
                             }>

                          <Text style={styles.titleSeedDate} > Creada el:  { seedDate } </Text>

                            {
                              uploadVisible === true ?
                              <View style={typeActionSelect === 1 ? styles.ViewflatlistTypeAction1:
                                           typeActionSelect === 2 ? styles.ViewflatlistTypeAction2:
                                           typeActionSelect === 3 ? styles.ViewflatlistTypeAction3:
                                           typeActionSelect === 4 ? styles.ViewflatlistTypeAction4:
                                           typeActionSelect === 5 ? styles.ViewflatlistTypeAction5:
                                           typeActionSelect === 6 ? styles.ViewflatlistTypeAction6:
                                           typeActionSelect === 7 ? styles.ViewflatlistTypeAction7:
                                           typeActionSelect === 8 ? styles.ViewflatlistTypeAction8:
                                           styles.ViewflatlistTypeAction9
                              }>
                              <FlatList
                                data={menuItems}
                                keyExtractor={(menuItem) => menuItem.typeActionsId.toString()}
                                ItemSeparatorComponent={ListItemSeparator}
                                renderItem={({ item, index }) => (
                                  <CardListTypeActions
                                    title ={item.typeActionsDesc}
                                    IconComponent={
                                      <Icon
                                        iconFamily={item.iconFamily}
                                        name={item.icon}
                                        size ={35}      //{item.size}
                                        backgroundColor={item.backgroundColor}
                                      />
                                    }
                                    onPress={() =>{ 
                                      typeActionSelect = menuItems[index].typeNum
                                      console.log("typeActionSelect==> ", typeActionSelect)
                                      setUploadVisible(false)
                                    }}
                                  />
                                )}
                              />
                              <Text style={styles.Cancel}
                              onPress={() =>{ 
                                setUploadVisible(false)
                              }}>Cancel</Text>
                              </View>
                              :
                              null
                            } 

             
                            {
                            typeActionSelect === 0 ?   <Text style={styles.titleSeed} >Tipo de acción: Semilla </Text>:
                            typeActionSelect === 1 ?   <Text style={styles.titleSeed} 
                                                onPress={() => {
                                                  uploadVisible === false ?
                                                    setUploadVisible(true)
                                                    :
                                                    setUploadVisible(false)
                                                }}
                                           >Tipo de acción: Información </Text>:                            
                            typeActionSelect === 2 ?   <Text style={styles.titleSeed} 
                                                onPress={() => {
                                                  uploadVisible === false ?
                                                    setUploadVisible(true)
                                                    :
                                                    setUploadVisible(false)
                                                }}
                                           >Tipo de acción: Idea </Text>:                            
                            typeActionSelect === 3 ?   <Text style={styles.titleSeed} 
                                                onPress={() => {
                                                  uploadVisible === false ?
                                                    setUploadVisible(true)
                                                    :
                                                    setUploadVisible(false)
                                                }}
                                                >Tipo de acción: Plan </Text>:
                            typeActionSelect === 4 ?   <Text style={styles.titleSeed} 
                                                onPress={() => {
                                                  uploadVisible === false ?
                                                    setUploadVisible(true)
                                                    :
                                                    setUploadVisible(false)
                                                }}
                                                >Tipo de acción: Realizar </Text>:
                            typeActionSelect === 5 ?   <Text style={styles.titleSeed}
                                                onPress={() => {
                                                  uploadVisible === false ?
                                                    setUploadVisible(true)
                                                    :
                                                    setUploadVisible(false)
                                                }}
                                                >Tipo de acción: Invitar </Text>:
                            typeActionSelect === 6 ?   <Text style={styles.titleSeed} 
                                                onPress={() => {
                                                  uploadVisible === false ?
                                                    setUploadVisible(true)
                                                    :
                                                    setUploadVisible(false)
                                                }}
                                                >Tipo de acción: Disfrutar </Text>:
                            typeActionSelect === 7 ?   <Text style={styles.titleSeed} 
                                                onPress={() => {
                                                  uploadVisible === false ?
                                                    setUploadVisible(true)
                                                    :
                                                    setUploadVisible(false)
                                                }}
                                                >Tipo de acción: Ramificar </Text>:
                            typeActionSelect === 8 ?   <Text style={styles.titleSeed} 
                                                onPress={() => {
                                                  uploadVisible === false ?
                                                    setUploadVisible(true)
                                                    :
                                                    setUploadVisible(false)
                                                }}
                                                >Tipo de acción: Requerimiento </Text>:
                              <Text style={styles.titleSeed} 
                                                onPress={() => {
                                                  uploadVisible === false ?
                                                    setUploadVisible(true)
                                                    :
                                                    setUploadVisible(false)
                                                }}
                                                >Tipo de acción: Donar</Text> 
                             }
                             
                  { 
                    changeListing ?   
                    <View>   
                    <TextInput style={styles.inputName}
                                      onChangeText = {text => setTitleBoxText(text)}
                                      value = {titleBoxText}
                                      multiline = {true}
                                      /> 
                   </View>
                   :
                   <View>
               {/* Prueba con filtroListing sábado 7 agosto 2021      */}
                  <Text style={styles.titleSeed} numberOfLines={2}> {seedName}</Text>
                   <Text style={styles.titleSeed} >Type { type}</Text>
                   <Text style={styles.titleSeed} >Seed Id { seedId}</Text>
                   <Text style={styles.titleSeed} >Origin {  origin}</Text>
                   
                   </View>
                  }
               
                  
                  {
                     //lógica para documentos 
                          String(documentSeed).includes('.mp4') ?
                         <Video 
                            ref = {video}
                            style = {styles.imageVideoSeed}
                            source = {{ uri: seedVideoUri + documentSeed }}
                            useNativeControls
                            resizeMode = "contain"
                            isLooping
                            onPlaybackStatusUpdate = {status => setStatus(() => status)}
                         />
                          : 
                          String(documentSeed).includes('.pdf') ?
                          <Foundation
                                    onPress = { () => retriveDoc()}
                                    name={"page-export-pdf"}
                                    size={50}
                                    color={colors.lemonGreen}
                                    style={styles.icon}
                          /> 
                          : 
                          String(documentSeed).includes('.avi') ?
                          <Video
                                ref={video}
                                style  ={styles.imageVideoSeed}
                                source = {{ uri: seedVideoUri + documentSeed }}                       
                                useNativeControls
                                resizeMode="contain"
                                isLooping
                                onPlaybackStatusUpdate={status => setStatus(() => status)}
                          /> 
                          : 
                          String(documentSeed).includes('.mov') ?
                          <Video
                                ref={video}
                                style  ={styles.imageVideoSeed}
                                source = {{ uri: seedVideoUri + documentSeed }}                       
                                useNativeControls
                                resizeMode="contain"
                                isLooping
                                onPlaybackStatusUpdate={status => setStatus(() => status)}
                          /> 
                          : 
                          String(documentSeed) === '' ?
                          null
                          :
                          String(documentSeed).includes('.xls') ?
                          <MaterialCommunityIcons
                              onPress = { () => retriveDoc()}
                              name={"file-excel"}
                              size={50}
                              color={colors.lemonGreen}
                              style={styles.icon}
                          /> 
                          :
                          String(documentSeed).includes('.xlxs') ?
                          <MaterialCommunityIcons
                              onPress = { () => retriveDoc()}
                              name={"file-excel"}
                              size={50}
                              color={colors.lemonGreen}
                              style={styles.icon}
                          /> 
                          :  
                           null                 
                        }
              {/* 1. primer View </View>  */}
              </View>
              
              {/* Aqui empieza View de Imagen y Follores */}
              <View style={styles.detailsContainerSeed}> 
                  <View >
                  <TouchableOpacity  onPress = {selectImage}>
                  {imageUri != '' ? 
                                
                                  
                                 String(imageUri).includes('.mp4') ?
                                   <Video 
                                      ref = {video}
                                      style = {styles.imageSeed}
                                      source = {{ uri: imageUri }}
                                      useNativeControls
                                      resizeMode = "contain"
                                      isLooping
                                      onPlaybackStatusUpdate = {status => setStatus(() => status)}
                                   />
                                  :
                                  String(imageUri).includes('.mov') ?
                                  <Video 
                                      ref = {video}
                                      style = {styles.imageSeed}
                                      source = {{ uri: imageUri }}
                                      useNativeControls
                                      resizeMode = "contain"
                                      isLooping
                                      onPlaybackStatusUpdate = {status => setStatus(() => status)}
                                  />
                                  : 
                                  imageUri === null ?    // http://18.116.234.21:5001/seedImages/
                                  <View style={styles.imageMountainSeed} >
                                              <Foundation 
                                                          name="mountains" 
                                                          size={182} 
                                                          color={colors.medium} />
                                  </View>
                                  :
                                  String(imageUri).includes('.jpg') ?
                                   
                                  <Image style={styles.imageSeed} source={{uri: imageUri} } />
                                  : String(imageUri).includes('.png') ?
                                     
                                  <Image style={styles.imageSeed} source={{uri: imageUri} } />
                                  :  
                                       
                                <Image style={styles.imageSeed} source={{uri: imageUri} } />
                          :
                            
                            true ?  
                             String(seedPhoto).includes('.mp4') ?
                               <Video 
                                  ref = {video}
                                  style = {styles.imageSeed}
                                  source = {{ uri: seedVideoUri + seedPhoto }}
                                  useNativeControls
                                  resizeMode = "contain"
                                  isLooping
                                  onPlaybackStatusUpdate = {status => setStatus(() => status)}
                               />
                              :
                              String(seedPhoto).includes('.mov') ?
                              <Video 
                                  ref = {video}
                                  style = {styles.imageSeed}
                                  source = {{ uri: seedVideoUri + seedPhoto }}
                                  useNativeControls
                                  resizeMode = "contain"
                                  isLooping
                                  onPlaybackStatusUpdate = {status => setStatus(() => status)}
                              />
                              : 
                              seedPhoto === null ?    // http://18.116.234.21:5001/seedImages/
                              <View style={styles.imageMountainSeed} >
                                          <Foundation 
                                                      name="mountains" 
                                                      size={182} 
                                                      color={colors.medium} />
                              </View>
                              :
                              String(seedPhoto).includes('.png') ?
                              <ImageCache
                                  style={styles.imageSeed}
                                  preview={{ uri: webUrl + seedPhoto }}
                                  tint="light"
                                  uri= { webUrl + seedPhoto }
                              /> 
                              :
                              <ImageCache
                                  style={styles.imageSeed}
                                  preview={{ uri: webUrl + seedPhoto }}
                                  tint="light"
                                  uri= { webUrl + seedPhoto }
                              />   
                              :  
                              // Este Image que viene no lo pude quitar porque sino me da un error :(
                             <ImageCache         
                             />      
                        
                          } 
              
                   
                  </TouchableOpacity>
                  </View> 
                    
                    <View style={styles.treeFollowersIconsContainer} >
                        <View  >
                            <Text style={styles.treeSeed} numberOfLines={1} >
                              <Entypo name={"tree"}
                                          //color={colors.medium} 
                                          color={colors.green} 
                                          size={30} 
                                  />                
                              </Text> 
                             <Text style={styles.numbersActionsFollowers} > 1,000 </Text>
                         </View>    
                         <View style={styles.treeFollowersIconsContainer} >
                            <Text style={styles.textFollowers} > Followers </Text>   
                            <Text style={styles.numbersFollowers} > { followers } </Text>  
                         </View>
                         <View style={styles.ContainerButtonEdit}>
                           {
                             foundUserChecker === "off" ?  //true?      //route.params.foundUserChecker === "off" ?
                            <TouchableOpacity  style={styles.buttonEdit}
                                                onPress={ () => 
                                                  updateInfo()
                                                  } >
                                <Text style={styles.textEdit}>
                                  Save
                                </Text>
                              </TouchableOpacity>
                            :
                                statusFollowed ===  1 ?
                                <TouchableOpacity  
                                  style={styles.buttonEdit}
                                  // onPress={ () => 
                                  //   onPressUnFollow()
                                  // }
                                >
                               <Text style={styles.textEdit}>
                                   Unfollow
                               </Text>
                               </TouchableOpacity> 
                            :
                               <TouchableOpacity  
                                  style={styles.buttonEdit}
                                  onPress={ () => 
                                    onPressFollow()
                                  } 
                                >
                                <Text style={styles.textEdit}>
                                  Follow
                                </Text>
                              </TouchableOpacity> 
                           }                     
                          </View>     
                    </View>         
              
              </View>
              {/* Aqui termina View de imagen y followers */}
              
                    {/* </TouchableOpacity> */}
                    <View style={styles.viewDescription}>
                                      <TextInput style={styles.input}
                                      onChangeText = {text => setDescriptionBoxText(text)}
                                      value = {descriptionBoxText}
                                      multiline = {true}
                                      />
                  </View>
              </View>

  );
  
  // "8"  N O T A  ======> S E E D   A C T I O N 8  <=== Porque era acción de requerimiento y eso sólo ira en componente.

   // S E E D  A C T I O N 8 <===  Donar
   case 9:   
   return (
     <View >
               <View style={ typeActionSelect === 0 ? styles.seedTitle :
                             typeActionSelect === 1 ? styles.seedTitle1 :
                             typeActionSelect === 2 ? styles.seedTitle2 :
                             typeActionSelect === 3 ? styles.seedTitle3 :
                             typeActionSelect === 4 ? styles.seedTitle4 :
                             typeActionSelect === 5 ? styles.seedTitle5 :
                             typeActionSelect === 6 ? styles.seedTitle6 :
                             typeActionSelect === 7 ? styles.seedTitle7 :
                             typeActionSelect === 8 ? styles.seedTitle8 :
                             styles.seedTitle9
                              }>
 
                           <Text style={styles.titleSeedDate} > Creada el:  { seedDate } </Text>
 
                             {
                               uploadVisible === true ?
                               <View style={typeActionSelect === 1 ? styles.ViewflatlistTypeAction1:
                                            typeActionSelect === 2 ? styles.ViewflatlistTypeAction2:
                                            typeActionSelect === 3 ? styles.ViewflatlistTypeAction3:
                                            typeActionSelect === 4 ? styles.ViewflatlistTypeAction4:
                                            typeActionSelect === 5 ? styles.ViewflatlistTypeAction5:
                                            typeActionSelect === 6 ? styles.ViewflatlistTypeAction6:
                                            typeActionSelect === 7 ? styles.ViewflatlistTypeAction7:
                                            typeActionSelect === 8 ? styles.ViewflatlistTypeAction8:
                                            styles.ViewflatlistTypeAction9
                               }>
                               <FlatList
                                 data={menuItems}
                                 keyExtractor={(menuItem) => menuItem.typeActionsId.toString()}
                                 ItemSeparatorComponent={ListItemSeparator}
                                 renderItem={({ item, index }) => (
                                   <CardListTypeActions
                                     title ={item.typeActionsDesc}
                                     IconComponent={
                                       <Icon
                                         iconFamily={item.iconFamily}
                                         name={item.icon}
                                         size ={35}      //{item.size}
                                         backgroundColor={item.backgroundColor}
                                       />
                                     }
                                     onPress={() =>{ 
                                       typeActionSelect = menuItems[index].typeNum
                                       console.log("typeActionSelect==> ", typeActionSelect)
                                       setUploadVisible(false)
                                     }}
                                   />
                                 )}
                               />
                               <Text style={styles.Cancel}
                               onPress={() =>{ 
                                 setUploadVisible(false)
                               }}>Cancel</Text>
                               </View>
                               :
                               null
                             } 
 
              
                             {
                             typeActionSelect === 0 ?   <Text style={styles.titleSeed} >Tipo de acción: Semilla </Text>:
                             typeActionSelect === 1 ?   <Text style={styles.titleSeed} 
                                                 onPress={() => {
                                                   uploadVisible === false ?
                                                     setUploadVisible(true)
                                                     :
                                                     setUploadVisible(false)
                                                 }}
                                            >Tipo de acción: Información </Text>:                            
                             typeActionSelect === 2 ?   <Text style={styles.titleSeed} 
                                                 onPress={() => {
                                                   uploadVisible === false ?
                                                     setUploadVisible(true)
                                                     :
                                                     setUploadVisible(false)
                                                 }}
                                            >Tipo de acción: Idea </Text>:                            
                             typeActionSelect === 3 ?   <Text style={styles.titleSeed} 
                                                 onPress={() => {
                                                   uploadVisible === false ?
                                                     setUploadVisible(true)
                                                     :
                                                     setUploadVisible(false)
                                                 }}
                                                 >Tipo de acción: Plan </Text>:
                             typeActionSelect === 4 ?   <Text style={styles.titleSeed} 
                                                 onPress={() => {
                                                   uploadVisible === false ?
                                                     setUploadVisible(true)
                                                     :
                                                     setUploadVisible(false)
                                                 }}
                                                 >Tipo de acción: Realizar </Text>:
                             typeActionSelect === 5 ?   <Text style={styles.titleSeed}
                                                 onPress={() => {
                                                   uploadVisible === false ?
                                                     setUploadVisible(true)
                                                     :
                                                     setUploadVisible(false)
                                                 }}
                                                 >Tipo de acción: Invitar </Text>:
                             typeActionSelect === 6 ?   <Text style={styles.titleSeed} 
                                                 onPress={() => {
                                                   uploadVisible === false ?
                                                     setUploadVisible(true)
                                                     :
                                                     setUploadVisible(false)
                                                 }}
                                                 >Tipo de acción: Disfrutar </Text>:
                             typeActionSelect === 7 ?   <Text style={styles.titleSeed} 
                                                 onPress={() => {
                                                   uploadVisible === false ?
                                                     setUploadVisible(true)
                                                     :
                                                     setUploadVisible(false)
                                                 }}
                                                 >Tipo de acción: Ramificar </Text>:
                             typeActionSelect === 8 ?   <Text style={styles.titleSeed} 
                                                 onPress={() => {
                                                   uploadVisible === false ?
                                                     setUploadVisible(true)
                                                     :
                                                     setUploadVisible(false)
                                                 }}
                                                 >Tipo de acción: Requerimiento </Text>:
                               <Text style={styles.titleSeed} 
                                                 onPress={() => {
                                                   uploadVisible === false ?
                                                     setUploadVisible(true)
                                                     :
                                                     setUploadVisible(false)
                                                 }}
                                                 >Tipo de acción: Donar</Text> 
                              }
                              
                   { 
                     changeListing ?   
                     <View>   
                     <TextInput style={styles.inputName}
                                       onChangeText = {text => setTitleBoxText(text)}
                                       value = {titleBoxText}
                                       multiline = {true}
                                       /> 
                    </View>
                    :
                    <View>
                {/* Prueba con filtroListing sábado 7 agosto 2021      */}
                   <Text style={styles.titleSeed} numberOfLines={2}> {seedName}</Text>
                    <Text style={styles.titleSeed} >Type { type}</Text>
                    <Text style={styles.titleSeed} >Seed Id { seedId}</Text>
                    <Text style={styles.titleSeed} >Origin {  origin}</Text>
                    
                    </View>
                   }
                
                   
                   {
                      //lógica para documentos 
                           String(documentSeed).includes('.mp4') ?
                          <Video 
                             ref = {video}
                             style = {styles.imageVideoSeed}
                             source = {{ uri: seedVideoUri + documentSeed }}
                             useNativeControls
                             resizeMode = "contain"
                             isLooping
                             onPlaybackStatusUpdate = {status => setStatus(() => status)}
                          />
                           : 
                           String(documentSeed).includes('.pdf') ?
                           <Foundation
                                     onPress = { () => retriveDoc()}
                                     name={"page-export-pdf"}
                                     size={50}
                                     color={colors.lemonGreen}
                                     style={styles.icon}
                           /> 
                           : 
                           String(documentSeed).includes('.avi') ?
                           <Video
                                 ref={video}
                                 style  ={styles.imageVideoSeed}
                                 source = {{ uri: seedVideoUri + documentSeed }}                       
                                 useNativeControls
                                 resizeMode="contain"
                                 isLooping
                                 onPlaybackStatusUpdate={status => setStatus(() => status)}
                           /> 
                           : 
                           String(documentSeed).includes('.mov') ?
                           <Video
                                 ref={video}
                                 style  ={styles.imageVideoSeed}
                                 source = {{ uri: seedVideoUri + documentSeed }}                       
                                 useNativeControls
                                 resizeMode="contain"
                                 isLooping
                                 onPlaybackStatusUpdate={status => setStatus(() => status)}
                           /> 
                           : 
                           String(documentSeed) === '' ?
                           null
                           :
                           String(documentSeed).includes('.xls') ?
                           <MaterialCommunityIcons
                               onPress = { () => retriveDoc()}
                               name={"file-excel"}
                               size={50}
                               color={colors.lemonGreen}
                               style={styles.icon}
                           /> 
                           :
                           String(documentSeed).includes('.xlxs') ?
                           <MaterialCommunityIcons
                               onPress = { () => retriveDoc()}
                               name={"file-excel"}
                               size={50}
                               color={colors.lemonGreen}
                               style={styles.icon}
                           /> 
                           :  
                            null                 
                         }
               {/* 1. primer View </View>  */}
               </View>
               
               {/* Aqui empieza View de Imagen y Follores */}
               <View style={styles.detailsContainerSeed}> 
                   <View >
                   <TouchableOpacity  onPress = {selectImage}>
                   {imageUri != '' ? 
                                 
                                   
                                  String(imageUri).includes('.mp4') ?
                                    <Video 
                                       ref = {video}
                                       style = {styles.imageSeed}
                                       source = {{ uri: imageUri }}
                                       useNativeControls
                                       resizeMode = "contain"
                                       isLooping
                                       onPlaybackStatusUpdate = {status => setStatus(() => status)}
                                    />
                                   :
                                   String(imageUri).includes('.mov') ?
                                   <Video 
                                       ref = {video}
                                       style = {styles.imageSeed}
                                       source = {{ uri: imageUri }}
                                       useNativeControls
                                       resizeMode = "contain"
                                       isLooping
                                       onPlaybackStatusUpdate = {status => setStatus(() => status)}
                                   />
                                   : 
                                   imageUri === null ?    // http://18.116.234.21:5001/seedImages/
                                   <View style={styles.imageMountainSeed} >
                                               <Foundation 
                                                           name="mountains" 
                                                           size={182} 
                                                           color={colors.medium} />
                                   </View>
                                   :
                                   String(imageUri).includes('.jpg') ?
                                    
                                   <Image style={styles.imageSeed} source={{uri: imageUri} } />
                                   : String(imageUri).includes('.png') ?
                                      
                                   <Image style={styles.imageSeed} source={{uri: imageUri} } />
                                   :  
                                        
                                 <Image style={styles.imageSeed} source={{uri: imageUri} } />
                           :
                             
                             true ?  
                              String(seedPhoto).includes('.mp4') ?
                                <Video 
                                   ref = {video}
                                   style = {styles.imageSeed}
                                   source = {{ uri: seedVideoUri + seedPhoto }}
                                   useNativeControls
                                   resizeMode = "contain"
                                   isLooping
                                   onPlaybackStatusUpdate = {status => setStatus(() => status)}
                                />
                               :
                               String(seedPhoto).includes('.mov') ?
                               <Video 
                                   ref = {video}
                                   style = {styles.imageSeed}
                                   source = {{ uri: seedVideoUri + seedPhoto }}
                                   useNativeControls
                                   resizeMode = "contain"
                                   isLooping
                                   onPlaybackStatusUpdate = {status => setStatus(() => status)}
                               />
                               : 
                               seedPhoto === null ?    // http://18.116.234.21:5001/seedImages/
                               <View style={styles.imageMountainSeed} >
                                           <Foundation 
                                                       name="mountains" 
                                                       size={182} 
                                                       color={colors.medium} />
                               </View>
                               :
                               String(seedPhoto).includes('.png') ?
                               <ImageCache
                                   style={styles.imageSeed}
                                   preview={{ uri: webUrl + seedPhoto }}
                                   tint="light"
                                   uri= { webUrl + seedPhoto }
                               /> 
                               :
                               <ImageCache
                                   style={styles.imageSeed}
                                   preview={{ uri: webUrl + seedPhoto }}
                                   tint="light"
                                   uri= { webUrl + seedPhoto }
                               />   
                               :  
                               // Este Image que viene no lo pude quitar porque sino me da un error :(
                              <ImageCache         
                              />      
                         
                           } 
               
                    
                   </TouchableOpacity>
                   </View> 
                     
                     <View style={styles.treeFollowersIconsContainer} >
                         <View  >
                             <Text style={styles.treeSeed} numberOfLines={1} >
                               <Entypo name={"tree"}
                                           //color={colors.medium} 
                                           color={colors.green} 
                                           size={30} 
                                   />                
                               </Text> 
                              <Text style={styles.numbersActionsFollowers} > 1,000 </Text>
                          </View>    
                          <View style={styles.treeFollowersIconsContainer} >
                             <Text style={styles.textFollowers} > Followers </Text>   
                             <Text style={styles.numbersFollowers} > { followers } </Text>  
                          </View>
                          <View style={styles.ContainerButtonEdit}>
                            {
                              foundUserChecker === "off" ?  //true?      //route.params.foundUserChecker === "off" ?
                             <TouchableOpacity  style={styles.buttonEdit}
                                                 onPress={ () => 
                                                   updateInfo()
                                                   } >
                                 <Text style={styles.textEdit}>
                                   Save
                                 </Text>
                               </TouchableOpacity>
                             :
                                 statusFollowed ===  1 ?
                                 <TouchableOpacity  
                                   style={styles.buttonEdit}
                                   // onPress={ () => 
                                   //   onPressUnFollow()
                                   // }
                                 >
                                <Text style={styles.textEdit}>
                                    Unfollow
                                </Text>
                                </TouchableOpacity> 
                             :
                                <TouchableOpacity  
                                   style={styles.buttonEdit}
                                   onPress={ () => 
                                     onPressFollow()
                                   } 
                                 >
                                 <Text style={styles.textEdit}>
                                   Follow
                                 </Text>
                               </TouchableOpacity> 
                            }                     
                           </View>     
                     </View>         
               
               </View>
               {/* Aqui termina View de imagen y followers */}
               
                     {/* </TouchableOpacity> */}
                     <View style={styles.viewDescription}>
                                       <TextInput style={styles.input}
                                       onChangeText = {text => setDescriptionBoxText(text)}
                                       value = {descriptionBoxText}
                                       multiline = {true}
                                       />
                   </View>
               </View>
 
   );
   
  
  // Add text  <===  L I S T O !!
  case 33:
    return (
      <>
      <View 
      style={ keyboardVisible === false ? styles.viewContent4 :
                    keyboardVisible === true ? styles.viewContent4Keyboard :
                    styles.viewContent4
                  }>
      

        <View style={styles.ContainerButtonSaveForEdition}>
              <TouchableOpacity  style={styles.buttonSaveForEdition}
                                 onPress={ () => 
                                 updateInfo()
                                  } >
                  <Text style={styles.textEdit}>
                    Save
                  </Text>
              </TouchableOpacity>
        </View>

      <Text style={styles.Title} > SeedOrder:  { seedOrder } </Text>  
      <Text style={styles.Title} > Creada el:  { dateFormated } </Text>
      <Text style={styles.Title} numberOfLines={1}> Type:  {type}  {seedId} </Text>

 {keyboardVisible === false ?
             <KeyboardAvoidingView 
                    keyboardVerticalOffset={1} 
                    behavior={Platform.OS == 'ios' ? 'floating' : 'height'}
                    style={styles.container}
             > 

        <View style={styles.detailsContainer}>
            <TextInput style={styles.input}
                onChangeText = {text => setTitleBoxText(text)}
                value = {titleBoxText}
                multiline = {true}
                /> 
            <TextInput style={styles.input}
                      onChangeText = {text => setDescriptionBoxText(text)}
                      value = {descriptionBoxText}
                      multiline = {true}
                      />
      </View>
      </KeyboardAvoidingView>
       : 
       <KeyboardAvoidingView 
                    keyboardVerticalOffset={1} 
                    behavior={Platform.OS == 'ios' ? 'padding' : 'height'}
                    style={styles.container}
             > 
        <View style={styles.detailsContainerIos34}>
            <TextInput style={styles.input}
                onChangeText = {text => setTitleBoxText(text)}
                value = {titleBoxText}
                multiline = {true}
                //scrollEnabled = {true}
                />
            <TextInput style={styles.input}
                      onChangeText = {text => setDescriptionBoxText(text)}
                      value = {descriptionBoxText}
                      multiline = {true}
                      />
         </View>
      </KeyboardAvoidingView>
      } 
      </View>
   </>  
  );
  
  
  // Add document <==================  SOLO F A L T A QUE NO TRUENE AL HACER GRANDE LOS ARCHIVOS EN EXCELL 5 SEP 2021 
  case 34:
    return (
      <ScrollView style={styles.viewContent4}>
         <View style={styles.viewContent4}>
            <View style={styles.ContainerButtonSaveForEdition}>
              <TouchableOpacity  style={styles.buttonSaveForEdition}
                                 onPress={ () => 
                                 updateInfo()
                                 } >
                  <Text style={styles.textEdit}>
                    Save
                  </Text>
              </TouchableOpacity>
          </View>
            <Text style={styles.Title} > SeedOrder:  { seedOrder } </Text>  
            <Text style={styles.Title} > Creada el:  { dateFormated } </Text>
            <Text style={styles.Title} numberOfLines={1}> Type:  {type}  {seedId} </Text>  

            <View style={styles.detailsContainer}>
                <View style={styles.detailsContainer}>
                  <TextInput style={styles.input}
                      onChangeText = {text => setTitleBoxText(text)}
                      value = {titleBoxText}
                      multiline = {true}
                      /> 
                  <TextInput style={styles.input}
                      onChangeText = {text => setDescriptionBoxText(text)}
                      value = {descriptionBoxText}
                      multiline = {true}
                      />
                </View>
            </View> 

          { 
          //nameDateDoc !== '' ?
          pickerFileRecipient === 'nothing' ?
          <TouchableOpacity style={nameDateDoc !== '' ? styles.iconDocsContent : styles.imageViewViewer}
                            onPress = {uploadDocument}>
              { 
                 filterDocumentSeed === ''?    // Esta opción es cuando se crea x primera vez! para que salga un letrero coqueto en vez de un fondo azul feo.
                 //<View  style={styles.imageViewViewer} >
                //  <WebView 
                //  source= {{ uri: infoDocumetUri + 'pdfSeeds/' + 'Letrero agrega doc.jpg' }} // Hay que mejorar este letrero.
                //  /> 
                <Text>
                  algo que WebView
                </Text>
                 //</View> 
                :
                pickerFile !== '' ?  // pickerFile
                  //<View  style={styles.imageViewViewer} >
                  // <WebView
                  // source= {{ uri: infoDocumetUri + 'pdfSeeds/' + 'Letrero doc anexado.jpg' }}
                  // /> 
                  <Text>
                  algo que WebView
                </Text>
                  //</View> 
                :
                 filterDocumentSeed.includes('.pdf')?
                 //<View  style={styles.imageViewViewer} >
                //  <WebView 
                //  source= {{ uri: infoDocumetUri + 'pdfSeeds/' + documentSeed }} 
                //  /> 
                <Text>
                  algo que WebView
                </Text>
                 //</View> 
               :
               filterDocumentSeed.includes('.xlx')?
                //<View  style={styles.imageViewViewer} >
                // <WebView 
                // source= {{ uri: infoDocumetUri + 'ExcellSeeds/' + documentSeed }} 
                // /> 
                <Text>
                  algo que WebView
                </Text>
                //</View> 
              :
              filterDocumentSeed.includes('.xlsx')?  
                //<View  style={styles.imageViewViewer} >
                // <WebView
                // source= {{ uri: infoDocumetUri + 'ExcellSeeds/' + documentSeed }}
                // /> 
                <Text>
                  algo que WebView
                </Text>
                //</View> 
              :
              pickerFileRecipient === 'nothing' ?
              <Feather 
              style={styles.image}
              onPress = {()=> uploadDocument()}
              name={"upload"}
              size={50}
              color={colors.medium}
              //style={styles.pdfIcon}         
              />
              :
              pickerFileRecipient === 'something' ?
              <Feather 
              style={styles.image}
              onPress = {()=> uploadDocument()}
              name={"check-circle"}
              size={50}
              color={colors.lemonGreen}
             // style={styles.pdfIcon}         
              />
              :
              null
              }
          </TouchableOpacity> 
      :
          <TouchableOpacity 
                            //style={nameDateDoc !== '' ? styles.iconDocsContent : styles.imageViewViewer}
                            style={styles.iconDocsContent}
                            onPress = {() =>{
                              uploadDocument()
                              //pickerFile = null
                            }
                          }>
                
                {/* documentSeed.includes('.pdf')?
                 //<View  style={styles.imageViewViewer} >
                 <WebView 
                 source= {{ uri: infoDocumetUri + 'pdfSeeds/' + documentSeed }} 
                 /> 
                 //</View> 
               : */}
                <Feather 
              style={styles.image}
              onPress = {()=> uploadDocument()}
              name={"check-circle"}
              size={50}
              color={colors.lemonGreen}
             // style={styles.pdfIcon}         
              />
            
          </TouchableOpacity>
        }
        
        {
          nameDateDoc !== '' ?
          <TouchableOpacity style={
                                   // pickerFileRecipient === 'nothing' ? styles.iconDocsContent : 
                                   nameDateDoc !== '' ? styles.imageViewViewer : 
                                  //  pickerFileRecipient === 'something' ? styles.imageViewViewer :
                                  //  pickerFileRecipient === 'something' ? null :
                                  styles.iconDocsContent }
                            onPress = {uploadDocument}>
              { 
                 filterDocumentSeed.includes('.pdf')?
                 //<View  style={styles.imageViewViewer} >
                //  <WebView 
                //  source= {{ uri: infoDocumetUri + 'pdfSeeds/' + documentSeed }} 
                //  /> 
                 //</View> 
                <Text>
                  algo que WebView
                </Text>
               :
                filterDocumentSeed.includes('.xlx')?
                //<View  style={styles.imageViewViewer} >
                // <WebView 
                // source= {{ uri: infoDocumetUri + 'ExcellSeeds/' + documentSeed }} 
                ///> 
                //</View> 
                <Text>
                  algo que WebView
                </Text>
              :
                filterDocumentSeed.includes('.xlsx')?
                //<View  style={styles.imageViewViewer} >
                //<WebView
                //source= {{ uri: infoDocumetUri + 'ExcellSeeds/' + documentSeed }}
               // /> 
                //</View> 
                <Text>
                  algo que WebView
                </Text>
              :
              pickerFileRecipient === 'nothing' ?
              <Feather 
              style={styles.image}
              onPress = {()=> uploadDocument()}
              name={"upload"}
              size={50}
              color={colors.medium}
             // style={styles.pdfIcon}         
              />
              :
              nameDateDoc !== '' ?
              <Feather 
              style={styles.image}
              onPress = {()=> uploadDocument()}
              name={"check-circle"}
              size={50}
              color={colors.lemonGreen}
             // style={styles.pdfIcon}         
              />
              :
              null
              }
          </TouchableOpacity> 
          :
          null
      }
      
      
          {/* <TouchableOpacity style={pickerFileRecipient === 'something' ? styles.iconDocsContent : null }
                            onPress = {uploadDocument}>
              { 
              pickerFileRecipient === 'something' ?
              <Feather 
              style={styles.image}
              onPress = {()=> uploadDocument()}
              name={"check-circle"}
              size={50}
              color={colors.lemonGreen}
              style={styles.pdfIcon}         
              />
              :
              null
              }
          </TouchableOpacity>  */}
          
          
          </View>
    </ScrollView>
  );
  
  
  // Add photo or Video  <===  L I S T O !!
  case 35:
    return (
      <View style={styles.viewContent5}>
            <Text style={styles.Title} > SeedOrder:  { seedOrder } </Text>  
            <Text style={styles.Title} > Creada el:  { dateFormated } </Text>
            <Text style={styles.Title} numberOfLines={1}> Type:  {type}  {seedId} </Text>  
           
{
                            typeActionSelect === 35 ?   <Text style={styles.titleSeed} 
                                                  onPress={() => {
                                                    listChooseArrange === false ?
                                                      setListChooseArrange(true)
                                                      :
                                                      setListChooseArrange(false)
                                                  }}
                                                    >Imagen al centro </Text>:
                            typeActionSelect === 36 ?   <Text style={styles.titleSeed} 
                                                onPress={() => {
                                                  listChooseArrange === false ?
                                                    setListChooseArrange(true)
                                                    :
                                                    setListChooseArrange(false)
                                                }}
                                           >Imagen a la derecha </Text>:                            
                            typeActionSelect === 37 ?   <Text style={styles.titleSeed} 
                                                onPress={() => {
                                                  listChooseArrange === false ?
                                                    setListChooseArrange(true)
                                                    :
                                                    setListChooseArrange(false)
                                                }}
                                           >Imagen a la izquierda </Text>:          
                                                    null
                             }

{
                              listChooseArrange === true ?
                              <View style={styles.ViewflatlistTypeAction}>
                              <FlatList
                                data={menuArrangePhotosComponent35}
                                keyExtractor={(item) => item.typeActionsId.toString()}
                                //ItemSeparatorComponent={ListItemSeparator}
                                renderItem={({ item, index }) => (
                                  <CardListTypeActions
                                    title ={item.title}
                                    backgroundColor = {item.background}
                                    IconComponent={
                                      <Icon
                                        iconFamily={item.iconFamily}
                                        name={item.icon}
                                        size ={35}      //{item.size}
                                        backgroundColor={item.backgroundColor}
                                      />
                                    }
                                    onPress={() =>{ 
                                      date = dateNow()
                                      newSeedDate = dateActions(date)
                                      typeActionSelect = menuArrangePhotosComponent35[index].typeActionsId
                                      console.log("typeActionSelect==> ", typeActionSelect)
                                      selectingArrangeImage(typeActionSelect)
                                    }}
                                  />
                                )}
                              />
                              <Text style={styles.ButtonCancel}
                              onPress={() =>{ 
                                setListChooseArrange(false)
                              }}>Regresar</Text>
                              </View>
                              :
                              null
                            }

<TouchableOpacity  onPress = {selectImage}>
                  {imageUri != '' ? 
                                 String(imageUri).includes('.mp4') ?
                                   <Video 
                                      ref = {video}
                                      style = {styles.image5}
                                      source = {{ uri: imageUri }}
                                      useNativeControls
                                      resizeMode = "stretch"  //"contain"
                                      isLooping
                                      onPlaybackStatusUpdate = {status => setStatus(() => status)}
                                   />
                                  :
                                  String(imageUri).includes('.mov') ?
                                  <Video 
                                      ref = {video}
                                      style = {styles.image5}
                                      source = {{ uri: imageUri }}
                                      useNativeControls
                                      resizeMode = "stretch"   //"contain"
                                      isLooping
                                      onPlaybackStatusUpdate = {status => setStatus(() => status)}
                                  />
                                  : 
                                  imageUri === null ?    // http://18.116.234.21:5001/seedImages/
                                  <View style={styles.imageMountainSeed} >
                                              <Foundation 
                                                          name="mountains" 
                                                          size={182} 
                                                          color={colors.medium} />
                                  </View>
                                  :
                                  String(imageUri).includes('.jpg') ?
                                  <Image style={styles.image5} 
                                         source={{uri: imageUri} } 
                                         resizeMode= "stretch"/>
                                  : String(imageUri).includes('.png') ?
                                  <Image style={styles.image5} 
                                         source={{uri: imageUri} } 
                                         resizeMode= "stretch"/>
                                  :  
                                <Image style={styles.image5} 
                                       source={{uri: imageUri} } 
                                       resizeMode= "stretch"/>
                          :
                            
                            true ?  
                             String(seedPhoto).includes('.mp4') ?
                               <Video 
                                  ref = {video}
                                  style = {styles.image5}
                                  source = {{ uri: seedVideoUri + seedPhoto }}
                                  useNativeControls
                                  resizeMode = "stretch"   //"contain"
                                  isLooping
                                  onPlaybackStatusUpdate = {status => setStatus(() => status)}
                               />
                              :
                              String(seedPhoto).includes('.mov') ?
                              <Video 
                                  ref = {video}
                                  style = {styles.image5}
                                  source = {{ uri: seedVideoUri + seedPhoto }}
                                  useNativeControls
                                  resizeMode = "stretch" //"contain"
                                  isLooping
                                  onPlaybackStatusUpdate = {status => setStatus(() => status)}
                              />
                              : 
                              seedPhoto === null ?    // http://18.116.234.21:5001/seedImages/
                              <View style={styles.imageMountainSeed} >
                                          <Foundation 
                                                      name="mountains" 
                                                      size={182} 
                                                      color={colors.medium} />
                              </View>
                              :
                              String(seedPhoto).includes('.png') ?
                              <ImageCache
                                  style={styles.image5}
                                  preview={{ uri: webUrl + seedPhoto }}
                                  tint="light"
                                  uri= { webUrl + seedPhoto }
                              /> 
                              :
                              <ImageCache
                                  style={styles.image5}
                                  preview={{ uri: webUrl + seedPhoto }}
                                  tint="light"
                                  uri= { webUrl + seedPhoto }
                                  //resizeMode= "cover"
                              />   
                              :  
                              // Este Image que viene no lo pude quitar porque sino me da un error :(
                             <ImageCache         
                             />      
                          } 
                  </TouchableOpacity>

          <View style={styles.detailsContainer}>
                  <TextInput style={styles.input}
                      onChangeText = {text => setTitleBoxText(text)}
                      value = {titleBoxText}
                      multiline = {true}
                      /> 
                  <TextInput style={styles.input}
                      onChangeText = {text => setDescriptionBoxText(text)}
                      value = {descriptionBoxText}
                      multiline = {true}
                      />
          </View>
          <View style={styles.ContainerButtonSaveForEdition}>
              <TouchableOpacity  style={styles.buttonSaveForEdition}
                                 onPress={ () => 
                                 updateInfo()
                                 } >
                  <Text style={styles.textEdit}>
                    Save
                  </Text>
              </TouchableOpacity>
          </View>
    </View>
  );
 
  
  // Add text left photo right  <===  L I S T O!!
  case 36:
  return (
<View style={styles.viewContent6}>
                <Text style={styles.title} > Creada el:  { dateFormated } </Text>
                <Text style={styles.title} numberOfLines={1}> Type:  {type} </Text>

                {
                            typeActionSelect === 35 ?   <Text style={styles.titleSeed} 
                                                  onPress={() => {
                                                    listChooseArrange === false ?
                                                      setListChooseArrange(true)
                                                      :
                                                      setListChooseArrange(false)
                                                  }}
                                                    >Imagen al centro </Text>:
                            typeActionSelect === 36 ?   <Text style={styles.titleSeed} 
                                                onPress={() => {
                                                  listChooseArrange === false ?
                                                    setListChooseArrange(true)
                                                    :
                                                    setListChooseArrange(false)
                                                }}
                                           >Imagen a la derecha </Text>:                            
                            typeActionSelect === 37 ?   <Text style={styles.titleSeed} 
                                                onPress={() => {
                                                  listChooseArrange === false ?
                                                    setListChooseArrange(true)
                                                    :
                                                    setListChooseArrange(false)
                                                }}
                                           >Imagen a la izquierda </Text>:          
                                                    null
                             }

{
                              listChooseArrange === true ?
                              <View style={styles.ViewflatlistTypeAction}>
                              <FlatList
                                data={menuArrangePhotosComponent35}
                                keyExtractor={(item) => item.typeActionsId.toString()}
                                //ItemSeparatorComponent={ListItemSeparator}
                                renderItem={({ item, index }) => (
                                  <CardListTypeActions
                                    title ={item.title}
                                    backgroundColor = {item.background}
                                    IconComponent={
                                      <Icon
                                        iconFamily={item.iconFamily}
                                        name={item.icon}
                                        size ={35}      //{item.size}
                                        backgroundColor={item.backgroundColor}
                                      />
                                    }
                                    onPress={() =>{ 
                                      date = dateNow()
                                      newSeedDate = dateActions(date)
                                      typeActionSelect = menuArrangePhotosComponent35[index].typeActionsId
                                      console.log("typeActionSelect==> ", typeActionSelect)
                                      selectingArrangeImage(typeActionSelect)
                                    }}
                                  />
                                )}
                              />
                              <Text style={styles.ButtonCancel}
                              onPress={() =>{ 
                                setListChooseArrange(false)
                              }}>Regresar</Text>
                              </View>
                              :
                              null
                            }

          <View style={styles.viewContent6PhotoYText}  >
                <View style={styles.viewContent7TitleYSeedDescription}>
                  <TextInput style={styles.input36}
                      onChangeText = {text => setTitleBoxText(text)}
                      value = {titleBoxText}
                      multiline = {true}
                      /> 
                  <TextInput style={styles.inputDescription36}
                      onChangeText = {text => setDescriptionBoxText(text)}
                      value = {descriptionBoxText}
                      multiline = {true}
                      />
                </View>

            <TouchableOpacity onPress = {selectImage}
            style={styles.viewContent7Image} >
                              {imageUri != '' ? 
                                 String(imageUri).includes('.mp4') ?
                                   <Video 
                                      ref = {video}
                                      style = {styles.image7}
                                      source = {{ uri: imageUri }}
                                      useNativeControls
                                      resizeMode = "contain"
                                      isLooping
                                      onPlaybackStatusUpdate = {status => setStatus(() => status)}
                                   />
                                  :
                                  String(imageUri).includes('.mov') ?
                                  <Video 
                                      ref = {video}
                                      style = {styles.image7}
                                      source = {{ uri: imageUri }}
                                      useNativeControls
                                      resizeMode = "contain"
                                      isLooping
                                      onPlaybackStatusUpdate = {status => setStatus(() => status)}
                                  />
                                  : 
                                  imageUri === null ?    // http://18.116.234.21:5001/seedImages/
                                  <View style={styles.imageMountainSeed} >
                                              <Foundation 
                                                          name="mountains" 
                                                          size={182} 
                                                          color={colors.medium} />
                                  </View>
                                  :
                                  String(imageUri).includes('.jpg') ?
                                   
                                  <Image style={styles.image7} source={{uri: imageUri} } />
                                  : String(imageUri).includes('.png') ?
                                     
                                  <Image style={styles.image7} source={{uri: imageUri} } />
                                  :  
                                       
                                <Image style={styles.image7} source={{uri: imageUri} } />
                          :
                            
                            true ?  
                             String(seedPhoto).includes('.mp4') ?
                               <Video 
                                  ref = {video}
                                  style = {styles.image7}
                                  source = {{ uri: seedVideoUri + seedPhoto }}
                                  useNativeControls
                                  resizeMode = "contain"
                                  isLooping
                                  onPlaybackStatusUpdate = {status => setStatus(() => status)}
                               />
                              :
                              String(seedPhoto).includes('.mov') ?
                              <Video 
                                  ref = {video}
                                  style = {styles.image7}
                                  source = {{ uri: seedVideoUri + seedPhoto }}
                                  useNativeControls
                                  resizeMode = "contain"
                                  isLooping
                                  onPlaybackStatusUpdate = {status => setStatus(() => status)}
                              />
                              : 
                              seedPhoto === null ?    // http://18.116.234.21:5001/seedImages/
                              <View style={styles.imageMountainSeed} >
                                          <Foundation 
                                                      name="mountains" 
                                                      size={182} 
                                                      color={colors.medium} />
                              </View>
                              :
                              String(seedPhoto).includes('.png') ?
                              <ImageCache
                                  style={styles.image7}
                                  preview={{ uri: webUrl + seedPhoto }}
                                  tint="light"
                                  uri= { webUrl + seedPhoto }
                              /> 
                              :
                              <ImageCache
                                  style={styles.image7}
                                  preview={{ uri: webUrl + seedPhoto }}
                                  tint="light"
                                  uri= { webUrl + seedPhoto }
                                  //resizeMode= "cover"
                              />   
                              :  
                              // Este Image que viene no lo pude quitar porque sino me da un error :(
                             <ImageCache         
                             />      
                          } 
            </TouchableOpacity>
          </View>
          <View style={styles.ContainerButtonSaveForEdition}>
              <TouchableOpacity  style={styles.buttonSaveForEdition}
                                 onPress={ () => 
                                 updateInfo()
                                 } >
                  <Text style={styles.textEdit}>
                    Save
                  </Text>
              </TouchableOpacity>
          </View> 
     </View>
);


  // Add photo left text right  <===  L I S T O!!
  case 37:
  return (
  <View style={styles.viewContent6}>
          <Text style={styles.title} > Creada el:  { dateFormated } </Text>
          <Text style={styles.title} numberOfLines={1}> Type:  {type} </Text>

          {
                            typeActionSelect === 35 ?   <Text style={styles.titleSeed} 
                                                  onPress={() => {
                                                    listChooseArrange === false ?
                                                      setListChooseArrange(true)
                                                      :
                                                      setListChooseArrange(false)
                                                  }}
                                                    >Imagen al centro </Text>:
                            typeActionSelect === 36 ?   <Text style={styles.titleSeed} 
                                                onPress={() => {
                                                  listChooseArrange === false ?
                                                    setListChooseArrange(true)
                                                    :
                                                    setListChooseArrange(false)
                                                }}
                                           >Imagen a la derecha </Text>:                            
                            typeActionSelect === 37 ?   <Text style={styles.titleSeed} 
                                                onPress={() => {
                                                  listChooseArrange === false ?
                                                    setListChooseArrange(true)
                                                    :
                                                    setListChooseArrange(false)
                                                }}
                                           >Imagen a la izquierda </Text>:          
                                                    null
        }

{
                              listChooseArrange === true ?
                              <View style={styles.ViewflatlistTypeAction}>
                              <FlatList
                                data={menuArrangePhotosComponent35}
                                keyExtractor={(item) => item.typeActionsId.toString()}
                                //ItemSeparatorComponent={ListItemSeparator}
                                renderItem={({ item, index }) => (
                                  <CardListTypeActions
                                    title ={item.title}
                                    backgroundColor = {item.background}
                                    IconComponent={
                                      <Icon
                                        iconFamily={item.iconFamily}
                                        name={item.icon}
                                        size ={35}      //{item.size}
                                        backgroundColor={item.backgroundColor}
                                      />
                                    }
                                    onPress={() =>{ 
                                      date = dateNow()
                                      newSeedDate = dateActions(date)
                                      typeActionSelect = menuArrangePhotosComponent35[index].typeActionsId
                                      console.log("typeActionSelect==> ", typeActionSelect)
                                      selectingArrangeImage(typeActionSelect)
                                    }}
                                  />
                                )}
                              />
                              <Text style={styles.ButtonCancel}
                              onPress={() =>{ 
                                setListChooseArrange(false)
                              }}>Regresar</Text>
                              </View>
                              :
                              null
        }


          <View style={styles.viewContent6PhotoYText}  >
          <TouchableOpacity onPress = {selectImage}
            style={styles.viewContent37Image} >
                              {imageUri != '' ? 
                                 String(imageUri).includes('.mp4') ?
                                   <Video 
                                      ref = {video}
                                      style = {styles.image37}
                                      source = {{ uri: imageUri }}
                                      useNativeControls
                                      resizeMode = "contain"
                                      isLooping
                                      onPlaybackStatusUpdate = {status => setStatus(() => status)}
                                   />
                                  :
                                  String(imageUri).includes('.mov') ?
                                  <Video 
                                      ref = {video}
                                      style = {styles.image37}
                                      source = {{ uri: imageUri }}
                                      useNativeControls
                                      resizeMode = "contain"
                                      isLooping
                                      onPlaybackStatusUpdate = {status => setStatus(() => status)}
                                  />
                                  : 
                                  imageUri === null ?    // http://18.116.234.21:5001/seedImages/
                                  <View style={styles.imageMountainSeed} >
                                              <Foundation 
                                                          name="mountains" 
                                                          size={182} 
                                                          color={colors.medium} />
                                  </View>
                                  :
                                  String(imageUri).includes('.jpg') ?
                                   
                                  <Image style={styles.image37} source={{uri: imageUri} } />
                                  : String(imageUri).includes('.png') ?
                                     
                                  <Image style={styles.image37} source={{uri: imageUri} } />
                                  :  
                                       
                                <Image style={styles.image37} source={{uri: imageUri} } />
                          :
                            
                            true ?  
                             String(seedPhoto).includes('.mp4') ?
                               <Video 
                                  ref = {video}
                                  style = {styles.image37}
                                  source = {{ uri: seedVideoUri + seedPhoto }}
                                  useNativeControls
                                  resizeMode = "contain"
                                  isLooping
                                  onPlaybackStatusUpdate = {status => setStatus(() => status)}
                               />
                              :
                              String(seedPhoto).includes('.mov') ?
                              <Video 
                                  ref = {video}
                                  style = {styles.image37}
                                  source = {{ uri: seedVideoUri + seedPhoto }}
                                  useNativeControls
                                  resizeMode = "contain"
                                  isLooping
                                  onPlaybackStatusUpdate = {status => setStatus(() => status)}
                              />
                              : 
                              seedPhoto === null ?    // http://18.116.234.21:5001/seedImages/
                              <View style={styles.imageMountainSeed} >
                                          <Foundation 
                                                      name="mountains" 
                                                      size={182} 
                                                      color={colors.medium} />
                              </View>
                              :
                              String(seedPhoto).includes('.png') ?
                              <ImageCache
                                  style={styles.image37}
                                  preview={{ uri: webUrl + seedPhoto }}
                                  tint="light"
                                  uri= { webUrl + seedPhoto }
                              /> 
                              :
                              <ImageCache
                                  style={styles.image37}
                                  preview={{ uri: webUrl + seedPhoto }}
                                  tint="light"
                                  uri= { webUrl + seedPhoto }
                                  //resizeMode= "cover"
                              />   
                              :  
                              // Este Image que viene no lo pude quitar porque sino me da un error :(
                             <ImageCache         
                             />      
                          } 
            </TouchableOpacity>
                <View style={styles.viewContent37TitleYSeedDescription}>
                    <TextInput style={styles.input36}
                        onChangeText = {text => setTitleBoxText(text)}
                        value = {titleBoxText}
                        multiline = {true}
                        /> 
                    <TextInput style={styles.inputDescription36}
                        onChangeText = {text => setDescriptionBoxText(text)}
                        value = {descriptionBoxText}
                        multiline = {true}
                        />
                </View>
          </View>
          <View style={styles.ContainerButtonSaveForEdition}>
              <TouchableOpacity  style={styles.buttonSaveForEdition}
                                 onPress={ () => 
                                 updateInfo()
                                 } >
                  <Text style={styles.textEdit}>
                    Save
                  </Text>
              </TouchableOpacity>
          </View>
    </View>
);
 
  
  //  Add     Y O U T U B E  V I D E O     <===  L I S T O!!
  case 38:
    return (
       <View style={ keyboardVisible === false ? styles.viewContent4 :
        keyboardVisible === true ? styles.viewContent4Keyboard :
        styles.viewContent4
      }>

          <View style={styles.ContainerButtonSaveForEdition}>
              <TouchableOpacity  style={styles.buttonSaveForEdition}
                                 onPress={ () => 
                                 updateInfo()
                                 } >
                  <Text style={styles.textEdit}>
                    Save
                  </Text>
              </TouchableOpacity>
          </View>

          <Text style={styles.title} >  Creada el:  { dateFormated } </Text>   
          <Text style={styles.title} >  Type:  {type} </Text>
          {/* <Text style={styles.title} >  Pega el link de youtube aqui: </Text> */}

{
    videoNumberHook === '' ?
    <Text style={styles.instructionsYoutubeLink}
    > * Pega el link aqui abajo por favor ! </Text> 
    :
    youtubeIdSelector.length >= 12 ?
    <Text style={styles.instructionsYoutubeLink}
    >  Ahora da clic en la palomita varias veces por favor ! </Text> 
    :
    youtubeIdSelector.length <= 11 ?
    <Text style={styles.instructionsYoutubeLink}
    >  Listo !!  Video localizado.     Ahora solo llena el Título y Descripción y dale Save¡ Gracias.  </Text>  
    :
    null
}

          <View style={styles.containerYoutubeLink}>      
                    
                    <TextInput style={styles.inputYoutube} 
                    onChangeText={text => setVideoNumber(text)}
                    //value = {videoNumber}
                    value = {youtubeIdSelector}
                    placeholder={"Pega link de Youtube y da clic en listo"}
                    //onChange     = {Keyboard.dismiss}
                    >
                    </TextInput>
                          
                      { youtubeIdSelector.trim() === '' ?
                      <AntDesign
                      onPress = { () => onChangeText()}
                      name={"checkcircleo"}
                      size={40}
                      color={colors.medium}
                      style={styles.iconPlay}
                      >
                      </AntDesign>
                      :
                      youtubeIdSelector.length >= 12 ?
                      <AntDesign
                      onPress = { () => onChangeText()}
                      name={"checkcircleo"}
                      size={40}
                      color={colors.medium}
                      style={styles.iconPlay}
                      > 
                    
                      </AntDesign> 
                      : 
                      <AntDesign
                      onPress = { () => onChangeText()}
                      name={"checkcircle"}
                      size={40}
                      color={colors.fuente}
                      style={styles.iconPlay}
                      >
                      </AntDesign>
                      }

                  </View>

          {keyboardVisible === false ?
             <KeyboardAvoidingView 
                    keyboardVerticalOffset={1} 
                    behavior={Platform.OS == 'ios' ? 'floating' : 'height'}
                    style={styles.container}
             > 

                <View style={styles.detailsContainer}>
                    <TextInput style={styles.input}
                        onChangeText = {text => setTitleBoxText(text)}
                        value = {titleBoxText}
                        multiline = {true}
                        /> 
                    <TextInput style={styles.input}
                              onChangeText = {text => setDescriptionBoxText(text)}
                              value = {descriptionBoxText}
                              multiline = {true}
                              />
                </View>
            </KeyboardAvoidingView>
          : 
             <KeyboardAvoidingView 
                          keyboardVerticalOffset={1} 
                          behavior={Platform.OS == 'ios' ? 'padding' : 'height'}
                          style={styles.container}
                  > 
           <View style={styles.detailsContainerIos34}>
            <TextInput style={styles.input}
                onChangeText = {text => setTitleBoxText(text)}
                value = {titleBoxText}
                multiline = {true}
                //scrollEnabled = {true}
                />
            <TextInput style={styles.input}
                      onChangeText = {text => setDescriptionBoxText(text)}
                      value = {descriptionBoxText}
                      multiline = {true}
                      />
            </View>
           </KeyboardAvoidingView>
      }

          <View style={styles.youtubeVideo} >
              <VideoVisor videoNumber={youtubeIdSelector}/> 
          </View>  
    </View>
  );
  

 //  Add    R E Q U I R E M E N T 
  case 39:
    return (
      <>
        <View style={ styles.viewContent4  }>
          <View style={styles.ContainerButtonSaveForEdition}>
              <TouchableOpacity  style={styles.buttonSaveForEdition}
                                 onPress={ () => 
                                 updateInfo()
                                  } >
                  <Text style={styles.textEdit}>
                    Save
                  </Text>
              </TouchableOpacity>
          </View>
    <Text style={styles.title} > Creada el:  { dateFormated } </Text> 
    <Text style={styles.title} > Type { type } Seed Id { seedId } Origin { origin }</Text>


    {keyboardVisible === false ?
             <KeyboardAvoidingView 
                    keyboardVerticalOffset={1} 
                    behavior={Platform.OS == 'ios' ? 'floating' : 'height'}
                    style={styles.container}
             > 

        <View style={styles.detailsContainer}>
            <TextInput style={styles.input}
                onChangeText = {text => setTitleBoxText(text)}
                value = {titleBoxText}
                multiline = {true}
                /> 
            <TextInput style={styles.input}
                      onChangeText = {text => setDescriptionBoxText(text)}
                      value = {descriptionBoxText}
                      multiline = {true}
                      />
      </View>
      </KeyboardAvoidingView>
       : 
       <KeyboardAvoidingView 
                    keyboardVerticalOffset={1} 
                    behavior={Platform.OS == 'ios' ? 'padding' : 'height'}
                    style={styles.container}
             > 
        <View style={styles.detailsContainerIos34}>
            <TextInput style={styles.input}
                onChangeText = {text => setTitleBoxText(text)}
                value = {titleBoxText}
                multiline = {true}
                //scrollEnabled = {true}
                />
            <TextInput style={styles.input}
                      onChangeText = {text => setDescriptionBoxText(text)}
                      value = {descriptionBoxText}
                      multiline = {true}
                      />
         </View>
      </KeyboardAvoidingView>
      }

                           {/* <ScrollView style={ styles.flatlistCardRequirements39 }>
                              <FlatList
                                data={itemsRequirements}
                                keyExtractor={(item) => item.seedId.toString()}
                                //ItemSeparatorComponent={ListItemSeparator}
                                renderItem={({ item, index }) => (
                                  <CardEdit
                                    type = { "r" }
                                    title = {item.title}
                                    seedDescription = { item.seedDescription }
                                    seedId = { item.seedId }
                                    seedName = { item.seedName }
                                    seedPhoto = { item.seedPhoto }
                                    origin = { item.origin }
                                    qty = { item.qty }
                                    mesure = { item.mesure }
                                    unitaryPrice = { item.unitaryPrice }
                                    currency = { item.currency }
                                    sub = { item.sub }
                                    thumbnailUrl={ item.thumbnailUrl }
                                    imageUrl={
                                      seedPhoto.includes('.mp4') ?
                                      seedVideoUri + seedPhoto :
                                      seedPhoto.includes('.mov') ?
                                      seedVideoUri + seedPhoto :
                                      webUrl + seedPhoto}
                                    screen = {1}
                                    onPress={() =>{ 
                                      date = dateNow()
                                      newSeedDate = dateActions(date)
                                      typeActionSelect = menuArrangePhotosComponent35[index].typeActionsId
                                      console.log("typeActionSelect==> ", typeActionSelect)
                                      selectingArrangeImage(typeActionSelect)
                                    }}
                                  />
                                )}
                              />
                        </ScrollView> */}
              </View>
        
      </>
  );
 
//  Edit    R E Q U I R E M E N T 
  case 40:
  return (
    <>
<View>
<ScrollView>
<View style={styles.card}>
          <View style={styles.ContainerButtonSaveForEdition}>
              <TouchableOpacity  style={styles.buttonSaveForEdition}
                                 onPress={ () => { 
                                  updateInfo()
                                }
                                  } >
                  <Text style={styles.textEdit}>
                    Save
                  </Text>
              </TouchableOpacity>
          </View>

      <View style={{height: (keyboardVisible === false? 200: keyboardVisible === true? 10: null),
                     width: "100%", alignItems: "center", marginBottom: "4%",
                    }}>
            {/* <PieChart  //https://gifted-charts.web.app/piechart
                donut
                radius={85}
                innerRadius={60}
                data={pieData}
                centerLabelComponent={() => {
                      return <Text style={{fontSize: 25}}> {percentageSuccess.toLocaleString()}% </Text>;
                }}
            /> */}
            <MyPieChart/>
      </View>
        

    <View style={styles.viewContent6PhotoYTextCaseR}  >
        <View style={styles.viewContent6Image} > 
  
<TouchableOpacity  onPress = {selectImage}>
                  {imageUri != '' ? 
                                 
                                  imageUri === '' ?     
                                  <View style={styles.imageCaseR} >
                                              <Foundation 
                                                          name="mountains" 
                                                          size={120} 
                                                          color={colors.medium} />
                                  </View>
                                  :
                                  String(imageUri).includes('.jpg') ?
                                      <Image style={styles.imageCaseR} 
                                             source={{uri: imageUri} } 
                                             resizeMode= "stretch" // Con esto logré que la imagen se adecuara a un view más pequeño!!   //"center"
                                             />

                                  : String(imageUri).includes('.png') ?
                                      <Image style={styles.imageCaseR} 
                                             source={{uri: imageUri} } 
                                             resizeMode= "stretch" // Con esto haces que una imagen grande entre en un view pequeño ajua ajuuuaaaa!!   //"center"
                                             />
                                  :  
                                      <Image style={styles.imageCaseR} 
                                             source={{uri: imageUri} } 
                                             resizeMode= "stretch" //"center"
                                             />
                                  :
                            
                            true ?  
                          
                              seedPhoto === 'Poner Foto ' ?   
                              <View style={styles.imageCaseR} >
                                          <Foundation 
                                                      name="mountains" 
                                                      size={120} 
                                                      color={colors.medium} />
                              </View>
                              :
                              String(seedPhoto).includes('.png') ?
                              <ImageCache
                                  style={styles.imageCaseR}
                                  //preview={{ uri: webUrl + seedPhoto }}
                                  preview={{ uri: thumbnailUrl }}
                                  tint="light"
                                  //uri= { webUrl + seedPhoto }
                                  uri={imageUrl}
                              /> 
                              :
                              <ImageCache
                                  style={styles.imageCaseR}
                                  //preview={{ uri: webUrl + seedPhoto }}
                                  preview={{ uri: thumbnailUrl }}
                                  tint="light"
                                  //uri= { webUrl + seedPhoto }
                                  uri={imageUrl}
                                  //resizeMode= "cover"
                              />   
                              :  
                              // Este Image que viene no lo pude quitar porque sino me da un error :(
                             <ImageCache         
                             />      
                          } 
                  </TouchableOpacity>

            
        </View>
           <View style={styles.viewContent6TitleYSeedDescription}> 
           <Text style={styles.textQtyMesure}>  Concepto  </Text>
           <TextInput style={styles.textConceptNote}              // Text del box de seedName
             onChangeText = {text => setTitleBoxText(text)}
             value = {titleBoxText}
             multiline = {true}
            />
           <View style={styles.viewQtyMesure}>
                  <Text style={styles.textQtyMesure} > Cantidad </Text>
                  <Text style={styles.textQtyMesure} >          Unidad  </Text>
           </View>
           <View style={styles.viewQtyMesure}>
                  <TextInput style={styles.textBoxQty}              // Text del box de Qty
                    onChangeText = {text => setQtyBox(text)}
                    keyboardType='numeric'
                    value = {qtyBox}
                    multiline = {true}
                   />
                
                   <Text style={styles.textBoxMesure}  // Para seleccionar mesure.
                         onPress={() => {
                          showMesures === false ?
                            setShowMesures(true)
                            :
                            setShowMesures(false)
                        }}
                    >
                      {mesureBox}
                   </Text>
                  
                  {
                    ifShowPriceSub === "show" ?
                      <MaterialCommunityIcons
                      onPress = {()=> setIfShowPriceSub("dontShow")}
                      name={"chevron-up"}
                      size={25}
                      color={colors.medium}
                      />
                    :
                    null
                  }
                  {
                    ifShowPriceSub === "dontShow" ?
                      <MaterialCommunityIcons
                      onPress = {()=> setIfShowPriceSub("show")}
                      name={"chevron-down"}
                      size={25}
                      color={colors.medium}
                      />
                    :
                    null
                  }
           </View>

           {
                    showMesures === true ?
                    <View style={styles.ViewflatlistMesures}>
                    <FlatList
                      data={mesures}
                      keyExtractor={(item) => item.mesureId.toString()}
                      ItemSeparatorComponent={ListItemSeparator}
                      renderItem={({ item, index }) => (
                        <CardListMesures
                          title ={item.description}
                          onPress={() =>{ 
                            mesureSelect = mesures[index].description
                            setMesureBox(mesureSelect)
                            setShowMesures(false)
                            console.log("Mesure seleccionada ==> ", mesureBox)
                          }}
                        />
                      )}
                    />
                    <Text style={styles.Cancel}
                    onPress={() =>{ 
                      setShowMesures(false)
                    }}>Cancel</Text>
                    </View>
                    :
                    null
                  }

                { 
                  ifShowPriceSub === "dontShow" ?
                    null
                  :
                    <View >
                          <View style={styles.viewQtyMesure}>
                              <Text style={styles.textQtyMesure}> Precio U. </Text>
                              <Text style={styles.textQtyMesure}>    Subtotal </Text>
                          </View>
                          <View style={styles.viewQtyMesure}>
                              <TextInput style={styles.textBoxPrice}          // Text del box de Precio U.
                                 onChangeText = {text => setUnitPriceBox(text)}
                                 value = {unitPriceBox}
                                 multiline = {true}
                               />
                              <Text style={styles.textBoxSub}> {sub.toLocaleString()}         </Text>
                          </View>
                    </View>
                }

                          <View style={styles.viewQtyMesure}>
                              <Text style={styles.textQtyMesure}> Aportado </Text>
                              <Text style={styles.textQtyMesure}>          Faltan: </Text>
                          </View>
                          <View style={styles.viewQtyMesure}>
                              <Text style={styles.textBoxQty}> {totalSupports.toLocaleString()} </Text>
                              <Text style={styles.textBoxQty}> {requirementsToFulfill.toLocaleString()}          </Text>
                          </View>
            {/* <Text style={styles.textConceptNote} >Nota: {seedDescription} </Text> */}
            <TextInput style={styles.textConceptNote}              // Text del box de description
             onChangeText = {text => setDescriptionBoxText(text)}
             value = {descriptionBoxText}
             multiline = {true}
            />
            {
              keyboardVisible === true ? 
                <View style={{height: 150, width: "20%"}}>
                </View>
              :
                null
            }
          </View>
   </View>
</View>
</ScrollView>
</View>

</>
  );  

//  Edit    R E Q U I R E M E N T 
case "r":
  return (
    <>
<View>
<View style={styles.card}>
   
      <View style={{height: (keyboardVisible === false? 200: keyboardVisible === true? 1: null),
                     width: "100%", alignItems: "center", marginBottom: "4%",
                    }}>
            {/* <PieChart  //https://gifted-charts.web.app/piechart
                donut
                radius={85}
                innerRadius={60}
                data={pieData}
                centerLabelComponent={() => {
                      return <Text style={{fontSize: 25}}> {percentageSuccess.toLocaleString()}% </Text>;
                }}
            /> */}
            <MyPieChart/>
      </View>
          <TouchableOpacity  style={styles.buttonEdit}
                             onPress={editRequirement} // () => { 
                             //editRequirement()
                             // }} 
                            >
                        <Text style={styles.textEdit}>
                          Editar 
                        </Text>
          </TouchableOpacity>

    <View style={styles.viewContent6PhotoYTextCaseR}  >
        <View style={styles.viewContent6Image} > 
            {  
              imageUrl === 'http://18.116.234.21:5001/seedImages/' ?
              <View style={styles.imageMountain} >
                          <Foundation 
                                      name="mountains" 
                                      size={350} 
                                      color={colors.medium} />
              </View>
              :               
              <ImageCache
                onPress={onPress}
                style={styles.imageCaseR}
                tint="light"
                preview={{ uri: thumbnailUrl }}
                uri={imageUrl}
              />
            }
              
            
        </View>
           <View style={styles.viewContent6TitleYSeedDescription}> 
           <Text style={styles.textQtyMesure}>  Concepto  </Text>
          <Text style={styles.textConceptNoteText} >{seedName}  </Text>
           <View style={styles.viewQtyMesure}>
                  <Text style={styles.textQtyMesure} > Cantidad </Text>
                  <Text style={styles.textQtyMesure} >          Unidad  </Text>
           </View>
           <View style={styles.viewQtyMesure}>
                  <Text style={styles.textBoxQtyText}> {qty}    </Text>
                  <Text style={styles.textBoxMesureText}> {mesure} </Text>
                  {
                    ifShowPriceSub === "show" ?
                      <MaterialCommunityIcons
                      onPress = {()=> setIfShowPriceSub("dontShow")}
                      name={"chevron-up"}
                      size={25}
                      color={colors.medium}
                      />
                    :
                    null
                  }
                  {
                    ifShowPriceSub === "dontShow" ?
                      <MaterialCommunityIcons
                      onPress = {()=> setIfShowPriceSub("show")}
                      name={"chevron-down"}
                      size={25}
                      color={colors.medium}
                      />
                    :
                    null
                  }
           </View>

                { 
                  ifShowPriceSub === "dontShow" ?
                    null
                  :
                    <View >
                          <View style={styles.viewQtyMesure}>
                              <Text style={styles.textQtyMesure}> Precio U. </Text>
                              <Text style={styles.textQtyMesure}>    Subtotal </Text>
                          </View>
                          <View style={styles.viewQtyMesure}>
                              <Text style={styles.textBoxPriceText}> {unitaryPrice} </Text>
                              <Text style={styles.textBoxSubText}> {sub.toLocaleString()}         </Text>
                          </View>
                    </View>
                }

                          <View style={styles.viewQtyMesure}>
                              <Text style={styles.textQtyMesure}> Aportado </Text>
                              <Text style={styles.textQtyMesure}>          Faltan: </Text>
                          </View>
                          <View style={styles.viewQtyMesure}>
                              <Text style={styles.textBoxQtyText}> {totalSupports.toLocaleString()} </Text>
                              <Text style={styles.textBoxQtyText}> {requirementsToFulfill.toLocaleString()}          </Text>
                          </View>
            <Text style={styles.textConceptNoteText} >Nota: {seedDescription} </Text>

 {
                                  keyboardVisible === true ? 
                                    <View style={{height: 150, width: "20%"}}>
                                    </View>
                                  :
                                  null
                                  }
          </View>
   </View>
</View>
</View>
</>
  );  

// Edit S U P P O R T
case 41:
    return (
      <View style={styles.cardApoyo}>
          <View style={styles.ContainerButtonSaveForEdition}>
              <TouchableOpacity  style={styles.buttonSaveForEdition}
                                 onPress={ () => { 
                                  updateInfo()
                                }
                                  } >
                  <Text style={styles.textEdit}>
                    Save
                  </Text>
              </TouchableOpacity>
          </View>

 
        <Text style={{fontSize: 20, textAlign: "right", marginRight: "3%", marginBottom: "2%"}} >  {seedId}   {userName}   </Text> 
        <Text style={styles.textQtyMesure}>   Concepto  </Text>
        <Text style={styles.textConceptNoteBlocked} >{seedName}  </Text>

    <View style={styles.viewApoyo}  >
   
            <View style={styles.viewContent6TitleYSeedDescriptionApoyo}>
                  <View style={styles.viewBoxesApoyo}>
                      <Text style={styles.textQtyMesure}> Cantidad </Text>
                      <Text style={styles.textQtyMesure}>                    Unidad   </Text>
                  </View>
                  <View style={styles.viewBoxesApoyo}>
                    <TextInput style={styles.textBoxQty}              // Text del box de Qty
                      onChangeText = {text => setQtyBox(text)}
                      value = {qtyBox}
                      multiline = {true}
                    />
                   <Text style={styles.textBoxMesureSupport}  // Para seleccionar mesure.
                         onPress={() => {
                          showMesures === false ?
                            setShowMesures(true)
                            :
                            setShowMesures(false)
                        }}
                    >
                      {mesureBox}
                   </Text>
                  </View>
                  <View style={styles.viewBoxesApoyo}>
                      <Text style={styles.textQtyMesure}> Precio U. </Text>
                      <Text style={styles.textQtyMesure}>            Subtotal  </Text>
                  </View>
                  <View style={styles.viewBoxesApoyo}>
                  <TextInput style={styles.textBoxPrice}          // Text del box de Precio U.
                                 onChangeText = {text => setUnitPriceBox(text)}
                                 value = {unitPriceBox}
                                 multiline = {true}
                               />
                              <Text style={styles.textBoxSubSupport}> {sub.toLocaleString()}   </Text>
                  </View>
                  {/* <Text style={styles.textNoteSupport} >Nota: {seedDescription} </Text> */}
                  <TextInput style={styles.textNoteSupport}              // Text del box de description
                  onChangeText = {text => setDescriptionBoxText(text)}
                  value = {descriptionBoxText}
                  multiline = {true}
                  />
            </View>
          

{
                    showMesures === true ?
                    <View style={styles.ViewflatlistMesures}>
                    <FlatList
                      data={mesures}
                      keyExtractor={(item) => item.mesureId.toString()}
                      ItemSeparatorComponent={ListItemSeparator}
                      renderItem={({ item, index }) => (
                        <CardListMesures
                          title ={item.description}
                          onPress={() =>{ 
                            mesureSelect = mesures[index].description
                            setMesureBox(mesureSelect)
                            setShowMesures(false)
                            console.log("Mesure seleccionada ==> ", mesureBox)
                          }}
                        />
                      )}
                    />
                    <Text style={styles.Cancel}
                    onPress={() =>{ 
                      setShowMesures(false)
                    }}>Cancel</Text>
                    </View>
                    :
                    null
                  }

        <View style={styles.viewImageUser} > 
            {  
              imageUrl === 'http://18.116.234.21:5001/imagenes/PerfilDeUsuario' ?
              <View style={styles.imageUser} >
                          <Foundation 
                                      name="mountains" 
                                      size={100} 
                                      color={colors.medium} />
              </View>
              :   
              <TouchableOpacity
              onPress={() => {
                  var item = {userId, userPhoto, userName}
                  var foundUserChecker = "foundUserChecker"
                  {if(userId === userIdAuth){
                    navigation.navigate(routes.USER_FIXO)
                  }else{
                  navigation.navigate(routes.FOUND_USER, { item, foundUserChecker })
                  }}
                }}
              >
              <ImageCache
                style={styles.imageUser}
                tint="light"
                preview={{ uri: thumbnailUrl }}
                //uri={imageUrl}
                uri={profileUri + userId + '_' + userPhoto}
                
              />
              </TouchableOpacity>             
            }
        </View>
   </View>

   <TouchableOpacity  onPress = {selectImage}>
                  {imageUri != '' ? 
                                 
                                  imageUri === '' ?     
                                  <View style={styles.imageSupport} >
                                              <Foundation 
                                                          name="mountains" 
                                                          size={400} 
                                                          color={colors.medium} />
                                  </View>
                                  :
                                  String(imageUri).includes('.jpg') ?
                                      <Image style={styles.imageSupport} 
                                             source={{uri: imageUri} } 
                                             resizeMode= "stretch" // Con esto logré que la imagen se adecuara a un view más pequeño!!   //"center"
                                             />

                                  : String(imageUri).includes('.png') ?
                                      <Image style={styles.imageSupport} 
                                             source={{uri: imageUri} } 
                                             resizeMode= "stretch" // Con esto haces que una imagen grande entre en un view pequeño ajua ajuuuaaaa!!   //"center"
                                             />
                                  :  
                                      <Image style={styles.imageSupport} 
                                             source={{uri: imageUri} } 
                                             resizeMode= "stretch" //"center"
                                             />
                                  :
                            
                            true ?  
                          
                              seedPhoto === 'Poner Foto ' ?   
                              <View style={styles.imageSupport} >
                                          <Foundation 
                                                      name="mountains" 
                                                      size={400} 
                                                      color={colors.medium} />
                              </View>
                              :
                              String(seedPhoto).includes('.png') ?
                              <ImageCache
                                  style={styles.imageSupport}
                                  //preview={{ uri: webUrl + seedPhoto }}
                                  preview={{ uri: thumbnailUrl }}
                                  tint="light"
                                  //uri= { webUrl + seedPhoto }
                                  uri={imageUrl}
                              /> 
                              :
                              <ImageCache
                                  style={styles.imageSupport}
                                  //preview={{ uri: webUrl + seedPhoto }}
                                  preview={{ uri: thumbnailUrl }}
                                  tint="light"
                                  //uri= { webUrl + seedPhoto }
                                  uri={imageUrl}
                                  //resizeMode= "cover"
                              />   
                              :  
                              // Este Image que viene no lo pude quitar porque sino me da un error :(
                             <ImageCache         
                             />      
                          } 
                  </TouchableOpacity>

</View>
  );

case 7:
    return (
      <>
      <Text> Al fin llegue al 7</Text>
      <Text style={styles.title} >Type { type }</Text>
      <Text style={styles.title} >Seed Id { seedId }</Text>
      <Text style={styles.title} >Origin { origin }</Text>
            </>
  );
  
  break;
  
  default: 
  <Text> type: {type} </Text>
  {
    keyboardVisible === true ? 
      <View style={{height: 10, width: "20%", backgroundColor: "red"}}>
      </View>
    :
    null
    } 
  break; 

  }



}

const styles = StyleSheet.create({
  //  Css para case 41 S U P P O R T S 
  textConceptNoteBlocked: {      // Estilo para editar con textInput
    fontSize: 18,  
    color: colors.black,
    marginLeft: "3%",
    paddingLeft: "1%",
    marginBottom: "1.5%",
    width: "69%", 
    backgroundColor: "white"
  },
  imageSupport: {
    marginTop: "2%",
    marginLeft: "1%",
    marginBottom: "3%",
    height: 400,
    width:  400,        //"100%",
    backgroundColor: colors.chakra8tur,
  },
  textBoxMesureSupport:{    // Estilo para editar con textInput
    fontSize: 17,  
    color: colors.black,
    marginRight: "3%",
    marginBottom: "3%",
    paddingLeft: "3%",
    width: "45%",
    backgroundColor: "white",
    borderWidth: 1,
    //borderRadius: 15,
    },
  textBoxSubSupport:{        // Estilo para editar con textInput
    fontSize: 16,  
    color: "black", //colors.black,
    marginRight: "3%",
    marginBottom: "2%",
    paddingLeft: "1%",
    width: "61%",
    height: 26,
    backgroundColor: "white",
    textAlignVertical: "bottom",  
    },
  textNoteSupport: {
    fontSize: 18,  
    color: "black",
    marginLeft: "2%",
    paddingLeft: "3%",
    marginBottom: "1.5%",
    marginRight: "2%",
    backgroundColor: "white",
    borderRadius: 15,
    borderWidth: 1,
    width: "93%",
  },
  textBoxQtyMesure:{
    fontSize: 17,  
    color: "black",
    marginRight: "3%",
    marginBottom: "3%",
    paddingLeft: "1%",
    width: "55%",
    backgroundColor: "white",
    },
  cardApoyo: {
    borderRadius: 15,
    backgroundColor: colors.fuente, 
    marginBottom: "2%",
    marginTop: "2%",
    overflow: "hidden",
  },
  viewApoyo: {
    borderRadius: 15,
    backgroundColor: colors.fuente,
    flexDirection: "row",
  },
  viewContent6TitleYSeedDescriptionApoyo: {
    backgroundColor: colors.fuente,
    width: "76%",
    marginLeft: "1%",
  },
  viewBoxesApoyo: {
    flexDirection: "row",
    width: "85%",
    marginLeft: "2%",
    //backgroundColor: "gray",
  },
  viewImageUser: {
    //backgroundColor: "red", //colors.chakra2ama,
    justifyContent: 'space-evenly', // Esto hace que las imágenes se centren verticalmente no importando que tanto crezca el texto.
    marginLeft: "1%",
    backgroundColor: colors.fuente, // Le puse este color esperando se vuelva transparente '#00000000',
    width: "18%",
  },
  // Termina Css S U P P O R T S
  ViewflatlistMesures: {   // Esto es para el view de fondo del FlatList para menu unidades de medida de Case 40
    position: "absolute",
    zIndex: 1,
    width: "50%",
    marginLeft: "3%",
    //marginTop: "21%",
    backgroundColor: colors.chakra3ver,
  },
  imageUser: {
    width: 74,
    height: 74,
    borderRadius: 37,
    marginTop: "-2%",
    marginLeft: "1%",
    backgroundColor: colors.chakra9aur
},
  // Empieza css del case "r" para los requirements
  card: {
    //borderRadius: 15,
    backgroundColor: colors.light, 
    marginTop: "2%",
    overflow: "hidden",
    borderRadius: 15,
    width:600,
    height:1000
  },
  viewContent6PhotoYTextCaseR: {
    borderRadius: 15,
    backgroundColor: colors.light,
    flexDirection: "row",
  },
  viewContent6Image: {
    //backgroundColor: "red", //colors.chakra2ama,
    marginLeft: "1%",
    backgroundColor: '#00000000', // Le puse este color esperando se vuelva transparente '#00000000',
    width: "70%", 
    alignContent: "space-between",
  },
  imageCaseR: {
    marginTop: "2%",
    height: 120,
    width:  120,        //"100%",
    backgroundColor: colors.chakra8tur,
  },
  viewContent6TitleYSeedDescription: {
    backgroundColor: colors.chakra2ama,
    width: "130%",
    marginLeft: "-38%",
  },
  viewQtyMesure: {
    flexDirection: "row",
    width: "40%",
    marginLeft: "2%",
    //backgroundColor: "gray",
  },
  textQtyMesure: {
    fontSize: 18,  
    color: "black",
  },
  textConceptNote: {      // Estilo para editar con textInput
    fontSize: 16,  
    color: colors.black,
    marginLeft: "2%",
    paddingLeft: "1%",
    marginBottom: "1.5%",
    width: "48.5%", 
    backgroundColor: "white",
    borderWidth: 1,
    borderRadius: 15,
  },
  textConceptNoteText: {    // Estilo para mostrar
    fontSize: 18,  
    color: "black",
    marginLeft: "2%",
    paddingLeft: "1%",
    marginBottom: "1.5%",
    width: "48.5%", 
    backgroundColor: "white",
  },
  textBoxPrice:{
    fontSize: 16,  
    color: colors.black,
    marginRight: "3%",
    marginBottom: "3%",
    paddingLeft: "2%",
    width: "45%",
    backgroundColor: "white",
    borderWidth: 1,
    borderRadius: 15,
    },
  textBoxPriceText:{     // Estilo para mostrar
    fontSize: 17,  
    color: "black",
    marginRight: "3%",
    marginBottom: "3%",
    paddingLeft: "1%",
    width: "45%",
    backgroundColor: "white",
    },
   textBoxSub:{        // Estilo para editar con textInput
    fontSize: 16,  
    color: colors.black,
    marginRight: "3%",
    marginBottom: "3%",
    paddingLeft: "1%",
    width: "73%",
    backgroundColor: "white",  
    borderWidth: 1,
    //borderRadius: 15,
    },
  textBoxSubText:{
    fontSize: 17,  
    color: "black",
    marginRight: "3%",
    marginBottom: "3%",
    paddingLeft: "1%",
    width: "73%",
    backgroundColor: "white",
    },
    textBoxQty:{    // Estilo para editar con textInput
      fontSize: 16,  
      color: colors.black,
      marginRight: "3%",
      marginBottom: "3%",
      paddingLeft: "3%",
      width: "60%",
      backgroundColor: "white",
      borderWidth: 1,
      borderRadius: 15,
      },
  textBoxQtyText:{   // Estilo para mostrar
    fontSize: 17,  
    color: "black",
    marginRight: "3%",
    marginBottom: "3%",
    paddingLeft: "1%",
    width: "60%",
    backgroundColor: "white",
    },
    textBoxQtyText:{
        fontSize: 17,  
        color: "black",
        marginRight: "3%",
        marginBottom: "3%",
        paddingLeft: "1%",
        width: "60%",
        backgroundColor: "white",
        },
    textBoxMesure:{    // Estilo para editar con textInput
      fontSize: 16,  
      color: colors.black,
      marginRight: "3%",
      marginBottom: "3%",
      paddingLeft: "1%",
      width: "45%",
      backgroundColor: "white",
      borderWidth: 1,
      borderRadius: 15,
      },
  textBoxMesureText:{   // Estilo para mostrar
    fontSize: 17,  
    color: "black",
    marginRight: "3%",
    marginBottom: "3%",
    paddingLeft: "1%",
    width: "45%",
    backgroundColor: "white",
    },
  // Termina css del case "r" para los requirements

  flatlistCardRequirements39: {
    marginLeft: "2%",
    width: "96%",
    height: 550,
    backgroundColor: colors.fuente,
  },
  flatlistCardRequirements39ios: {
    marginLeft: "2%",
    marginTop: "-38%",
    width: "96%",
    height: 550,
    backgroundColor: colors.fuente,
  },
  youtubeVideo: {
    width: "100%",
    marginTop: "2%",
    height: 250,
   // backgroundColor: colors.pistache,
    },
  ViewflatlistTypeAction: {   // Esto es para el view de fondo del FlatList para elegir acomodo de imagen en componentes 35, 36 y 37
    position: "absolute",
    zIndex: 1,
    width: "83%",
    height: "9.6%",
    marginLeft: "1%",
    marginTop: "30.5%",
    marginBottom: "30%",
    marginLeft: "2%",
    backgroundColor: colors.chakra1nar,
  },
  ButtonCancel: {
    backgroundColor: colors.lemonGreen,
    color: "white",
    fontSize: 20,
    alignSelf: "center",
    textAlign: "center",
    padding: "2%",
    //borderRadius: 50,
    width: "100%",
    marginTop: ".65%",
    //marginLeft: "-1.5%",
  },
  image5: {
    width: 400, // "100%", cambie a 400 pixeles para meter el stretch 
    height: 400,
    //marginLeft: "0.5%",
    marginTop: "2%",
    //marginBottom: "2%",
    //backgroundColor: "green",
  },
  image7: {
    width: "63%", // A mayo porcentaje en el marginLeft se requiere disminuir el width para que la foto se haga cuadrada en vez de rectangular.
    height: 200,
    //marginLeft: "63.5%", // Cada que aumentaba el marginLeft me hacía la foto más rectangular, tuve que disminuir el width.
    alignContent: "space-around",
  },
  image37: {
    width: "63%", // A mayo porcentaje en el marginLeft se requiere disminuir el width para que la foto se haga cuadrada en vez de rectangular.
    height: 200,
    //marginLeft: "63.5%", // Cada que aumentaba el marginLeft me hacía la foto más rectangular, tuve que disminuir el width.
    alignContent: "space-around",
  },
  iconDocsContent: {
    marginTop: "1%",
    marginBottom: "2%",
    //marginLeft: "4%",
    alignItems: "center",
    width: "100%",
  },
  viewContent5: {
    backgroundColor: colors.chakra2ama,
    marginTop: "2%",
    overflow: "hidden",
  },
  viewContent6: {
    //borderRadius: 15,
    backgroundColor: colors.chakra2ama,
    //marginBottom: 15,
    overflow: "hidden",
  },
  viewContent7TitleYSeedDescription: {
    backgroundColor: colors.chakra2ama,
    width: "15%",
    marginLeft: "2%",
  },
  viewContent37TitleYSeedDescription: {
    backgroundColor: colors.chakra2ama,
    width: "15%",
    marginLeft: "-22%",
  },
  viewContent6PhotoYText: {
    //borderRadius: 15,
    backgroundColor: colors.chakra2ama,
    //marginBottom: 15,
    //overflow: "hidden",
    flexDirection: "row",
  },
  viewContent7Image: {
    justifyContent: 'center',
    alignSelf: 'center',
    //backgroundColor: 'red',
    width: "66%", // A mayo porcentaje en el marginLeft se requiere disminuir el width para que la foto se haga cuadrada en vez de rectangular.
    height: 230,
    marginLeft: "40%", // Cada que aumentaba el marginLeft me hacía la foto más rectangular, tuve que disminuir el width.
  },
  viewContent37Image: {
    justifyContent: 'center',
    alignSelf: 'center',
    //backgroundColor: 'red',
    width: "66%", // A mayo porcentaje en el marginLeft se requiere disminuir el width para que la foto se haga cuadrada en vez de rectangular.
    height: 230,
    marginLeft: "2%", // Cada que aumentaba el marginLeft me hacía la foto más rectangular, tuve que disminuir el width.
  },
  imageViewViewer: {
    //marginTop: "1%",
    //marginLeft: "2%",
    overflow: "hidden",
    width: "100%",
    height: 300,
    backgroundColor: "blue",
  },
  imageMountain: {
    width: "10%",
    height: 350,
  },
  Cancel: {
    color: colors.dark,
    textAlign: "center",
    fontSize: 20,
    marginTop: "2%",
    marginBottom: "-3%",
    width: "100%",
    fontWeight: "300",
    paddingBottom: "4%",
  },
  ViewflatlistTypeAction1: {   // Esto es para el view de fondo del FlatList para elegir tipo de acción
    position: "absolute",
    zIndex: 1,
    width: "90.5%",
    marginLeft: "3%",
    marginTop: "21%",
    backgroundColor: colors.chakra1nar,
  },
  ViewflatlistTypeAction2: {   // Esto es para el view de fondo del FlatList para elegir tipo de acción
    position: "absolute",
    zIndex: 1,
    width: "90.5%",
    marginLeft: "3%",
    marginTop: "21%",
    backgroundColor: colors.chakra2ama,
  },
  ViewflatlistTypeAction3: {   // Esto es para el view de fondo del FlatList para elegir tipo de acción
    position: "absolute",
    zIndex: 1,
    width: "90.5%",
    marginLeft: "3%",
    marginTop: "21%",
    backgroundColor: colors.chakra3ver,
  },
  ViewflatlistTypeAction4: {   // Esto es para el view de fondo del FlatList para elegir tipo de acción
    position: "absolute",
    zIndex: 1,
    width: "90.5%",
    marginLeft: "3%",
    marginTop: "21%",
    backgroundColor: colors.chakra4azu,
  },
  ViewflatlistTypeAction5: {   // Esto es para el view de fondo del FlatList para elegir tipo de acción
    position: "absolute",
    zIndex: 1,
    width: "90.5%",
    marginLeft: "3%",
    marginTop: "21%",
    backgroundColor: colors.chakra5vlt,
  },
  ViewflatlistTypeAction6: {   // Esto es para el view de fondo del FlatList para elegir tipo de acción
    position: "absolute",
    zIndex: 1,
    width: "90.5%",
    marginLeft: "3%",
    marginTop: "21%",
    backgroundColor: colors.chakra6rsa,
  },
  ViewflatlistTypeAction7: {   // Esto es para el view de fondo del FlatList para elegir tipo de acción
    position: "absolute",
    zIndex: 1,
    width: "90.5%",
    marginLeft: "3%",
    marginTop: "21%",
    backgroundColor: colors.chakra7ryo,
  },
  ViewflatlistTypeAction8: {   // Esto es para el view de fondo del FlatList para elegir tipo de acción
    position: "absolute",
    zIndex: 1,
    width: "90.5%",
    marginLeft: "3%",
    marginTop: "21%",
    backgroundColor: colors.chakra8tur,
  },
  ViewflatlistTypeAction9: {   // Esto es para el view de fondo del FlatList para elegir tipo de acción
    position: "absolute",
    zIndex: 1,
    width: "90.5%",
    marginLeft: "3%",
    marginTop: "21%",
    backgroundColor: colors.chakra9aur,
  },
  prueba: {
    backgroundColor: colors.pistache,
    height: 600,
    width: "100%",
  },
    containerYoutubeLink: {
      width: "100%",
      marginTop: "2%",
      marginLeft: "2%",
      marginBottom: "2%",
      flexDirection:"row",
      backgroundColor: '#00000000', // Le puse este color esperando se vuelva transparente '#00000000',
    },
    instructionsYoutubeLink: {
      color: colors.lemonGreen,
      textAlign: "center",
      fontSize: 19,
      marginTop: "1%",
      marginLeft: "6%",
      marginBottom: "1%",
      width: "70%",
      fontWeight: "500",
    },
    containerTitleDescription:{
      marginTop:"5%",
      width:"100%",
  },  
    input: {              // Input de la descripción
      width: "100%",
      fontSize: 19,
      color: colors.black,
      borderWidth: 1,
      borderRadius: 15,
      marginTop: "2%",
      padding: "3%", 
    },
    input36:{
      width: "350%",
      fontSize: 17,  
      color: colors.black,
      borderWidth: 1,
      borderRadius: 15,
      marginTop: "10%", 
      textAlign: "justify",
      padding: "5%", 
      },
      inputDescription36: {
        width: "350%",
        fontSize: 17,  
        color: colors.black,
        borderWidth: 1,
        borderRadius: 15,
        marginBottom: 7,
        marginTop: "10%",
        width: "350%",
        textAlign: "justify",
        padding: "5%", 
      },
    inputName: {
      width: "93%",
      fontSize: 19,
      color: colors.black,
      borderWidth: 1,
      marginTop: "2%",
      marginLeft: "2%",
      marginBottom: "4%",
      padding: "2%",
      borderRadius: 15 
    },
    inputYoutube: {
      width: "80%",
      fontSize: 18,
      color: colors.black,
      borderWidth: 1,
      textAlign: "center",
      marginTop: "-1.5%",
      marginLeft: ".3%",
      marginRight: "2%",
      padding: "2%",
      borderRadius: 25, 
      //backgroundColor: "red",
    },
    imagePhoto: {
      width: 200,
      height: 200,
      alignSelf: "center",
      marginBottom: "10%",
      borderRadius: 5,
      marginTop: "5%",
    },
    icon:{
      alignSelf:"center",
      marginTop: "7%",
      width:"100%",
  },
  iconPlay:{
    width: "30%",
    alignSelf:"center",
    alignContent: "center",
    marginTop: "-1.5%",
    marginLeft: "1%",
    marginRight: "85%",
  },
  iconYoutube:{
   // zIndex: 2,
    justifyContent: 'center', // Esto hace que las imágenes se centren verticalmente no importando que tanto crezca el texto.
    alignSelf:"center",
    padding: "1%",
    backgroundColor: colors.light,
    marginRight: "5%",
    marginLeft: "-1.5%",
    marginTop: "2%",
  },
  //----------------------------------------------------
    detailsContainer: {     //Contenedor de primera línea botones
      marginLeft: "3%",
      padding: "2%",
      flexDirection: "row",
      width: "92%",
      height: "25%",
      //backgroundColor: "red",
    },
    generals: {
      marginTop: "2%",
      marginLeft: "4%",
      width: "92%",
      //height: "25%", 
    },
    image: {
      marginTop: "1%",
      marginLeft: "2%",
      alignSelf: "center",
      width: 182,
      height: 182,
    },
    treeFollowersIconsContainer: {
      marginTop: "1%",
      marginLeft: "5%",
      //flexDirection: "row",
      alignItems: "center",
      alignContent: "center",
      //height: "20%",
      backgroundColor: colors.pistache,
    },
    tree:{
      marginLeft: "10%",
      color: colors.dark,
      marginTop: "2%",
     },
     textFollowers: {
      color: colors.medium,
      fontWeight: "900",
      marginTop: "2%",
      marginLeft: "6%",
     },
    
    video: {
      width: "90%",
      height: "20%",
      marginTop: "2%",
      marginLeft: "5%",
      backgroundColor: colors.pistache,
    },
      
    title: {
      color: colors.dark,
      textAlign: "justify",
      fontSize: 18,
      marginTop: "2%",
      width: "90%",
      fontWeight: "500",
      textAlign: "justify",
    },
    buttonsContainersContainer: {
      width: "100%",
      height: "50%",
      marginVertical: 10,
    },
    
    buttonsContainer1: {
      paddingLeft: "12%",
      flexDirection: "row",
      width: "100%",
      height: 50,
      marginVertical: 10,
      alignItems: "center",
      alignContent: "center",
    },
    buttonsContainer2: {
      padding: 7,
      flexDirection: "row",
      width: "100%",
      height: 50,
      marginVertical: 10,
      alignItems: "center",
    },
    buttonsContainer3: {
      paddingLeft: "12%",
      padding: 7,
      flexDirection: "row",
      width: "100%",
      height: 50,
      marginVertical: 10,
      alignItems: "center",
    },
    bottomMenu: {
      //paddingLeft: "12%",
      //padding: 7,
      flexDirection: "row",
      alignSelf: "flex-end",
      width: "100%",
      height: "10%",
      backgroundColor: colors.fuente,
    },
        
  
      // ********************* Inicia css de la semilla o accion original. **************************
      detailsContainerSeed: {     //Contenedor de primera línea botones
        flexDirection: "row",
        width: "100%",
        overflow: "hidden",
      },
      imageSeed: {
        marginTop: "3%",
        marginBottom: "1%",
        marginLeft: "2.2%",
        width: 270,
        height: 270,
      },
      imageVideoSeed: {
        width: 270,
        height: 270,
        alignSelf: "center",
        alignItems: "center",
      },
      treeFollowersIconsContainer: {
        marginTop: "1.8%",
        marginBottom: "0.5%",
        marginLeft: "1%",
         alignItems: "center",
        backgroundColor: colors.pistache,
      },
      treeSeed:{
        marginLeft: "10%",
        color:  "green",
        marginTop: "25%",
       },
       textFollowers: {
        color: colors.green,
        fontWeight: "900",
        marginTop: "2%",
        marginLeft: "6%",
       },
       numbersActionsFollowers: {
        color: colors.dark,
        marginTop: "4%",
       },
       numbersFollowers: {
        color: colors.dark,
        marginTop: "-2%",
        marginBottom: "2%",
       },
      viewDescription: {         // View de la descripción de la semilla 
        marginTop: "-0.2%",
        marginLeft: "1.5%",
        width: "95%",
        marginBottom: "5%",
      }, 
      description: {
        color: colors.greyDescription,
        fontSize: 17,
        marginRight: "2%",
        marginLeft: "2%",
        marginTop: "1%",
        textAlign: "justify",
        backgroundColor: "yellow",
      },
      seedTitle:{
        marginTop: 1,
        width: "100%", 
        backgroundColor: colors.chakra0red,
        zIndex: 1  
      },
      seedTitle1:{
        marginTop: "1%",
        width: "100%", 
        backgroundColor: colors.chakra1nar,
        zIndex: 1
      },
      seedTitle2:{
        marginTop: "1%",
        width: "100%", 
        backgroundColor: colors.chakra2ama,
        zIndex: 1
      },
      seedTitle3:{
        marginTop: "1%",
        width: "100%", 
        backgroundColor: colors.chakra3ver,
        zIndex: 1
      },
      seedTitle4:{
        marginTop: "1%",
        width: "100%", 
        backgroundColor: colors.chakra4azu,
        zIndex: 1
      },
      seedTitle5:{
        marginTop: "1%",
        width: "100%", 
        backgroundColor: colors.chakra5vlt,
        zIndex: 1
      },
      seedTitle6:{
        marginTop: "1%",
        width: "100%", 
        backgroundColor: colors.chakra6rsa,
        zIndex: 1
      },
      seedTitle7:{
        marginTop: "1%",
        width: "100%", 
        backgroundColor: colors.chakra7ryo,
        zIndex: 1
      },
      seedTitle8:{
        marginTop: "1%",
        width: "100%", 
        backgroundColor: colors.chakra8tur,
        zIndex: 1
      },
      seedTitle9:{
        marginTop: "1%",
        width: "100%", 
        backgroundColor: colors.chakra9aur,
        zIndex: 1
      },
      titleSeedDate: {
        width: "95%",
        fontSize: 19,
        color: colors.black,
        marginTop: "3%",
        marginLeft: "2%",
      },
      titleSeedSeed: {
        width: "80%",
        fontSize: 19,
        color: colors.black,
        marginTop: "1%",
        marginLeft: "2%",
        padding: "1%", 
      },
      titleSeed: {        // Estilo del Input del type.
        width: "93%",
        fontSize: 20,
        fontWeight: "500",
        color: colors.black,
        borderWidth: 1,
        marginTop: "2%",
        marginLeft: "2%",
        padding: "1.5%", 
        borderRadius: 15,
      },
      ContainerButtonEdit: {
        marginTop: "9%",
        height: 35,  // Esta madre la tenía en porcentaje y me estaba generando un fantasma en blanco¡¡ Recuerda no usar ningún heght en porcentaje¡¡¡¡ no mameeees 6 horas perdidas me carga la chi....
        width: "75%",
      },
      buttonEdit: {
        marginLeft: "2%",
        backgroundColor: colors.primary,
        borderRadius: 15,
        justifyContent: "center",
        alignItems: "center",
        padding: 4,
        marginRight: "5%",
      },
      ContainerButtonSaveForEdition: {
        marginTop: "0%",
        marginBottom: "3%",
        height: 35,  // Esta madre la tenía en porcentaje y me estaba generando un fantasma en blanco¡¡ Recuerda no usar ningún heght en porcentaje¡¡¡¡ no mameeees 6 horas perdidas me carga la chi....
        width: "100%",
        alignItems: "center",
      },
      buttonSaveForEdition: {
        marginLeft: "7%",
        marginRight: "7%",
        backgroundColor: colors.primary,
        borderRadius: 15,
        justifyContent: "center",
        alignItems: "center",
        padding: 7,
        width: "33%",
      },
      textEdit: {
        color: colors.white,
        fontSize: 18,
      },
      imageMountainSeed: {
        alignItems: "center",
        backgroundColor: "green",
      },
    // **** Aqui termina todo el css de la semilla
   
  // **** CSS para cerebro y comments ****
  detailsContainer: {
    padding: 5,
    //backgroundColor: "green",
  },
 seedDescription: {
  width: "95%",
  textAlign: "justify",
  fontSize: 18,
  color: colors.black,
  marginLeft: "2%",
  marginBottom: 7,
  marginTop: "1.5%",
  //backgroundColor: "green",
},
likeAndCommentContainer5: {
  flexDirection: "row",
  width: "90%",
  height: 30,
  //marginLeft: "10%",
  marginTop: "1%",
  alignItems: "center",
  //backgroundColor: "green",
},
likeAndCommentContainer5Icons: {
  marginLeft: "20%",
  //backgroundColor: "green",
},
likeAndCommentContainer5Nums: {
  marginLeft: "10%",
  color: colors.medium,
},


// ***********   Aqui empieza CSS de los componentes 33 en adelante...  ***************
viewContent4: {
  backgroundColor: colors.white,
  overflow: "hidden",
  marginTop: "2%",
},
viewContent4Keyboard: {
  backgroundColor: colors.white,
  overflow: "hidden",
  marginTop: "2%",
  marginBottom: "38%",
},
SelectComponentList:  {
  width: "100%",
  height: "0.1%",
  marginTop: "0.01%",
  alignItems: "flex-end",
  backgroundColor: colors.fuente,
  zIndex: 1,    
},
detailsContainer: {
  padding: 5,
},
detailsContainerIos34: {
  padding: 5,
  //marginBottom: "50%",
  textAlignVertical: "bottom",
  //position: "absolute",
  //zIndex: 1,
},

ViewBotonesInsertUpDown: {
  flexDirection: "row",
  width: "100%",
}
  });
  

export default CardEdit;

